import { emptyApi as api } from "./emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    clientAuthDeprecatedControllerLogin: build.mutation<
      ClientAuthDeprecatedControllerLoginApiResponse,
      ClientAuthDeprecatedControllerLoginApiArg
    >({
      query: () => ({ url: `/api/client/v1/auth/login`, method: "POST" }),
    }),
    clientTelegramAuthControllerLogin: build.mutation<
      ClientTelegramAuthControllerLoginApiResponse,
      ClientTelegramAuthControllerLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/telegram/auth/login`,
        method: "POST",
        body: queryArg.clientTelegramLoginDto,
      }),
    }),
    clientTelegramAuthControllerWhoami: build.query<
      ClientTelegramAuthControllerWhoamiApiResponse,
      ClientTelegramAuthControllerWhoamiApiArg
    >({
      query: () => ({ url: `/api/client/v1/telegram/auth/whoami` }),
    }),
    clientMaxAuthControllerLogin: build.mutation<
      ClientMaxAuthControllerLoginApiResponse,
      ClientMaxAuthControllerLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/max/auth/login`,
        method: "POST",
        body: queryArg.clientMaxLoginDto,
      }),
    }),
    clientMaxAuthControllerWhoami: build.query<
      ClientMaxAuthControllerWhoamiApiResponse,
      ClientMaxAuthControllerWhoamiApiArg
    >({
      query: () => ({ url: `/api/client/v1/max/auth/whoami` }),
    }),
    clientTokenAuthControllerRefresh: build.mutation<
      ClientTokenAuthControllerRefreshApiResponse,
      ClientTokenAuthControllerRefreshApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/auth/refresh`,
        method: "POST",
        body: queryArg.refreshTokenDto,
      }),
    }),
    clientTokenAuthControllerLogout: build.mutation<
      ClientTokenAuthControllerLogoutApiResponse,
      ClientTokenAuthControllerLogoutApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/auth/logout`,
        method: "POST",
        body: queryArg.refreshTokenDto,
      }),
    }),
    clientOAuthControllerStart: build.mutation<
      ClientOAuthControllerStartApiResponse,
      ClientOAuthControllerStartApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/oauth/${queryArg.provider}/start`,
        method: "POST",
        body: queryArg.clientOAuthStartDto,
      }),
    }),
    clientOAuthControllerCallback: build.mutation<
      ClientOAuthControllerCallbackApiResponse,
      ClientOAuthControllerCallbackApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/oauth/${queryArg.provider}/callback`,
        method: "POST",
        body: queryArg.clientOAuthCallbackDto,
      }),
    }),
    clientMagicAuthControllerRequest: build.mutation<
      ClientMagicAuthControllerRequestApiResponse,
      ClientMagicAuthControllerRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/auth/magic-link/request`,
        method: "POST",
        body: queryArg.magicAuthRequestDto,
      }),
    }),
    clientMagicAuthControllerVerify: build.mutation<
      ClientMagicAuthControllerVerifyApiResponse,
      ClientMagicAuthControllerVerifyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/auth/magic-link/verify`,
        method: "POST",
        body: queryArg.clientMagicAuthVerifyDto,
      }),
    }),
    clientUserControllerUpdate: build.mutation<
      ClientUserControllerUpdateApiResponse,
      ClientUserControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/user/update`,
        method: "POST",
        body: queryArg.clientUpdateUserDto,
      }),
    }),
    clientAdvertisingBannerControllerGetActiveBanners: build.query<
      ClientAdvertisingBannerControllerGetActiveBannersApiResponse,
      ClientAdvertisingBannerControllerGetActiveBannersApiArg
    >({
      query: () => ({ url: `/api/client/v1/advertising/banners` }),
    }),
    clientChainControllerGetChainInformation: build.query<
      ClientChainControllerGetChainInformationApiResponse,
      ClientChainControllerGetChainInformationApiArg
    >({
      query: () => ({ url: `/api/client/v1/chain/information` }),
    }),
    clientEventsControllerRecord: build.mutation<
      ClientEventsControllerRecordApiResponse,
      ClientEventsControllerRecordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/events`,
        method: "POST",
        body: queryArg.recordEventsRequestDto,
      }),
    }),
    clientDeliveryControllerGetOptimalDeliveryZone: build.mutation<
      ClientDeliveryControllerGetOptimalDeliveryZoneApiResponse,
      ClientDeliveryControllerGetOptimalDeliveryZoneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/delivery/optimal-zone`,
        method: "POST",
        body: queryArg.getOptimalDeliveryZoneDto,
      }),
    }),
    clientLocationControllerGetAllLocations: build.query<
      ClientLocationControllerGetAllLocationsApiResponse,
      ClientLocationControllerGetAllLocationsApiArg
    >({
      query: () => ({ url: `/api/client/v1/locations` }),
    }),
    clientLocationControllerGetLocation: build.query<
      ClientLocationControllerGetLocationApiResponse,
      ClientLocationControllerGetLocationApiArg
    >({
      query: (queryArg) => ({ url: `/api/client/v1/locations/${queryArg.id}` }),
    }),
    clientLocationControllerGetSchedule: build.mutation<
      ClientLocationControllerGetScheduleApiResponse,
      ClientLocationControllerGetScheduleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/locations/${queryArg.id}/schedule`,
        method: "POST",
        body: queryArg.getLocationScheduleDto,
      }),
    }),
    clientLocationControllerFindClosestLocation: build.mutation<
      ClientLocationControllerFindClosestLocationApiResponse,
      ClientLocationControllerFindClosestLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/locations/closest`,
        method: "POST",
        body: queryArg.findClosestLocationDto,
      }),
    }),
    clientOrderPointControllerFindOrderPoints: build.mutation<
      ClientOrderPointControllerFindOrderPointsApiResponse,
      ClientOrderPointControllerFindOrderPointsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/order-points/find`,
        method: "POST",
        body: queryArg.findOrderPointsDto,
      }),
    }),
    clientOrderPointControllerCalculateDeliveryPrice: build.mutation<
      ClientOrderPointControllerCalculateDeliveryPriceApiResponse,
      ClientOrderPointControllerCalculateDeliveryPriceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/order-points/${queryArg.orderPointId}/delivery-price`,
        method: "POST",
        body: queryArg.clientCalculateOrderPointDeliveryPriceDto,
      }),
    }),
    clientMenuItemCategoriesControllerGetAllMenuCategories: build.query<
      ClientMenuItemCategoriesControllerGetAllMenuCategoriesApiResponse,
      ClientMenuItemCategoriesControllerGetAllMenuCategoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/menu-categories`,
        params: {
          locationId: queryArg.locationId,
        },
      }),
    }),
    clientMenuItemsControllerGetAllMenuItems: build.query<
      ClientMenuItemsControllerGetAllMenuItemsApiResponse,
      ClientMenuItemsControllerGetAllMenuItemsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/menu-items`,
        params: {
          locationId: queryArg.locationId,
        },
      }),
    }),
    clientMenuItemsControllerGetMenuItemById: build.query<
      ClientMenuItemsControllerGetMenuItemByIdApiResponse,
      ClientMenuItemsControllerGetMenuItemByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/menu-items/${queryArg.id}`,
        params: {
          locationId: queryArg.locationId,
        },
      }),
    }),
    clientMenuItemsControllerGetAllRecommendations: build.query<
      ClientMenuItemsControllerGetAllRecommendationsApiResponse,
      ClientMenuItemsControllerGetAllRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/menu-items/filter/recommendations`,
        params: {
          locationId: queryArg.locationId,
        },
      }),
    }),
    clientOrderControllerGetOrders: build.query<
      ClientOrderControllerGetOrdersApiResponse,
      ClientOrderControllerGetOrdersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/orders`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    clientOrderControllerGetOrderById: build.query<
      ClientOrderControllerGetOrderByIdApiResponse,
      ClientOrderControllerGetOrderByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/client/v1/orders/${queryArg.id}` }),
    }),
    clientOrderControllerCreateTakeoutOrder: build.mutation<
      ClientOrderControllerCreateTakeoutOrderApiResponse,
      ClientOrderControllerCreateTakeoutOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/orders/takeout`,
        method: "POST",
        body: queryArg.createTakeoutOrderDto,
      }),
    }),
    clientOrderControllerCreateCitywideDelivery: build.mutation<
      ClientOrderControllerCreateCitywideDeliveryApiResponse,
      ClientOrderControllerCreateCitywideDeliveryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/orders/delivery`,
        method: "POST",
        body: queryArg.createDeliveryOrderCitywideDto,
      }),
    }),
    clientOrderControllerCreateNationwideDelivery: build.mutation<
      ClientOrderControllerCreateNationwideDeliveryApiResponse,
      ClientOrderControllerCreateNationwideDeliveryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/orders/delivery/nationwide`,
        method: "POST",
        body: queryArg.createDeliveryOrderNationwideDto,
      }),
    }),
    clientOrderControllerCreateOrderFromOrderPoint: build.mutation<
      ClientOrderControllerCreateOrderFromOrderPointApiResponse,
      ClientOrderControllerCreateOrderFromOrderPointApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/orders/order-point`,
        method: "POST",
        body: queryArg.createOrderFromOrderPoint,
      }),
    }),
    clientOrderControllerGetBonusInfoForOrderCreation: build.mutation<
      ClientOrderControllerGetBonusInfoForOrderCreationApiResponse,
      ClientOrderControllerGetBonusInfoForOrderCreationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/orders/bonuses`,
        method: "POST",
        body: queryArg.getBonusInfoForOrderCreation,
      }),
    }),
    clientLegalControllerGetGeneratedDocuments: build.query<
      ClientLegalControllerGetGeneratedDocumentsApiResponse,
      ClientLegalControllerGetGeneratedDocumentsApiArg
    >({
      query: () => ({ url: `/api/client/v1/legal/documents` }),
    }),
    clientLegalControllerAcceptDocuments: build.mutation<
      ClientLegalControllerAcceptDocumentsApiResponse,
      ClientLegalControllerAcceptDocumentsApiArg
    >({
      query: () => ({
        url: `/api/client/v1/legal/documents/accept`,
        method: "POST",
      }),
    }),
    clientReservationControllerGetReservations: build.query<
      ClientReservationControllerGetReservationsApiResponse,
      ClientReservationControllerGetReservationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/reservations`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    clientReservationControllerCreateReservation: build.mutation<
      ClientReservationControllerCreateReservationApiResponse,
      ClientReservationControllerCreateReservationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/reservations`,
        method: "POST",
        body: queryArg.createReservationDto,
      }),
    }),
    clientReservationControllerGetTimeSlots: build.query<
      ClientReservationControllerGetTimeSlotsApiResponse,
      ClientReservationControllerGetTimeSlotsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/reservations/${queryArg.locationId}/time-slots`,
      }),
    }),
    clientReservationControllerGetTables: build.query<
      ClientReservationControllerGetTablesApiResponse,
      ClientReservationControllerGetTablesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/reservations/${queryArg.locationId}/tables`,
        params: {
          page: queryArg.page,
        },
      }),
    }),
    clientReservationControllerGetTablesByIds: build.mutation<
      ClientReservationControllerGetTablesByIdsApiResponse,
      ClientReservationControllerGetTablesByIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/reservations/${queryArg.locationId}/tables`,
        method: "POST",
        body: queryArg.getReservationTablesByIds,
      }),
    }),
    clientReservationControllerCalculateDeposit: build.mutation<
      ClientReservationControllerCalculateDepositApiResponse,
      ClientReservationControllerCalculateDepositApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/reservations/${queryArg.locationId}/deposit`,
        method: "POST",
        body: queryArg.calculateReservationDepositDto,
      }),
    }),
    clientPromocodeControllerExists: build.query<
      ClientPromocodeControllerExistsApiResponse,
      ClientPromocodeControllerExistsApiArg
    >({
      query: () => ({ url: `/api/client/v1/promocodes/exists` }),
    }),
    clientPromocodeControllerFind: build.mutation<
      ClientPromocodeControllerFindApiResponse,
      ClientPromocodeControllerFindApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/promocodes/find`,
        method: "POST",
        body: queryArg.findPromocodeDto,
      }),
    }),
    clientPromocodeControllerCalculateDiscount: build.mutation<
      ClientPromocodeControllerCalculateDiscountApiResponse,
      ClientPromocodeControllerCalculateDiscountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/promocodes/discount`,
        method: "POST",
        body: queryArg.calculatePromocodeDiscountDto,
      }),
    }),
    clientProfileControllerGetProfile: build.query<
      ClientProfileControllerGetProfileApiResponse,
      ClientProfileControllerGetProfileApiArg
    >({
      query: () => ({ url: `/api/client/v1/profile` }),
    }),
    clientProfileControllerUpdateProfile: build.mutation<
      ClientProfileControllerUpdateProfileApiResponse,
      ClientProfileControllerUpdateProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/profile`,
        method: "PATCH",
        body: queryArg.updateClientProfileDto,
      }),
    }),
    emailVerificationControllerRequest: build.mutation<
      EmailVerificationControllerRequestApiResponse,
      EmailVerificationControllerRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/profile/email-verification/request`,
        method: "POST",
        body: queryArg.clientEmailVerificationRequestDto,
      }),
    }),
    emailVerificationControllerVerify: build.mutation<
      EmailVerificationControllerVerifyApiResponse,
      EmailVerificationControllerVerifyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/profile/email-verification/verify`,
        method: "POST",
        body: queryArg.clientEmailVerificationVerifyDto,
      }),
    }),
    clientReservationByUrlIntegrationControllerGetIntegration: build.query<
      ClientReservationByUrlIntegrationControllerGetIntegrationApiResponse,
      ClientReservationByUrlIntegrationControllerGetIntegrationApiArg
    >({
      query: () => ({ url: `/api/client/v1/integrations/reservation-by-url` }),
    }),
    clientCdekIntegrationControllerGetIntegration: build.query<
      ClientCdekIntegrationControllerGetIntegrationApiResponse,
      ClientCdekIntegrationControllerGetIntegrationApiArg
    >({
      query: () => ({ url: `/api/client/v1/integrations/cdek` }),
    }),
    clientWildberriesIntegrationControllerExists: build.query<
      ClientWildberriesIntegrationControllerExistsApiResponse,
      ClientWildberriesIntegrationControllerExistsApiArg
    >({
      query: () => ({ url: `/api/client/v1/integrations/wildberries/exists` }),
    }),
    clientWildberriesSellerAnalyticsControllerGetSellerInfo: build.query<
      ClientWildberriesSellerAnalyticsControllerGetSellerInfoApiResponse,
      ClientWildberriesSellerAnalyticsControllerGetSellerInfoApiArg
    >({
      query: () => ({
        url: `/api/client/v1/integrations/wildberries-seller-analytics`,
      }),
    }),
    clientAccoutLinkControllerGetActiveVeritificationCode: build.query<
      ClientAccoutLinkControllerGetActiveVeritificationCodeApiResponse,
      ClientAccoutLinkControllerGetActiveVeritificationCodeApiArg
    >({
      query: () => ({ url: `/api/client/v1/link/verification-code/active` }),
    }),
    clientAccoutLinkControllerReceiveVerificationCode: build.mutation<
      ClientAccoutLinkControllerReceiveVerificationCodeApiResponse,
      ClientAccoutLinkControllerReceiveVerificationCodeApiArg
    >({
      query: () => ({
        url: `/api/client/v1/link/verification-code`,
        method: "POST",
      }),
    }),
    clientAccoutLinkControllerLinkTelegram: build.mutation<
      ClientAccoutLinkControllerLinkTelegramApiResponse,
      ClientAccoutLinkControllerLinkTelegramApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/link/telegram`,
        method: "POST",
        body: queryArg.clientLinkAccontDto,
      }),
    }),
    clientAccoutLinkControllerLinkMax: build.mutation<
      ClientAccoutLinkControllerLinkMaxApiResponse,
      ClientAccoutLinkControllerLinkMaxApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/link/max`,
        method: "POST",
        body: queryArg.clientLinkAccontDto,
      }),
    }),
    clientStartAppControllerHandle: build.mutation<
      ClientStartAppControllerHandleApiResponse,
      ClientStartAppControllerHandleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/client/v1/start-app/handle`,
        method: "POST",
        body: queryArg.clientStartAppRequestDto,
      }),
    }),
    managementTelegramAuthDeprecatedControllerValidateInitData: build.mutation<
      ManagementTelegramAuthDeprecatedControllerValidateInitDataApiResponse,
      ManagementTelegramAuthDeprecatedControllerValidateInitDataApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/telegram-auth/validate-init-data`,
        method: "POST",
        body: queryArg.telegramInitDataDto,
      }),
    }),
    managementTelegramBotDeprecatedControllerVerifyBotToken: build.mutation<
      ManagementTelegramBotDeprecatedControllerVerifyBotTokenApiResponse,
      ManagementTelegramBotDeprecatedControllerVerifyBotTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/telegram-bots/verify-token`,
        method: "POST",
        body: queryArg.verifyTelegramBotTokenDto,
      }),
    }),
    managementTelegramAuthControllerLogin: build.mutation<
      ManagementTelegramAuthControllerLoginApiResponse,
      ManagementTelegramAuthControllerLoginApiArg
    >({
      query: () => ({
        url: `/api/management/v1/telegram/auth/login`,
        method: "POST",
      }),
    }),
    managementTelegramAuthControllerWhoami: build.query<
      ManagementTelegramAuthControllerWhoamiApiResponse,
      ManagementTelegramAuthControllerWhoamiApiArg
    >({
      query: () => ({ url: `/api/management/v1/telegram/auth/whoami` }),
    }),
    managementMaxAuthControllerLogin: build.mutation<
      ManagementMaxAuthControllerLoginApiResponse,
      ManagementMaxAuthControllerLoginApiArg
    >({
      query: () => ({
        url: `/api/management/v1/max/auth/login`,
        method: "POST",
      }),
    }),
    managementMaxAuthControllerWhoami: build.query<
      ManagementMaxAuthControllerWhoamiApiResponse,
      ManagementMaxAuthControllerWhoamiApiArg
    >({
      query: () => ({ url: `/api/management/v1/max/auth/whoami` }),
    }),
    managementTokenAuthControllerRefresh: build.mutation<
      ManagementTokenAuthControllerRefreshApiResponse,
      ManagementTokenAuthControllerRefreshApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/auth/refresh`,
        method: "POST",
        body: queryArg.refreshTokenDto,
      }),
    }),
    managementTokenAuthControllerLogout: build.mutation<
      ManagementTokenAuthControllerLogoutApiResponse,
      ManagementTokenAuthControllerLogoutApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/auth/logout`,
        method: "POST",
        body: queryArg.refreshTokenDto,
      }),
    }),
    managementOAuthControllerStart: build.mutation<
      ManagementOAuthControllerStartApiResponse,
      ManagementOAuthControllerStartApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/oauth/${queryArg.provider}/start`,
        method: "POST",
        body: queryArg.managementOAuthStartDto,
      }),
    }),
    managementOAuthControllerCallback: build.mutation<
      ManagementOAuthControllerCallbackApiResponse,
      ManagementOAuthControllerCallbackApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/oauth/${queryArg.provider}/callback`,
        method: "POST",
        body: queryArg.managementOAuthCallbackDto,
      }),
    }),
    managementMagicAuthControllerRequest: build.mutation<
      ManagementMagicAuthControllerRequestApiResponse,
      ManagementMagicAuthControllerRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/auth/magic-link/request`,
        method: "POST",
        body: queryArg.magicAuthRequestDto,
      }),
    }),
    managementMagicAuthControllerVerify: build.mutation<
      ManagementMagicAuthControllerVerifyApiResponse,
      ManagementMagicAuthControllerVerifyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/auth/magic-link/verify`,
        method: "POST",
        body: queryArg.magicAuthVerifyDto,
      }),
    }),
    managementUserControllerUpdate: build.mutation<
      ManagementUserControllerUpdateApiResponse,
      ManagementUserControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/user/update`,
        method: "POST",
        body: queryArg.managementUpdateUserDto,
      }),
    }),
    managementAdvertisingBannerControllerGetBanners: build.query<
      ManagementAdvertisingBannerControllerGetBannersApiResponse,
      ManagementAdvertisingBannerControllerGetBannersApiArg
    >({
      query: () => ({ url: `/api/management/v1/advertising/banners` }),
    }),
    managementAdvertisingBannerControllerCreateBanner: build.mutation<
      ManagementAdvertisingBannerControllerCreateBannerApiResponse,
      ManagementAdvertisingBannerControllerCreateBannerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/advertising/banners`,
        method: "POST",
        body: queryArg.createAdvertisingBannerDto,
      }),
    }),
    managementAdvertisingBannerControllerUploadPreviewPhoto: build.mutation<
      ManagementAdvertisingBannerControllerUploadPreviewPhotoApiResponse,
      ManagementAdvertisingBannerControllerUploadPreviewPhotoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/advertising/banners/preview-photo/upload`,
        method: "POST",
        body: queryArg.uploadAdvertisingBannerPreviewPhotoDto,
      }),
    }),
    managementAdvertisingBannerControllerGetBanner: build.query<
      ManagementAdvertisingBannerControllerGetBannerApiResponse,
      ManagementAdvertisingBannerControllerGetBannerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/advertising/banners/${queryArg.id}`,
      }),
    }),
    managementAdvertisingBannerControllerUpdateBanner: build.mutation<
      ManagementAdvertisingBannerControllerUpdateBannerApiResponse,
      ManagementAdvertisingBannerControllerUpdateBannerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/advertising/banners/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateAdvertisingBannerDto,
      }),
    }),
    managementAdvertisingBannerControllerDeleteBanner: build.mutation<
      ManagementAdvertisingBannerControllerDeleteBannerApiResponse,
      ManagementAdvertisingBannerControllerDeleteBannerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/advertising/banners/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    managementAdvertisingBannerControllerReorderBanners: build.mutation<
      ManagementAdvertisingBannerControllerReorderBannersApiResponse,
      ManagementAdvertisingBannerControllerReorderBannersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/advertising/banners/reorder`,
        method: "PATCH",
        body: queryArg.reorderAdvertisingBannersDto,
      }),
    }),
    managementUtmCampaignControllerGetCampaigns: build.query<
      ManagementUtmCampaignControllerGetCampaignsApiResponse,
      ManagementUtmCampaignControllerGetCampaignsApiArg
    >({
      query: () => ({ url: `/api/management/v1/utm-campaigns` }),
    }),
    managementUtmCampaignControllerCreateCampaign: build.mutation<
      ManagementUtmCampaignControllerCreateCampaignApiResponse,
      ManagementUtmCampaignControllerCreateCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/utm-campaigns`,
        method: "POST",
        body: queryArg.createUtmCampaignDto,
      }),
    }),
    managementUtmCampaignControllerUpdateCampaign: build.mutation<
      ManagementUtmCampaignControllerUpdateCampaignApiResponse,
      ManagementUtmCampaignControllerUpdateCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/utm-campaigns/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateUtmCampaignDto,
      }),
    }),
    managementUtmCampaignControllerSoftDeleteCampaign: build.mutation<
      ManagementUtmCampaignControllerSoftDeleteCampaignApiResponse,
      ManagementUtmCampaignControllerSoftDeleteCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/utm-campaigns/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    managementLinkStatsControllerGetStats: build.mutation<
      ManagementLinkStatsControllerGetStatsApiResponse,
      ManagementLinkStatsControllerGetStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/marketing/link-stats`,
        method: "POST",
        body: queryArg.linkStatsRequestDto,
      }),
    }),
    managementChainsControllerMyChains: build.query<
      ManagementChainsControllerMyChainsApiResponse,
      ManagementChainsControllerMyChainsApiArg
    >({
      query: () => ({ url: `/api/management/v1/chains/myChains` }),
    }),
    managementChainsControllerCreate: build.mutation<
      ManagementChainsControllerCreateApiResponse,
      ManagementChainsControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/chains`,
        method: "POST",
        body: queryArg.createChainDto,
      }),
    }),
    managementChainsControllerUpdateChain: build.mutation<
      ManagementChainsControllerUpdateChainApiResponse,
      ManagementChainsControllerUpdateChainApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/chains`,
        method: "PATCH",
        body: queryArg.updateChainDto,
      }),
    }),
    managementChainsControllerUploadBrandLogo: build.mutation<
      ManagementChainsControllerUploadBrandLogoApiResponse,
      ManagementChainsControllerUploadBrandLogoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/chains/brand-logo/upload`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    managementChainsControllerUploadBrandPhoto: build.mutation<
      ManagementChainsControllerUploadBrandPhotoApiResponse,
      ManagementChainsControllerUploadBrandPhotoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/chains/brand-photo/upload`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    managementChainsControllerUploadBannerPhoto: build.mutation<
      ManagementChainsControllerUploadBannerPhotoApiResponse,
      ManagementChainsControllerUploadBannerPhotoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/chains/banner-photo/upload`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    managementChainsControllerGetChainInformation: build.query<
      ManagementChainsControllerGetChainInformationApiResponse,
      ManagementChainsControllerGetChainInformationApiArg
    >({
      query: () => ({ url: `/api/management/v1/chains/information` }),
    }),
    managementChainsControllerUpdateChainInformation: build.mutation<
      ManagementChainsControllerUpdateChainInformationApiResponse,
      ManagementChainsControllerUpdateChainInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/chains/information`,
        method: "PATCH",
        body: queryArg.updateChainInformationDto,
      }),
    }),
    chainLegalControllerGetGeneratedDocuments: build.query<
      ChainLegalControllerGetGeneratedDocumentsApiResponse,
      ChainLegalControllerGetGeneratedDocumentsApiArg
    >({
      query: () => ({
        url: `/api/management/v1/chains/legal/generated-documents`,
      }),
    }),
    chainLegalControllerGetLegalInfo: build.query<
      ChainLegalControllerGetLegalInfoApiResponse,
      ChainLegalControllerGetLegalInfoApiArg
    >({
      query: () => ({ url: `/api/management/v1/chains/legal/info` }),
    }),
    chainLegalControllerSetLegalInfo: build.mutation<
      ChainLegalControllerSetLegalInfoApiResponse,
      ChainLegalControllerSetLegalInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/chains/legal/info`,
        method: "POST",
        body: queryArg.setChainLegalInfoDto,
      }),
    }),
    chainLegalControllerDeleteLegalInfo: build.mutation<
      ChainLegalControllerDeleteLegalInfoApiResponse,
      ChainLegalControllerDeleteLegalInfoApiArg
    >({
      query: () => ({
        url: `/api/management/v1/chains/legal/info`,
        method: "DELETE",
      }),
    }),
    chainPaymentControllerGetSavedPaymentMethod: build.query<
      ChainPaymentControllerGetSavedPaymentMethodApiResponse,
      ChainPaymentControllerGetSavedPaymentMethodApiArg
    >({
      query: () => ({ url: `/api/management/v1/chains/payments/saved-method` }),
    }),
    chainPaymentControllerUpdatePaymentMethod: build.mutation<
      ChainPaymentControllerUpdatePaymentMethodApiResponse,
      ChainPaymentControllerUpdatePaymentMethodApiArg
    >({
      query: () => ({
        url: `/api/management/v1/chains/payments/saved-method/update`,
        method: "POST",
      }),
    }),
    chainPaymentControllerGetLastPaymentMethodUpdate: build.query<
      ChainPaymentControllerGetLastPaymentMethodUpdateApiResponse,
      ChainPaymentControllerGetLastPaymentMethodUpdateApiArg
    >({
      query: () => ({
        url: `/api/management/v1/chains/payments/saved-method/update/last`,
      }),
    }),
    managementWildberriesSellerAnalyticsControllerCreate: build.mutation<
      ManagementWildberriesSellerAnalyticsControllerCreateApiResponse,
      ManagementWildberriesSellerAnalyticsControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/integrations/wildberries-seller-analytics`,
        method: "POST",
        body: queryArg.createWildberriesSellerAnalyticsDto,
      }),
    }),
    managementWildberriesSellerAnalyticsControllerUpdate: build.mutation<
      ManagementWildberriesSellerAnalyticsControllerUpdateApiResponse,
      ManagementWildberriesSellerAnalyticsControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/integrations/wildberries-seller-analytics`,
        method: "PATCH",
        body: queryArg.updateWildberriesSellerAnalyticsDto,
      }),
    }),
    managementWildberriesSellerAnalyticsControllerGet: build.query<
      ManagementWildberriesSellerAnalyticsControllerGetApiResponse,
      ManagementWildberriesSellerAnalyticsControllerGetApiArg
    >({
      query: () => ({
        url: `/api/management/v1/integrations/wildberries-seller-analytics`,
      }),
    }),
    managementIntegrationControllerGetAll: build.query<
      ManagementIntegrationControllerGetAllApiResponse,
      ManagementIntegrationControllerGetAllApiArg
    >({
      query: () => ({ url: `/api/management/v1/integrations` }),
    }),
    managementIntegrationControllerGetById: build.query<
      ManagementIntegrationControllerGetByIdApiResponse,
      ManagementIntegrationControllerGetByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/integrations/${queryArg.id}`,
      }),
    }),
    managementIntegrationControllerDeleteById: build.mutation<
      ManagementIntegrationControllerDeleteByIdApiResponse,
      ManagementIntegrationControllerDeleteByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/integrations/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    managementMenuSyncControllerSynciikoMenu: build.mutation<
      ManagementMenuSyncControllerSynciikoMenuApiResponse,
      ManagementMenuSyncControllerSynciikoMenuApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu/sync/iiko`,
        method: "POST",
        body: queryArg.startMenuIikoSync,
      }),
    }),
    managementMenuSyncControllerGetIikoSyncInfo: build.query<
      ManagementMenuSyncControllerGetIikoSyncInfoApiResponse,
      ManagementMenuSyncControllerGetIikoSyncInfoApiArg
    >({
      query: () => ({ url: `/api/management/v1/menu/sync/iiko/info` }),
    }),
    managementIikoIntegrationControllerIntegrateIiko: build.mutation<
      ManagementIikoIntegrationControllerIntegrateIikoApiResponse,
      ManagementIikoIntegrationControllerIntegrateIikoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/integrations/iiko`,
        method: "POST",
        body: queryArg.integrateIikoDto,
      }),
    }),
    managementIikoIntegrationControllerUpdateIikoIntegration: build.mutation<
      ManagementIikoIntegrationControllerUpdateIikoIntegrationApiResponse,
      ManagementIikoIntegrationControllerUpdateIikoIntegrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/integrations/iiko`,
        method: "PATCH",
        body: queryArg.updateIikoIntegrationDto,
      }),
    }),
    managementCdekIntegrationControllerIntegrateCdek: build.mutation<
      ManagementCdekIntegrationControllerIntegrateCdekApiResponse,
      ManagementCdekIntegrationControllerIntegrateCdekApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/integrations/cdek`,
        method: "POST",
        body: queryArg.integrateCdekDto,
      }),
    }),
    managementCdekIntegrationControllerUpdateCdekIntegration: build.mutation<
      ManagementCdekIntegrationControllerUpdateCdekIntegrationApiResponse,
      ManagementCdekIntegrationControllerUpdateCdekIntegrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/integrations/cdek`,
        method: "PATCH",
        body: queryArg.updateCdekIntegrationDto,
      }),
    }),
    managementReservationByUrlIntegrationControllerIntegrate: build.mutation<
      ManagementReservationByUrlIntegrationControllerIntegrateApiResponse,
      ManagementReservationByUrlIntegrationControllerIntegrateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/integrations/reservation-by-url`,
        method: "POST",
        body: queryArg.integrateReservationByUrlDto,
      }),
    }),
    managementReservationByUrlIntegrationControllerUpdateIntegration:
      build.mutation<
        ManagementReservationByUrlIntegrationControllerUpdateIntegrationApiResponse,
        ManagementReservationByUrlIntegrationControllerUpdateIntegrationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/management/v1/integrations/reservation-by-url`,
          method: "PATCH",
          body: queryArg.updateReservationByUrlIntegrationDto,
        }),
      }),
    managementRestoplaceIntegrationControllerIntegrateRestoplace:
      build.mutation<
        ManagementRestoplaceIntegrationControllerIntegrateRestoplaceApiResponse,
        ManagementRestoplaceIntegrationControllerIntegrateRestoplaceApiArg
      >({
        query: (queryArg) => ({
          url: `/api/management/v1/integrations/restoplace`,
          method: "POST",
          body: queryArg.integrateRestoplaceDto,
        }),
      }),
    managementRestoplaceIntegrationControllerUpdateRestoplaceIntegration:
      build.mutation<
        ManagementRestoplaceIntegrationControllerUpdateRestoplaceIntegrationApiResponse,
        ManagementRestoplaceIntegrationControllerUpdateRestoplaceIntegrationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/management/v1/integrations/${queryArg.id}/restoplace`,
          method: "PATCH",
          body: queryArg.updateRestoplaceIntegrationDto,
        }),
      }),
    managementWildberriesIntegrationControllerCreateIntegration: build.mutation<
      ManagementWildberriesIntegrationControllerCreateIntegrationApiResponse,
      ManagementWildberriesIntegrationControllerCreateIntegrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/integrations/wildberries`,
        method: "POST",
        body: queryArg.upsertWildberriesIntegrationDto,
      }),
    }),
    managementWildberriesIntegrationControllerUpdateIntegration: build.mutation<
      ManagementWildberriesIntegrationControllerUpdateIntegrationApiResponse,
      ManagementWildberriesIntegrationControllerUpdateIntegrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/integrations/wildberries`,
        method: "PATCH",
        body: queryArg.upsertWildberriesIntegrationDto,
      }),
    }),
    managementWildberriesIntegrationControllerGetImportableItems: build.query<
      ManagementWildberriesIntegrationControllerGetImportableItemsApiResponse,
      ManagementWildberriesIntegrationControllerGetImportableItemsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/integrations/wildberries/items/importable`,
        params: {
          limit: queryArg.limit,
          textSearch: queryArg.textSearch,
          cursor: queryArg.cursor,
        },
      }),
    }),
    managementWildberriesIntegrationControllerImportAllItems: build.mutation<
      ManagementWildberriesIntegrationControllerImportAllItemsApiResponse,
      ManagementWildberriesIntegrationControllerImportAllItemsApiArg
    >({
      query: () => ({
        url: `/api/management/v1/integrations/wildberries/items/import`,
        method: "POST",
      }),
    }),
    managementLocationsControllerCreate: build.mutation<
      ManagementLocationsControllerCreateApiResponse,
      ManagementLocationsControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/locations`,
        method: "POST",
        body: queryArg.createLocationDto,
      }),
    }),
    managementLocationsControllerFindAll: build.query<
      ManagementLocationsControllerFindAllApiResponse,
      ManagementLocationsControllerFindAllApiArg
    >({
      query: () => ({ url: `/api/management/v1/locations` }),
    }),
    managementLocationsControllerFindOne: build.query<
      ManagementLocationsControllerFindOneApiResponse,
      ManagementLocationsControllerFindOneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/locations/${queryArg.id}`,
      }),
    }),
    managementLocationsControllerUpdate: build.mutation<
      ManagementLocationsControllerUpdateApiResponse,
      ManagementLocationsControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/locations/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateLocationDto,
      }),
    }),
    managementLocationsControllerGetSchedule: build.mutation<
      ManagementLocationsControllerGetScheduleApiResponse,
      ManagementLocationsControllerGetScheduleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/locations/${queryArg.id}/schedule`,
        method: "POST",
        body: queryArg.getLocationScheduleDto,
      }),
    }),
    managementLocationsControllerFindClosestLocation: build.mutation<
      ManagementLocationsControllerFindClosestLocationApiResponse,
      ManagementLocationsControllerFindClosestLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/locations/closest`,
        method: "POST",
        body: queryArg.findClosestLocationDto,
      }),
    }),
    managementOrderPointControllerFindOrderPoints: build.mutation<
      ManagementOrderPointControllerFindOrderPointsApiResponse,
      ManagementOrderPointControllerFindOrderPointsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/order-points/find`,
        method: "POST",
        body: queryArg.findOrderPointsDto,
      }),
    }),
    managementOrderPointControllerCalculateDeliveryPrice: build.mutation<
      ManagementOrderPointControllerCalculateDeliveryPriceApiResponse,
      ManagementOrderPointControllerCalculateDeliveryPriceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/order-points/${queryArg.orderPointId}/delivery-price`,
        method: "POST",
        body: queryArg.managementCalculateOrderPointDeliveryPriceDto,
      }),
    }),
    managementMenuCategoriesControllerCreate: build.mutation<
      ManagementMenuCategoriesControllerCreateApiResponse,
      ManagementMenuCategoriesControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu-categories`,
        method: "POST",
        body: queryArg.createMenuCategoryDto,
      }),
    }),
    managementMenuCategoriesControllerFindAll: build.query<
      ManagementMenuCategoriesControllerFindAllApiResponse,
      ManagementMenuCategoriesControllerFindAllApiArg
    >({
      query: () => ({ url: `/api/management/v1/menu-categories` }),
    }),
    managementMenuCategoriesControllerFindOne: build.query<
      ManagementMenuCategoriesControllerFindOneApiResponse,
      ManagementMenuCategoriesControllerFindOneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu-categories/${queryArg.id}`,
      }),
    }),
    managementMenuCategoriesControllerUpdate: build.mutation<
      ManagementMenuCategoriesControllerUpdateApiResponse,
      ManagementMenuCategoriesControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu-categories/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateMenuCategoryDto,
      }),
    }),
    managementMenuCategoriesControllerReorder: build.mutation<
      ManagementMenuCategoriesControllerReorderApiResponse,
      ManagementMenuCategoriesControllerReorderApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu-categories/reorder`,
        method: "PATCH",
        body: queryArg.reorderCategoriesDto,
      }),
    }),
    managementMenuItemsControllerCreate: build.mutation<
      ManagementMenuItemsControllerCreateApiResponse,
      ManagementMenuItemsControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu-items`,
        method: "POST",
        body: queryArg.createMenuItemDto,
      }),
    }),
    managementMenuItemsControllerFindAll: build.query<
      ManagementMenuItemsControllerFindAllApiResponse,
      ManagementMenuItemsControllerFindAllApiArg
    >({
      query: () => ({ url: `/api/management/v1/menu-items` }),
    }),
    managementMenuItemsControllerFindOne: build.query<
      ManagementMenuItemsControllerFindOneApiResponse,
      ManagementMenuItemsControllerFindOneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu-items/${queryArg.id}`,
      }),
    }),
    managementMenuItemsControllerUpdate: build.mutation<
      ManagementMenuItemsControllerUpdateApiResponse,
      ManagementMenuItemsControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu-items/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateMenuItemDto,
      }),
    }),
    managementMenuItemsControllerSetStock: build.mutation<
      ManagementMenuItemsControllerSetStockApiResponse,
      ManagementMenuItemsControllerSetStockApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu-items/stock`,
        method: "PATCH",
        body: queryArg.updateStockDto,
      }),
    }),
    managementMenuItemsControllerReorder: build.mutation<
      ManagementMenuItemsControllerReorderApiResponse,
      ManagementMenuItemsControllerReorderApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu-items/reorder`,
        method: "POST",
        body: queryArg.reorderMenuItemsDto,
      }),
    }),
    managementMenuItemsControllerGetAllRecommendations: build.query<
      ManagementMenuItemsControllerGetAllRecommendationsApiResponse,
      ManagementMenuItemsControllerGetAllRecommendationsApiArg
    >({
      query: () => ({
        url: `/api/management/v1/menu-items/filter/recommendations`,
      }),
    }),
    managementMenuItemsControllerUploadPhotos: build.mutation<
      ManagementMenuItemsControllerUploadPhotosApiResponse,
      ManagementMenuItemsControllerUploadPhotosApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu-items/photos/upload`,
        method: "POST",
        body: queryArg.uploadMenuPhotosDto,
      }),
    }),
    managementMenuItemsControllerSetRecommendations: build.mutation<
      ManagementMenuItemsControllerSetRecommendationsApiResponse,
      ManagementMenuItemsControllerSetRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu-items/set-recommendations`,
        method: "POST",
        body: queryArg.setMenuItemRecommendationsDto,
      }),
    }),
    managementMenuItemsControllerReorderRecommendations: build.mutation<
      ManagementMenuItemsControllerReorderRecommendationsApiResponse,
      ManagementMenuItemsControllerReorderRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/menu-items/reorder-recommendations`,
        method: "POST",
        body: queryArg.reorderMenuItemRecommendationsDto,
      }),
    }),
    managementOnlinePaymentsControllerGetOnlinePayments: build.query<
      ManagementOnlinePaymentsControllerGetOnlinePaymentsApiResponse,
      ManagementOnlinePaymentsControllerGetOnlinePaymentsApiArg
    >({
      query: () => ({ url: `/api/management/v1/online-payments` }),
    }),
    managementOnlinePaymentsControllerCreateOnlinePayment: build.mutation<
      ManagementOnlinePaymentsControllerCreateOnlinePaymentApiResponse,
      ManagementOnlinePaymentsControllerCreateOnlinePaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/online-payments`,
        method: "POST",
        body: queryArg.createOnlinePaymentDto,
      }),
    }),
    managementOnlinePaymentsControllerUpdateOnlinePayment: build.mutation<
      ManagementOnlinePaymentsControllerUpdateOnlinePaymentApiResponse,
      ManagementOnlinePaymentsControllerUpdateOnlinePaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/online-payments/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateOnlinePaymentDto,
      }),
    }),
    managementOnlinePaymentsControllerDeleteOnlinePayment: build.mutation<
      ManagementOnlinePaymentsControllerDeleteOnlinePaymentApiResponse,
      ManagementOnlinePaymentsControllerDeleteOnlinePaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/online-payments/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    managementOrdersControllerFindAll: build.query<
      ManagementOrdersControllerFindAllApiResponse,
      ManagementOrdersControllerFindAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/orders`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
          customerTelegramId: queryArg.customerTelegramId,
          clientId: queryArg.clientId,
          orderNumber: queryArg.orderNumber,
        },
      }),
    }),
    managementOrdersControllerGetOpenOrders: build.query<
      ManagementOrdersControllerGetOpenOrdersApiResponse,
      ManagementOrdersControllerGetOpenOrdersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/orders/open`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    managementOrdersControllerGetDelayedOrders: build.query<
      ManagementOrdersControllerGetDelayedOrdersApiResponse,
      ManagementOrdersControllerGetDelayedOrdersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/orders/delayed`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
          section: queryArg.section,
        },
      }),
    }),
    managementOrdersControllerGetArchivedOrders: build.query<
      ManagementOrdersControllerGetArchivedOrdersApiResponse,
      ManagementOrdersControllerGetArchivedOrdersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/orders/archived`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    managementOrdersControllerCountOrders: build.query<
      ManagementOrdersControllerCountOrdersApiResponse,
      ManagementOrdersControllerCountOrdersApiArg
    >({
      query: () => ({ url: `/api/management/v1/orders/count` }),
    }),
    managementOrdersControllerFindOne: build.query<
      ManagementOrdersControllerFindOneApiResponse,
      ManagementOrdersControllerFindOneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/orders/${queryArg.id}`,
      }),
    }),
    managementOrdersControllerUpdateOrder: build.mutation<
      ManagementOrdersControllerUpdateOrderApiResponse,
      ManagementOrdersControllerUpdateOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/orders/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateOrderDto,
      }),
    }),
    managementOrdersControllerUpdateStatus: build.mutation<
      ManagementOrdersControllerUpdateStatusApiResponse,
      ManagementOrdersControllerUpdateStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/orders/${queryArg.id}/status`,
        method: "PATCH",
        body: queryArg.updateStatusDto,
      }),
    }),
    managementOrdersControllerGetOptimalDeliveryZones: build.mutation<
      ManagementOrdersControllerGetOptimalDeliveryZonesApiResponse,
      ManagementOrdersControllerGetOptimalDeliveryZonesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/orders/optimal-delivery-zone`,
        method: "POST",
        body: queryArg.getOptimalDeliveryZoneDto,
      }),
    }),
    managementOrdersControllerGetOrderUpdateBonusInfo: build.mutation<
      ManagementOrdersControllerGetOrderUpdateBonusInfoApiResponse,
      ManagementOrdersControllerGetOrderUpdateBonusInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/orders/${queryArg.id}/bonuses`,
        method: "POST",
        body: queryArg.getBonusInfoForOrderUpdateDto,
      }),
    }),
    managementStaffMembersControllerCreate: build.mutation<
      ManagementStaffMembersControllerCreateApiResponse,
      ManagementStaffMembersControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/staff-members`,
        method: "POST",
        body: queryArg.createStaffMemberDto,
      }),
    }),
    managementStaffMembersControllerFindAll: build.query<
      ManagementStaffMembersControllerFindAllApiResponse,
      ManagementStaffMembersControllerFindAllApiArg
    >({
      query: () => ({ url: `/api/management/v1/staff-members` }),
    }),
    managementStaffMembersControllerGetMe: build.query<
      ManagementStaffMembersControllerGetMeApiResponse,
      ManagementStaffMembersControllerGetMeApiArg
    >({
      query: () => ({ url: `/api/management/v1/staff-members/me` }),
    }),
    managementStaffMembersControllerUpdate: build.mutation<
      ManagementStaffMembersControllerUpdateApiResponse,
      ManagementStaffMembersControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/staff-members/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateStaffMemberDto,
      }),
    }),
    managementLegalControllerGetDocuments: build.query<
      ManagementLegalControllerGetDocumentsApiResponse,
      ManagementLegalControllerGetDocumentsApiArg
    >({
      query: () => ({ url: `/api/management/v1/legal/documents` }),
    }),
    managementLegalControllerAcceptDocuments: build.mutation<
      ManagementLegalControllerAcceptDocumentsApiResponse,
      ManagementLegalControllerAcceptDocumentsApiArg
    >({
      query: () => ({
        url: `/api/management/v1/legal/documents/accept`,
        method: "POST",
      }),
    }),
    managementLegalControllerAcceptInstruction: build.mutation<
      ManagementLegalControllerAcceptInstructionApiResponse,
      ManagementLegalControllerAcceptInstructionApiArg
    >({
      query: () => ({
        url: `/api/management/v1/legal/instruction/accept`,
        method: "POST",
      }),
    }),
    managementStatsControllerGetStatsById: build.query<
      ManagementStatsControllerGetStatsByIdApiResponse,
      ManagementStatsControllerGetStatsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/stats/client/${queryArg.id}`,
      }),
    }),
    managementStatsControllerGetStats: build.mutation<
      ManagementStatsControllerGetStatsApiResponse,
      ManagementStatsControllerGetStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/stats/client`,
        method: "POST",
        body: queryArg.getClientStatsDto,
      }),
    }),
    managementRevenueStatsControllerStats: build.mutation<
      ManagementRevenueStatsControllerStatsApiResponse,
      ManagementRevenueStatsControllerStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/stats/revenue`,
        method: "POST",
        body: queryArg.getRevenueStatsDto,
      }),
    }),
    managementOrdersExportControllerExportOrders: build.query<
      ManagementOrdersExportControllerExportOrdersApiResponse,
      ManagementOrdersExportControllerExportOrdersApiArg
    >({
      query: () => ({ url: `/api/management/v1/stats/export/orders` }),
    }),
    managementOrdersExportControllerExportOrderItems: build.query<
      ManagementOrdersExportControllerExportOrderItemsApiResponse,
      ManagementOrdersExportControllerExportOrderItemsApiArg
    >({
      query: () => ({ url: `/api/management/v1/stats/export/order-items` }),
    }),
    managementEventsStatsControllerStats: build.mutation<
      ManagementEventsStatsControllerStatsApiResponse,
      ManagementEventsStatsControllerStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/events/stats`,
        method: "POST",
        body: queryArg.eventsStatsRequestDto,
      }),
    }),
    managementSubscriptionControllerGetSubscription: build.query<
      ManagementSubscriptionControllerGetSubscriptionApiResponse,
      ManagementSubscriptionControllerGetSubscriptionApiArg
    >({
      query: () => ({ url: `/api/management/v1/subscriptions` }),
    }),
    managementSubscriptionControllerGetMetadata: build.query<
      ManagementSubscriptionControllerGetMetadataApiResponse,
      ManagementSubscriptionControllerGetMetadataApiArg
    >({
      query: () => ({ url: `/api/management/v1/subscriptions/metadata` }),
    }),
    managementSubscriptionControllerSubscribe: build.mutation<
      ManagementSubscriptionControllerSubscribeApiResponse,
      ManagementSubscriptionControllerSubscribeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/subscriptions/subscribe`,
        method: "POST",
        body: queryArg.subscribePremiumDto,
      }),
    }),
    managementSubscriptionControllerUpdate: build.mutation<
      ManagementSubscriptionControllerUpdateApiResponse,
      ManagementSubscriptionControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/subscriptions/${queryArg.id}/update`,
        method: "PATCH",
        body: queryArg.updatePremiumChainSubscriptionDto,
      }),
    }),
    managementSubscriptionPromocodeControllerGetPromocode: build.query<
      ManagementSubscriptionPromocodeControllerGetPromocodeApiResponse,
      ManagementSubscriptionPromocodeControllerGetPromocodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/subscriptions/promocodes/find`,
        params: {
          code: queryArg.code,
        },
      }),
    }),
    managementSubscriptionHistoryControllerGetHistory: build.query<
      ManagementSubscriptionHistoryControllerGetHistoryApiResponse,
      ManagementSubscriptionHistoryControllerGetHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/subscriptions/history`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    managementPromocodesControllerGetAll: build.query<
      ManagementPromocodesControllerGetAllApiResponse,
      ManagementPromocodesControllerGetAllApiArg
    >({
      query: () => ({ url: `/api/management/v1/promocodes` }),
    }),
    managementPromocodesControllerCreate: build.mutation<
      ManagementPromocodesControllerCreateApiResponse,
      ManagementPromocodesControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/promocodes`,
        method: "POST",
        body: queryArg.createPromocodeDto,
      }),
    }),
    managementPromocodesControllerGetOneById: build.query<
      ManagementPromocodesControllerGetOneByIdApiResponse,
      ManagementPromocodesControllerGetOneByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/promocodes/${queryArg.id}`,
      }),
    }),
    managementPromocodesControllerUpdate: build.mutation<
      ManagementPromocodesControllerUpdateApiResponse,
      ManagementPromocodesControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/promocodes/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updatePromocodeDto,
      }),
    }),
    managementPromocodesControllerDelete: build.mutation<
      ManagementPromocodesControllerDeleteApiResponse,
      ManagementPromocodesControllerDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/promocodes/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    managementPromocodesControllerCalculateDiscount: build.mutation<
      ManagementPromocodesControllerCalculateDiscountApiResponse,
      ManagementPromocodesControllerCalculateDiscountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/promocodes/discount`,
        method: "POST",
        body: queryArg.calculatePromocodeDiscountDto,
      }),
    }),
    managementProfileControllerGetProfile: build.query<
      ManagementProfileControllerGetProfileApiResponse,
      ManagementProfileControllerGetProfileApiArg
    >({
      query: () => ({ url: `/api/management/v1/profile` }),
    }),
    managementProfileControllerUpdateProfile: build.mutation<
      ManagementProfileControllerUpdateProfileApiResponse,
      ManagementProfileControllerUpdateProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/profile`,
        method: "PATCH",
        body: queryArg.updateManagementProfileDto,
      }),
    }),
    managementMailingControllerGetDraftMailings: build.query<
      ManagementMailingControllerGetDraftMailingsApiResponse,
      ManagementMailingControllerGetDraftMailingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/mailings/draft`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    managementMailingControllerGetScheduledMailings: build.query<
      ManagementMailingControllerGetScheduledMailingsApiResponse,
      ManagementMailingControllerGetScheduledMailingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/mailings/scheduled`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    managementMailingControllerGetSentMailings: build.query<
      ManagementMailingControllerGetSentMailingsApiResponse,
      ManagementMailingControllerGetSentMailingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/mailings/sent`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    managementMailingControllerCountMailings: build.query<
      ManagementMailingControllerCountMailingsApiResponse,
      ManagementMailingControllerCountMailingsApiArg
    >({
      query: () => ({ url: `/api/management/v1/mailings/count` }),
    }),
    managementMailingControllerGetMailingById: build.query<
      ManagementMailingControllerGetMailingByIdApiResponse,
      ManagementMailingControllerGetMailingByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/mailings/${queryArg.id}`,
      }),
    }),
    managementMailingControllerUpdateMailingById: build.mutation<
      ManagementMailingControllerUpdateMailingByIdApiResponse,
      ManagementMailingControllerUpdateMailingByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/mailings/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateMailingDto,
      }),
    }),
    managementMailingControllerDeleteMailingById: build.mutation<
      ManagementMailingControllerDeleteMailingByIdApiResponse,
      ManagementMailingControllerDeleteMailingByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/mailings/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    managementMailingControllerGetExtendedMailingById: build.query<
      ManagementMailingControllerGetExtendedMailingByIdApiResponse,
      ManagementMailingControllerGetExtendedMailingByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/mailings/${queryArg.id}/extended`,
      }),
    }),
    managementMailingControllerCreateMailing: build.mutation<
      ManagementMailingControllerCreateMailingApiResponse,
      ManagementMailingControllerCreateMailingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/mailings`,
        method: "POST",
        body: queryArg.createMailingDto,
      }),
    }),
    managementMailingControllerStartMailing: build.mutation<
      ManagementMailingControllerStartMailingApiResponse,
      ManagementMailingControllerStartMailingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/mailings/${queryArg.id}/start`,
        method: "POST",
      }),
    }),
    managementMailingControllerUploadMailingPhoto: build.mutation<
      ManagementMailingControllerUploadMailingPhotoApiResponse,
      ManagementMailingControllerUploadMailingPhotoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/mailings/photo/upload`,
        method: "POST",
        body: queryArg.uploadMailingPhotoDto,
      }),
    }),
    managementReservationControllerGetActive: build.query<
      ManagementReservationControllerGetActiveApiResponse,
      ManagementReservationControllerGetActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/reservations/active`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    managementReservationControllerGetArchived: build.query<
      ManagementReservationControllerGetArchivedApiResponse,
      ManagementReservationControllerGetArchivedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/reservations/archived`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    managementReservationControllerCount: build.query<
      ManagementReservationControllerCountApiResponse,
      ManagementReservationControllerCountApiArg
    >({
      query: () => ({ url: `/api/management/v1/reservations/count` }),
    }),
    managementReservationControllerGetTablesByIds: build.mutation<
      ManagementReservationControllerGetTablesByIdsApiResponse,
      ManagementReservationControllerGetTablesByIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/reservations/${queryArg.locationId}/tables`,
        method: "POST",
        body: queryArg.getReservationTablesByIds,
      }),
    }),
    managementAccountLinkControllerGetActiveVeritificationCode: build.query<
      ManagementAccountLinkControllerGetActiveVeritificationCodeApiResponse,
      ManagementAccountLinkControllerGetActiveVeritificationCodeApiArg
    >({
      query: () => ({
        url: `/api/management/v1/link/verification-code/active`,
      }),
    }),
    managementAccountLinkControllerCreateVerificationCode: build.mutation<
      ManagementAccountLinkControllerCreateVerificationCodeApiResponse,
      ManagementAccountLinkControllerCreateVerificationCodeApiArg
    >({
      query: () => ({
        url: `/api/management/v1/link/verification-code`,
        method: "POST",
      }),
    }),
    managementAccountLinkControllerLinkTelegram: build.mutation<
      ManagementAccountLinkControllerLinkTelegramApiResponse,
      ManagementAccountLinkControllerLinkTelegramApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/link/telegram`,
        method: "POST",
        body: queryArg.managementLinkAccontDto,
      }),
    }),
    managementAccountLinkControllerLinkMax: build.mutation<
      ManagementAccountLinkControllerLinkMaxApiResponse,
      ManagementAccountLinkControllerLinkMaxApiArg
    >({
      query: (queryArg) => ({
        url: `/api/management/v1/link/max`,
        method: "POST",
        body: queryArg.managementLinkAccontDto,
      }),
    }),
    sharedHealthControllerCheck: build.query<
      SharedHealthControllerCheckApiResponse,
      SharedHealthControllerCheckApiArg
    >({
      query: () => ({ url: `/api/v1/health` }),
    }),
    sharedWebhooksControllerHandleIikoWebhook: build.mutation<
      SharedWebhooksControllerHandleIikoWebhookApiResponse,
      SharedWebhooksControllerHandleIikoWebhookApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/webhooks/iiko`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    sharedWebhooksControllerHandleRestoplaceWebhook: build.mutation<
      SharedWebhooksControllerHandleRestoplaceWebhookApiResponse,
      SharedWebhooksControllerHandleRestoplaceWebhookApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/webhooks/restoplace`,
        method: "POST",
        body: queryArg.restoplaceWebhookReserveEventDto,
      }),
    }),
    oAuthRedirectControllerClientCallback: build.query<
      OAuthRedirectControllerClientCallbackApiResponse,
      OAuthRedirectControllerClientCallbackApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/oauth/client/callback`,
        params: {
          state: queryArg.state,
          code: queryArg.code,
          device_id: queryArg.deviceId,
          error: queryArg.error,
          error_description: queryArg.errorDescription,
        },
      }),
    }),
    oAuthRedirectControllerManagementCallback: build.query<
      OAuthRedirectControllerManagementCallbackApiResponse,
      OAuthRedirectControllerManagementCallbackApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/oauth/management/callback`,
        params: {
          state: queryArg.state,
          code: queryArg.code,
          device_id: queryArg.deviceId,
          error: queryArg.error,
          error_description: queryArg.errorDescription,
        },
      }),
    }),
    devLegalControllerUploadDocuments: build.mutation<
      DevLegalControllerUploadDocumentsApiResponse,
      DevLegalControllerUploadDocumentsApiArg
    >({
      query: () => ({
        url: `/api/dev/v1/legal/documents/upload`,
        method: "POST",
      }),
    }),
    devEventsControllerRunRollup: build.mutation<
      DevEventsControllerRunRollupApiResponse,
      DevEventsControllerRunRollupApiArg
    >({
      query: () => ({ url: `/api/dev/v1/events/rollup/run`, method: "POST" }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as restApi };
export type ClientAuthDeprecatedControllerLoginApiResponse =
  /** status 200  */ {
    data: AuthenticatedClientTelegramUserDataDto;
  };
export type ClientAuthDeprecatedControllerLoginApiArg = void;
export type ClientTelegramAuthControllerLoginApiResponse = /** status 200  */ {
  data: AuthenticatedClientTelegramUserDataDto;
};
export type ClientTelegramAuthControllerLoginApiArg = {
  clientTelegramLoginDto: ClientTelegramLoginDto;
};
export type ClientTelegramAuthControllerWhoamiApiResponse = /** status 200  */ {
  data?: ClientUserDto;
};
export type ClientTelegramAuthControllerWhoamiApiArg = void;
export type ClientMaxAuthControllerLoginApiResponse = /** status 200  */ {
  data: AuthenticatedClientMaxUserDataDto;
};
export type ClientMaxAuthControllerLoginApiArg = {
  clientMaxLoginDto: ClientMaxLoginDto;
};
export type ClientMaxAuthControllerWhoamiApiResponse = /** status 200  */ {
  data?: ClientUserDto;
};
export type ClientMaxAuthControllerWhoamiApiArg = void;
export type ClientTokenAuthControllerRefreshApiResponse = /** status 200  */ {
  data: TokenPairDto;
};
export type ClientTokenAuthControllerRefreshApiArg = {
  refreshTokenDto: RefreshTokenDto;
};
export type ClientTokenAuthControllerLogoutApiResponse = /** status 200  */ {
  data?: boolean;
};
export type ClientTokenAuthControllerLogoutApiArg = {
  refreshTokenDto: RefreshTokenDto;
};
export type ClientOAuthControllerStartApiResponse = /** status 200  */ {
  data: ClientOAuthStartResponseDto;
};
export type ClientOAuthControllerStartApiArg = {
  provider: string;
  clientOAuthStartDto: ClientOAuthStartDto;
};
export type ClientOAuthControllerCallbackApiResponse = /** status 200  */ {
  data: ClientOAuthCallbackResponseDto;
};
export type ClientOAuthControllerCallbackApiArg = {
  provider: string;
  clientOAuthCallbackDto: ClientOAuthCallbackDto;
};
export type ClientMagicAuthControllerRequestApiResponse = /** status 200  */ {
  data: MagicAuthRequestResponseDto;
};
export type ClientMagicAuthControllerRequestApiArg = {
  magicAuthRequestDto: MagicAuthRequestDto;
};
export type ClientMagicAuthControllerVerifyApiResponse = /** status 200  */ {
  data: ClientMagicAuthResponseDto;
};
export type ClientMagicAuthControllerVerifyApiArg = {
  clientMagicAuthVerifyDto: ClientMagicAuthVerifyDto;
};
export type ClientUserControllerUpdateApiResponse = /** status 200  */ {
  data: ClientUserDto;
};
export type ClientUserControllerUpdateApiArg = {
  clientUpdateUserDto: ClientUpdateUserDto;
};
export type ClientAdvertisingBannerControllerGetActiveBannersApiResponse =
  /** status 200  */ {
    data?: AdvertisingBannerDto[];
    total?: number;
  };
export type ClientAdvertisingBannerControllerGetActiveBannersApiArg = void;
export type ClientChainControllerGetChainInformationApiResponse =
  /** status 200  */ {
    data: ClientChainDto;
  };
export type ClientChainControllerGetChainInformationApiArg = void;
export type ClientEventsControllerRecordApiResponse = unknown;
export type ClientEventsControllerRecordApiArg = {
  recordEventsRequestDto: RecordEventsRequestDto;
};
export type ClientDeliveryControllerGetOptimalDeliveryZoneApiResponse =
  /** status 200  */ {
    data?: ClientOptimalDeliveryZoneInfoDto;
  };
export type ClientDeliveryControllerGetOptimalDeliveryZoneApiArg = {
  getOptimalDeliveryZoneDto: GetOptimalDeliveryZoneDto;
};
export type ClientLocationControllerGetAllLocationsApiResponse =
  /** status 200  */ {
    data?: ClientLocationDto[];
    total?: number;
  };
export type ClientLocationControllerGetAllLocationsApiArg = void;
export type ClientLocationControllerGetLocationApiResponse =
  /** status 200  */ {
    data: ClientLocationDto;
  };
export type ClientLocationControllerGetLocationApiArg = {
  id: string;
};
export type ClientLocationControllerGetScheduleApiResponse =
  /** status 200  */ {
    data: LocationScheduleDto;
  };
export type ClientLocationControllerGetScheduleApiArg = {
  id: string;
  getLocationScheduleDto: GetLocationScheduleDto;
};
export type ClientLocationControllerFindClosestLocationApiResponse =
  /** status 200  */ {
    data: ClientLocationDto;
  };
export type ClientLocationControllerFindClosestLocationApiArg = {
  findClosestLocationDto: FindClosestLocationDto;
};
export type ClientOrderPointControllerFindOrderPointsApiResponse =
  /** status 200  */ {
    data?: OrderPointDto[];
    total?: number;
  };
export type ClientOrderPointControllerFindOrderPointsApiArg = {
  findOrderPointsDto: FindOrderPointsDto;
};
export type ClientOrderPointControllerCalculateDeliveryPriceApiResponse =
  /** status 200  */ {
    data: OrderPointDeliveryPriceDto;
  };
export type ClientOrderPointControllerCalculateDeliveryPriceApiArg = {
  orderPointId: string;
  clientCalculateOrderPointDeliveryPriceDto: ClientCalculateOrderPointDeliveryPriceDto;
};
export type ClientMenuItemCategoriesControllerGetAllMenuCategoriesApiResponse =
  /** status 200  */ {
    data?: ClientMenuCategoryDto[];
    total?: number;
  };
export type ClientMenuItemCategoriesControllerGetAllMenuCategoriesApiArg = {
  locationId?: string;
};
export type ClientMenuItemsControllerGetAllMenuItemsApiResponse =
  /** status 200  */ {
    data?: ClientMenuItemDto[];
    total?: number;
  };
export type ClientMenuItemsControllerGetAllMenuItemsApiArg = {
  locationId?: string;
};
export type ClientMenuItemsControllerGetMenuItemByIdApiResponse =
  /** status 200  */ {
    data: ClientMenuItemDto;
  };
export type ClientMenuItemsControllerGetMenuItemByIdApiArg = {
  id: string;
  locationId?: string;
};
export type ClientMenuItemsControllerGetAllRecommendationsApiResponse =
  /** status 200  */ {
    data?: ClientMenuItemDto[];
    total?: number;
  };
export type ClientMenuItemsControllerGetAllRecommendationsApiArg = {
  locationId?: string;
};
export type ClientOrderControllerGetOrdersApiResponse = /** status 200  */ {
  data?: ClientOrderDto[];
  total?: number;
  nextCursor?: string | null;
};
export type ClientOrderControllerGetOrdersApiArg = {
  limit?: number;
  cursor?: string;
};
export type ClientOrderControllerGetOrderByIdApiResponse = /** status 200  */ {
  data: ClientOrderDto;
};
export type ClientOrderControllerGetOrderByIdApiArg = {
  id: string;
};
export type ClientOrderControllerCreateTakeoutOrderApiResponse =
  /** status 201  */ {
    data: ClientOrderDto;
  };
export type ClientOrderControllerCreateTakeoutOrderApiArg = {
  createTakeoutOrderDto: CreateTakeoutOrderDto;
};
export type ClientOrderControllerCreateCitywideDeliveryApiResponse =
  /** status 201  */ {
    data: ClientOrderDto;
  };
export type ClientOrderControllerCreateCitywideDeliveryApiArg = {
  createDeliveryOrderCitywideDto: CreateDeliveryOrderCitywideDto;
};
export type ClientOrderControllerCreateNationwideDeliveryApiResponse =
  /** status 201  */ {
    data: ClientOrderDto;
  };
export type ClientOrderControllerCreateNationwideDeliveryApiArg = {
  createDeliveryOrderNationwideDto: CreateDeliveryOrderNationwideDto;
};
export type ClientOrderControllerCreateOrderFromOrderPointApiResponse =
  /** status 201  */ {
    data: ClientOrderDto;
  };
export type ClientOrderControllerCreateOrderFromOrderPointApiArg = {
  createOrderFromOrderPoint: CreateOrderFromOrderPoint;
};
export type ClientOrderControllerGetBonusInfoForOrderCreationApiResponse =
  /** status 200  */ {
    data: OrderBonusInfoDto;
  };
export type ClientOrderControllerGetBonusInfoForOrderCreationApiArg = {
  getBonusInfoForOrderCreation: GetBonusInfoForOrderCreation;
};
export type ClientLegalControllerGetGeneratedDocumentsApiResponse =
  /** status 200  */ {
    data: ChainGeneratedLegalDocumentsDto;
  };
export type ClientLegalControllerGetGeneratedDocumentsApiArg = void;
export type ClientLegalControllerAcceptDocumentsApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ClientLegalControllerAcceptDocumentsApiArg = void;
export type ClientReservationControllerGetReservationsApiResponse =
  /** status 200  */ {
    data?: ReservationDto[];
    total?: number;
    nextCursor?: string | null;
  };
export type ClientReservationControllerGetReservationsApiArg = {
  limit?: number;
  cursor?: string;
};
export type ClientReservationControllerCreateReservationApiResponse =
  /** status 201  */ {
    data: ReservationDto;
  };
export type ClientReservationControllerCreateReservationApiArg = {
  createReservationDto: CreateReservationDto;
};
export type ClientReservationControllerGetTimeSlotsApiResponse =
  /** status 200  */ {
    data?: ReservationTimeSlotDto[];
    total?: number;
  };
export type ClientReservationControllerGetTimeSlotsApiArg = {
  locationId: string;
};
export type ClientReservationControllerGetTablesApiResponse =
  /** status 200  */ {
    data: ReservationTablesPageInfoDto;
  };
export type ClientReservationControllerGetTablesApiArg = {
  locationId: string;
  page?: number;
};
export type ClientReservationControllerGetTablesByIdsApiResponse =
  /** status 200  */ {
    data?: ReservationTableDto[];
    total?: number;
  };
export type ClientReservationControllerGetTablesByIdsApiArg = {
  locationId: string;
  getReservationTablesByIds: GetReservationTablesByIds;
};
export type ClientReservationControllerCalculateDepositApiResponse =
  /** status 200  */ {
    data: ReservationDepositDto;
  };
export type ClientReservationControllerCalculateDepositApiArg = {
  locationId: string;
  calculateReservationDepositDto: CalculateReservationDepositDto;
};
export type ClientPromocodeControllerExistsApiResponse = /** status 200  */ {
  data?: boolean;
};
export type ClientPromocodeControllerExistsApiArg = void;
export type ClientPromocodeControllerFindApiResponse = /** status 200  */ {
  data?: ClientPromocodeDto;
};
export type ClientPromocodeControllerFindApiArg = {
  findPromocodeDto: FindPromocodeDto;
};
export type ClientPromocodeControllerCalculateDiscountApiResponse =
  /** status 200  */ {
    data: PromocodeDiscountInfoDto;
  };
export type ClientPromocodeControllerCalculateDiscountApiArg = {
  calculatePromocodeDiscountDto: CalculatePromocodeDiscountDto;
};
export type ClientProfileControllerGetProfileApiResponse = /** status 200  */ {
  data: ClientProfileDto;
};
export type ClientProfileControllerGetProfileApiArg = void;
export type ClientProfileControllerUpdateProfileApiResponse =
  /** status 200  */ {
    data: ClientProfileDto;
  };
export type ClientProfileControllerUpdateProfileApiArg = {
  updateClientProfileDto: UpdateClientProfileDto;
};
export type EmailVerificationControllerRequestApiResponse = /** status 200  */ {
  data: MagicAuthRequestResponseDto;
};
export type EmailVerificationControllerRequestApiArg = {
  clientEmailVerificationRequestDto: ClientEmailVerificationRequestDto;
};
export type EmailVerificationControllerVerifyApiResponse = /** status 200  */ {
  data: ClientEmailVerificationResultDto;
};
export type EmailVerificationControllerVerifyApiArg = {
  clientEmailVerificationVerifyDto: ClientEmailVerificationVerifyDto;
};
export type ClientReservationByUrlIntegrationControllerGetIntegrationApiResponse =
  /** status 200  */ {
    data?: ReservationByUrlIntegrationDto;
  };
export type ClientReservationByUrlIntegrationControllerGetIntegrationApiArg =
  void;
export type ClientCdekIntegrationControllerGetIntegrationApiResponse =
  /** status 200  */ {
    data?: CdekIntegrationDto;
  };
export type ClientCdekIntegrationControllerGetIntegrationApiArg = void;
export type ClientWildberriesIntegrationControllerExistsApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ClientWildberriesIntegrationControllerExistsApiArg = void;
export type ClientWildberriesSellerAnalyticsControllerGetSellerInfoApiResponse =
  /** status 200  */ {
    data?: ClientWildberriesSellerInfoDto;
  };
export type ClientWildberriesSellerAnalyticsControllerGetSellerInfoApiArg =
  void;
export type ClientAccoutLinkControllerGetActiveVeritificationCodeApiResponse =
  /** status 200  */ {
    data?: ClientAccountLinkVerificationCodeDto;
  };
export type ClientAccoutLinkControllerGetActiveVeritificationCodeApiArg = void;
export type ClientAccoutLinkControllerReceiveVerificationCodeApiResponse =
  /** status 201  */ {
    data: ClientAccountLinkVerificationCodeDto;
  };
export type ClientAccoutLinkControllerReceiveVerificationCodeApiArg = void;
export type ClientAccoutLinkControllerLinkTelegramApiResponse =
  /** status 200  */ {
    data: ClientUserDto;
  };
export type ClientAccoutLinkControllerLinkTelegramApiArg = {
  clientLinkAccontDto: ClientLinkAccontDto;
};
export type ClientAccoutLinkControllerLinkMaxApiResponse = /** status 200  */ {
  data: ClientUserDto;
};
export type ClientAccoutLinkControllerLinkMaxApiArg = {
  clientLinkAccontDto: ClientLinkAccontDto;
};
export type ClientStartAppControllerHandleApiResponse = /** status 200  */ {
  data: ClientStartAppResponseDto;
};
export type ClientStartAppControllerHandleApiArg = {
  clientStartAppRequestDto: ClientStartAppRequestDto;
};
export type ManagementTelegramAuthDeprecatedControllerValidateInitDataApiResponse =
  /** status 200  */ {
    data: AuthenticatedTelegramUserDataDto;
  };
export type ManagementTelegramAuthDeprecatedControllerValidateInitDataApiArg = {
  telegramInitDataDto: TelegramInitDataDto;
};
export type ManagementTelegramBotDeprecatedControllerVerifyBotTokenApiResponse =
  /** status 200  */ {
    data: TelegramBotVerificationDto;
  };
export type ManagementTelegramBotDeprecatedControllerVerifyBotTokenApiArg = {
  verifyTelegramBotTokenDto: VerifyTelegramBotTokenDto;
};
export type ManagementTelegramAuthControllerLoginApiResponse =
  /** status 200  */ {
    data: AuthenticatedTelegramUserDataDto;
  };
export type ManagementTelegramAuthControllerLoginApiArg = void;
export type ManagementTelegramAuthControllerWhoamiApiResponse =
  /** status 200  */ {
    data?: ManagementUserDto;
  };
export type ManagementTelegramAuthControllerWhoamiApiArg = void;
export type ManagementMaxAuthControllerLoginApiResponse = /** status 200  */ {
  data: AuthenticatedMaxUserDataDto;
};
export type ManagementMaxAuthControllerLoginApiArg = void;
export type ManagementMaxAuthControllerWhoamiApiResponse = /** status 200  */ {
  data?: ManagementUserDto;
};
export type ManagementMaxAuthControllerWhoamiApiArg = void;
export type ManagementTokenAuthControllerRefreshApiResponse =
  /** status 200  */ {
    data: TokenPairDto;
  };
export type ManagementTokenAuthControllerRefreshApiArg = {
  refreshTokenDto: RefreshTokenDto;
};
export type ManagementTokenAuthControllerLogoutApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementTokenAuthControllerLogoutApiArg = {
  refreshTokenDto: RefreshTokenDto;
};
export type ManagementOAuthControllerStartApiResponse = /** status 200  */ {
  data: ManagementOAuthStartResponseDto;
};
export type ManagementOAuthControllerStartApiArg = {
  provider: string;
  managementOAuthStartDto: ManagementOAuthStartDto;
};
export type ManagementOAuthControllerCallbackApiResponse = /** status 200  */ {
  data: ManagementOAuthCallbackResponseDto;
};
export type ManagementOAuthControllerCallbackApiArg = {
  provider: string;
  managementOAuthCallbackDto: ManagementOAuthCallbackDto;
};
export type ManagementMagicAuthControllerRequestApiResponse =
  /** status 200  */ {
    data: MagicAuthRequestResponseDto;
  };
export type ManagementMagicAuthControllerRequestApiArg = {
  magicAuthRequestDto: MagicAuthRequestDto;
};
export type ManagementMagicAuthControllerVerifyApiResponse =
  /** status 200  */ {
    data: ManagementMagicAuthResponseDto;
  };
export type ManagementMagicAuthControllerVerifyApiArg = {
  magicAuthVerifyDto: MagicAuthVerifyDto;
};
export type ManagementUserControllerUpdateApiResponse = /** status 200  */ {
  data: ManagementUserDto;
};
export type ManagementUserControllerUpdateApiArg = {
  managementUpdateUserDto: ManagementUpdateUserDto;
};
export type ManagementAdvertisingBannerControllerGetBannersApiResponse =
  /** status 200  */ {
    data?: AdvertisingBannerDto[];
    total?: number;
  };
export type ManagementAdvertisingBannerControllerGetBannersApiArg = void;
export type ManagementAdvertisingBannerControllerCreateBannerApiResponse =
  /** status 201  */ {
    data: AdvertisingBannerDto;
  };
export type ManagementAdvertisingBannerControllerCreateBannerApiArg = {
  createAdvertisingBannerDto: CreateAdvertisingBannerDto;
};
export type ManagementAdvertisingBannerControllerUploadPreviewPhotoApiResponse =
  /** status 200  */ {
    data: AdvertisingBannerUploadPreviewPhotoInfoDto;
  };
export type ManagementAdvertisingBannerControllerUploadPreviewPhotoApiArg = {
  uploadAdvertisingBannerPreviewPhotoDto: UploadAdvertisingBannerPreviewPhotoDto;
};
export type ManagementAdvertisingBannerControllerGetBannerApiResponse =
  /** status 200  */ {
    data: AdvertisingBannerDto;
  };
export type ManagementAdvertisingBannerControllerGetBannerApiArg = {
  id: string;
};
export type ManagementAdvertisingBannerControllerUpdateBannerApiResponse =
  /** status 200  */ {
    data: AdvertisingBannerDto;
  };
export type ManagementAdvertisingBannerControllerUpdateBannerApiArg = {
  id: string;
  updateAdvertisingBannerDto: UpdateAdvertisingBannerDto;
};
export type ManagementAdvertisingBannerControllerDeleteBannerApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementAdvertisingBannerControllerDeleteBannerApiArg = {
  id: string;
};
export type ManagementAdvertisingBannerControllerReorderBannersApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementAdvertisingBannerControllerReorderBannersApiArg = {
  reorderAdvertisingBannersDto: ReorderAdvertisingBannersDto;
};
export type ManagementUtmCampaignControllerGetCampaignsApiResponse =
  /** status 200  */ {
    data?: UtmCampaignDto[];
    total?: number;
  };
export type ManagementUtmCampaignControllerGetCampaignsApiArg = void;
export type ManagementUtmCampaignControllerCreateCampaignApiResponse =
  /** status 201  */ {
    data: UtmCampaignDto;
  };
export type ManagementUtmCampaignControllerCreateCampaignApiArg = {
  createUtmCampaignDto: CreateUtmCampaignDto;
};
export type ManagementUtmCampaignControllerUpdateCampaignApiResponse =
  /** status 201  */ {
    data: UtmCampaignDto;
  };
export type ManagementUtmCampaignControllerUpdateCampaignApiArg = {
  id: string;
  updateUtmCampaignDto: UpdateUtmCampaignDto;
};
export type ManagementUtmCampaignControllerSoftDeleteCampaignApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementUtmCampaignControllerSoftDeleteCampaignApiArg = {
  id: string;
};
export type ManagementLinkStatsControllerGetStatsApiResponse =
  /** status 200  */ {
    data: UtmLinkStatsDto | PromocodeLinkStatsDto;
  };
export type ManagementLinkStatsControllerGetStatsApiArg = {
  linkStatsRequestDto: LinkStatsRequestDto;
};
export type ManagementChainsControllerMyChainsApiResponse = /** status 200  */ {
  data?: ExtendedChainDto[];
  total?: number;
};
export type ManagementChainsControllerMyChainsApiArg = void;
export type ManagementChainsControllerCreateApiResponse = /** status 201  */ {
  data: ExtendedChainDto;
};
export type ManagementChainsControllerCreateApiArg = {
  createChainDto: CreateChainDto;
};
export type ManagementChainsControllerUpdateChainApiResponse =
  /** status 200  */ {
    data: ManagementChainDto;
  };
export type ManagementChainsControllerUpdateChainApiArg = {
  updateChainDto: UpdateChainDto;
};
export type ManagementChainsControllerUploadBrandLogoApiResponse =
  /** status 200  */ {
    data: ChainUploadedBrandLogoImageDto;
  };
export type ManagementChainsControllerUploadBrandLogoApiArg = {
  body: {
    image: Blob;
  };
};
export type ManagementChainsControllerUploadBrandPhotoApiResponse =
  /** status 200  */ {
    data: ChainUploadedBrandPhotoImageDto;
  };
export type ManagementChainsControllerUploadBrandPhotoApiArg = {
  body: {
    image: Blob;
  };
};
export type ManagementChainsControllerUploadBannerPhotoApiResponse =
  /** status 200  */ {
    data: ChainUploadedBannerPhotoImageDto;
  };
export type ManagementChainsControllerUploadBannerPhotoApiArg = {
  body: {
    desktop?: Blob;
    adaptive?: Blob;
  };
};
export type ManagementChainsControllerGetChainInformationApiResponse =
  /** status 200  */ {
    data: ManagementChainDto;
  };
export type ManagementChainsControllerGetChainInformationApiArg = void;
export type ManagementChainsControllerUpdateChainInformationApiResponse =
  /** status 200  */ {
    data: ManagementChainDto;
  };
export type ManagementChainsControllerUpdateChainInformationApiArg = {
  updateChainInformationDto: UpdateChainInformationDto;
};
export type ChainLegalControllerGetGeneratedDocumentsApiResponse =
  /** status 200  */ {
    data: ChainGeneratedLegalDocumentsDto;
  };
export type ChainLegalControllerGetGeneratedDocumentsApiArg = void;
export type ChainLegalControllerGetLegalInfoApiResponse = /** status 200  */ {
  data?: ChainLegalInfoDto;
};
export type ChainLegalControllerGetLegalInfoApiArg = void;
export type ChainLegalControllerSetLegalInfoApiResponse = /** status 200  */ {
  data: ManagementChainDto;
};
export type ChainLegalControllerSetLegalInfoApiArg = {
  setChainLegalInfoDto: SetChainLegalInfoDto;
};
export type ChainLegalControllerDeleteLegalInfoApiResponse =
  /** status 200  */ {
    data: ManagementChainDto;
  };
export type ChainLegalControllerDeleteLegalInfoApiArg = void;
export type ChainPaymentControllerGetSavedPaymentMethodApiResponse =
  /** status 200  */ {
    data?: ChainSavedPaymentMethodDto;
  };
export type ChainPaymentControllerGetSavedPaymentMethodApiArg = void;
export type ChainPaymentControllerUpdatePaymentMethodApiResponse =
  /** status 200  */ {
    data: ChainPaymentMethodUpdateDto;
  };
export type ChainPaymentControllerUpdatePaymentMethodApiArg = void;
export type ChainPaymentControllerGetLastPaymentMethodUpdateApiResponse =
  /** status 200  */ {
    data?: ChainPaymentMethodUpdateDto;
  };
export type ChainPaymentControllerGetLastPaymentMethodUpdateApiArg = void;
export type ManagementWildberriesSellerAnalyticsControllerCreateApiResponse =
  /** status 201  */ {
    data: WildberriesSellerAnalyticsDto;
  };
export type ManagementWildberriesSellerAnalyticsControllerCreateApiArg = {
  createWildberriesSellerAnalyticsDto: CreateWildberriesSellerAnalyticsDto;
};
export type ManagementWildberriesSellerAnalyticsControllerUpdateApiResponse =
  /** status 200  */ {
    data: WildberriesSellerAnalyticsDto;
  };
export type ManagementWildberriesSellerAnalyticsControllerUpdateApiArg = {
  updateWildberriesSellerAnalyticsDto: UpdateWildberriesSellerAnalyticsDto;
};
export type ManagementWildberriesSellerAnalyticsControllerGetApiResponse =
  /** status 200  */ {
    data: WildberriesSellerAnalyticsDto;
  };
export type ManagementWildberriesSellerAnalyticsControllerGetApiArg = void;
export type ManagementIntegrationControllerGetAllApiResponse =
  /** status 200  */ {
    data?: IntegrationDto[];
    total?: number;
  };
export type ManagementIntegrationControllerGetAllApiArg = void;
export type ManagementIntegrationControllerGetByIdApiResponse =
  /** status 200  */ {
    data: IntegrationDto;
  };
export type ManagementIntegrationControllerGetByIdApiArg = {
  id: string;
};
export type ManagementIntegrationControllerDeleteByIdApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementIntegrationControllerDeleteByIdApiArg = {
  id: string;
};
export type ManagementMenuSyncControllerSynciikoMenuApiResponse =
  /** status 201  */ {
    data?: boolean;
  };
export type ManagementMenuSyncControllerSynciikoMenuApiArg = {
  startMenuIikoSync: StartMenuIikoSync;
};
export type ManagementMenuSyncControllerGetIikoSyncInfoApiResponse =
  /** status 200  */ {
    data: IikoMenuSyncInfoDto;
  };
export type ManagementMenuSyncControllerGetIikoSyncInfoApiArg = void;
export type ManagementIikoIntegrationControllerIntegrateIikoApiResponse =
  /** status 201  */ {
    data: IntegrationDto;
  };
export type ManagementIikoIntegrationControllerIntegrateIikoApiArg = {
  integrateIikoDto: IntegrateIikoDto;
};
export type ManagementIikoIntegrationControllerUpdateIikoIntegrationApiResponse =
  /** status 200  */ {
    data: IntegrationDto;
  };
export type ManagementIikoIntegrationControllerUpdateIikoIntegrationApiArg = {
  updateIikoIntegrationDto: UpdateIikoIntegrationDto;
};
export type ManagementCdekIntegrationControllerIntegrateCdekApiResponse =
  /** status 201  */ {
    data: IntegrationDto;
  };
export type ManagementCdekIntegrationControllerIntegrateCdekApiArg = {
  integrateCdekDto: IntegrateCdekDto;
};
export type ManagementCdekIntegrationControllerUpdateCdekIntegrationApiResponse =
  /** status 200  */ {
    data: IntegrationDto;
  };
export type ManagementCdekIntegrationControllerUpdateCdekIntegrationApiArg = {
  updateCdekIntegrationDto: UpdateCdekIntegrationDto;
};
export type ManagementReservationByUrlIntegrationControllerIntegrateApiResponse =
  /** status 201  */ {
    data: IntegrationDto;
  };
export type ManagementReservationByUrlIntegrationControllerIntegrateApiArg = {
  integrateReservationByUrlDto: IntegrateReservationByUrlDto;
};
export type ManagementReservationByUrlIntegrationControllerUpdateIntegrationApiResponse =
  /** status 200  */ {
    data: IntegrationDto;
  };
export type ManagementReservationByUrlIntegrationControllerUpdateIntegrationApiArg =
  {
    updateReservationByUrlIntegrationDto: UpdateReservationByUrlIntegrationDto;
  };
export type ManagementRestoplaceIntegrationControllerIntegrateRestoplaceApiResponse =
  /** status 201  */ {
    data: IntegrationDto;
  };
export type ManagementRestoplaceIntegrationControllerIntegrateRestoplaceApiArg =
  {
    integrateRestoplaceDto: IntegrateRestoplaceDto;
  };
export type ManagementRestoplaceIntegrationControllerUpdateRestoplaceIntegrationApiResponse =
  /** status 201  */ {
    data: IntegrationDto;
  };
export type ManagementRestoplaceIntegrationControllerUpdateRestoplaceIntegrationApiArg =
  {
    id: string;
    updateRestoplaceIntegrationDto: UpdateRestoplaceIntegrationDto;
  };
export type ManagementWildberriesIntegrationControllerCreateIntegrationApiResponse =
  /** status 201  */ {
    data: IntegrationDto;
  };
export type ManagementWildberriesIntegrationControllerCreateIntegrationApiArg =
  {
    upsertWildberriesIntegrationDto: UpsertWildberriesIntegrationDto;
  };
export type ManagementWildberriesIntegrationControllerUpdateIntegrationApiResponse =
  /** status 200  */ {
    data: IntegrationDto;
  };
export type ManagementWildberriesIntegrationControllerUpdateIntegrationApiArg =
  {
    upsertWildberriesIntegrationDto: UpsertWildberriesIntegrationDto;
  };
export type ManagementWildberriesIntegrationControllerGetImportableItemsApiResponse =
  /** status 200  */ {
    data?: WbImportableItemDto[];
    total?: number;
    nextCursor?: string | null;
  };
export type ManagementWildberriesIntegrationControllerGetImportableItemsApiArg =
  {
    limit?: number;
    textSearch?: string;
    /** Opaque cursor string from previous response */
    cursor?: string;
  };
export type ManagementWildberriesIntegrationControllerImportAllItemsApiResponse =
  /** status 200  */ {
    data: WbImportSummaryDto;
  };
export type ManagementWildberriesIntegrationControllerImportAllItemsApiArg =
  void;
export type ManagementLocationsControllerCreateApiResponse =
  /** status 201  */ {
    data: ManagementLocationDto;
  };
export type ManagementLocationsControllerCreateApiArg = {
  createLocationDto: CreateLocationDto;
};
export type ManagementLocationsControllerFindAllApiResponse =
  /** status 200  */ {
    data?: ManagementLocationDto[];
    total?: number;
  };
export type ManagementLocationsControllerFindAllApiArg = void;
export type ManagementLocationsControllerFindOneApiResponse =
  /** status 200  */ {
    data: ManagementLocationDto;
  };
export type ManagementLocationsControllerFindOneApiArg = {
  id: string;
};
export type ManagementLocationsControllerUpdateApiResponse =
  /** status 200  */ {
    data: ManagementLocationDto;
  };
export type ManagementLocationsControllerUpdateApiArg = {
  id: string;
  updateLocationDto: UpdateLocationDto;
};
export type ManagementLocationsControllerGetScheduleApiResponse =
  /** status 200  */ {
    data: LocationScheduleDto;
  };
export type ManagementLocationsControllerGetScheduleApiArg = {
  id: string;
  getLocationScheduleDto: GetLocationScheduleDto;
};
export type ManagementLocationsControllerFindClosestLocationApiResponse =
  /** status 200  */ {
    data: ManagementLocationDto;
  };
export type ManagementLocationsControllerFindClosestLocationApiArg = {
  findClosestLocationDto: FindClosestLocationDto;
};
export type ManagementOrderPointControllerFindOrderPointsApiResponse =
  /** status 200  */ {
    data?: OrderPointDto[];
    total?: number;
  };
export type ManagementOrderPointControllerFindOrderPointsApiArg = {
  findOrderPointsDto: FindOrderPointsDto;
};
export type ManagementOrderPointControllerCalculateDeliveryPriceApiResponse =
  /** status 200  */ {
    data: OrderPointDeliveryPriceDto;
  };
export type ManagementOrderPointControllerCalculateDeliveryPriceApiArg = {
  orderPointId: string;
  managementCalculateOrderPointDeliveryPriceDto: ManagementCalculateOrderPointDeliveryPriceDto;
};
export type ManagementMenuCategoriesControllerCreateApiResponse =
  /** status 201  */ {
    data: MenuCategoryDto;
  };
export type ManagementMenuCategoriesControllerCreateApiArg = {
  createMenuCategoryDto: CreateMenuCategoryDto;
};
export type ManagementMenuCategoriesControllerFindAllApiResponse =
  /** status 200  */ {
    data?: ExtendedMenuCategoryDto[];
    total?: number;
  };
export type ManagementMenuCategoriesControllerFindAllApiArg = void;
export type ManagementMenuCategoriesControllerFindOneApiResponse =
  /** status 200  */ {
    data: MenuCategoryDto;
  };
export type ManagementMenuCategoriesControllerFindOneApiArg = {
  id: string;
};
export type ManagementMenuCategoriesControllerUpdateApiResponse =
  /** status 200  */ {
    data: MenuCategoryDto;
  };
export type ManagementMenuCategoriesControllerUpdateApiArg = {
  id: string;
  updateMenuCategoryDto: UpdateMenuCategoryDto;
};
export type ManagementMenuCategoriesControllerReorderApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementMenuCategoriesControllerReorderApiArg = {
  reorderCategoriesDto: ReorderCategoriesDto;
};
export type ManagementMenuItemsControllerCreateApiResponse =
  /** status 201  */ {
    data: MenuItemDto;
  };
export type ManagementMenuItemsControllerCreateApiArg = {
  createMenuItemDto: CreateMenuItemDto;
};
export type ManagementMenuItemsControllerFindAllApiResponse =
  /** status 200  */ {
    data?: MenuItemDto[];
    total?: number;
  };
export type ManagementMenuItemsControllerFindAllApiArg = void;
export type ManagementMenuItemsControllerFindOneApiResponse =
  /** status 200  */ {
    data: MenuItemDto;
  };
export type ManagementMenuItemsControllerFindOneApiArg = {
  id: string;
};
export type ManagementMenuItemsControllerUpdateApiResponse =
  /** status 200  */ {
    data: MenuItemDto;
  };
export type ManagementMenuItemsControllerUpdateApiArg = {
  id: string;
  updateMenuItemDto: UpdateMenuItemDto;
};
export type ManagementMenuItemsControllerSetStockApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementMenuItemsControllerSetStockApiArg = {
  updateStockDto: UpdateStockDto;
};
export type ManagementMenuItemsControllerReorderApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementMenuItemsControllerReorderApiArg = {
  reorderMenuItemsDto: ReorderMenuItemsDto;
};
export type ManagementMenuItemsControllerGetAllRecommendationsApiResponse =
  /** status 200  */ {
    data: MenuItemRecommendationsDto;
  };
export type ManagementMenuItemsControllerGetAllRecommendationsApiArg = void;
export type ManagementMenuItemsControllerUploadPhotosApiResponse =
  /** status 200  */ {
    data?: UploadedMenuPhotoDto[];
    total?: number;
  };
export type ManagementMenuItemsControllerUploadPhotosApiArg = {
  uploadMenuPhotosDto: UploadMenuPhotosDto;
};
export type ManagementMenuItemsControllerSetRecommendationsApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementMenuItemsControllerSetRecommendationsApiArg = {
  setMenuItemRecommendationsDto: SetMenuItemRecommendationsDto;
};
export type ManagementMenuItemsControllerReorderRecommendationsApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementMenuItemsControllerReorderRecommendationsApiArg = {
  reorderMenuItemRecommendationsDto: ReorderMenuItemRecommendationsDto;
};
export type ManagementOnlinePaymentsControllerGetOnlinePaymentsApiResponse =
  /** status 200  */ {
    data?: ManagementOnlinePaymentDto[];
    total?: number;
  };
export type ManagementOnlinePaymentsControllerGetOnlinePaymentsApiArg = void;
export type ManagementOnlinePaymentsControllerCreateOnlinePaymentApiResponse =
  /** status 201  */ {
    data: ManagementOnlinePaymentDto;
  };
export type ManagementOnlinePaymentsControllerCreateOnlinePaymentApiArg = {
  createOnlinePaymentDto: CreateOnlinePaymentDto;
};
export type ManagementOnlinePaymentsControllerUpdateOnlinePaymentApiResponse =
  /** status 200  */ {
    data: ManagementOnlinePaymentDto;
  };
export type ManagementOnlinePaymentsControllerUpdateOnlinePaymentApiArg = {
  id: string;
  updateOnlinePaymentDto: UpdateOnlinePaymentDto;
};
export type ManagementOnlinePaymentsControllerDeleteOnlinePaymentApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementOnlinePaymentsControllerDeleteOnlinePaymentApiArg = {
  id: string;
};
export type ManagementOrdersControllerFindAllApiResponse = /** status 200  */ {
  data?: ManagementOrderDto[];
  total?: number;
  nextCursor?: string | null;
};
export type ManagementOrdersControllerFindAllApiArg = {
  limit?: number;
  cursor?: string;
  customerTelegramId?: string;
  clientId?: string;
  orderNumber?: string;
};
export type ManagementOrdersControllerGetOpenOrdersApiResponse =
  /** status 200  */ {
    data?: ManagementOrderDto[];
    total?: number;
    nextCursor?: string | null;
  };
export type ManagementOrdersControllerGetOpenOrdersApiArg = {
  limit?: number;
  cursor?: string;
};
export type ManagementOrdersControllerGetDelayedOrdersApiResponse =
  /** status 200  */ {
    data?: ManagementOrderDto[];
    total?: number;
    nextCursor?: string | null;
  };
export type ManagementOrdersControllerGetDelayedOrdersApiArg = {
  limit?: number;
  cursor?: string;
  section?: DelayedOrdersSectionEnum;
};
export type ManagementOrdersControllerGetArchivedOrdersApiResponse =
  /** status 200  */ {
    data?: ManagementOrderDto[];
    total?: number;
    nextCursor?: string | null;
  };
export type ManagementOrdersControllerGetArchivedOrdersApiArg = {
  limit?: number;
  cursor?: string;
};
export type ManagementOrdersControllerCountOrdersApiResponse =
  /** status 200  */ {
    data: OrdersCountDto;
  };
export type ManagementOrdersControllerCountOrdersApiArg = void;
export type ManagementOrdersControllerFindOneApiResponse = /** status 200  */ {
  data: ManagementOrderDto;
};
export type ManagementOrdersControllerFindOneApiArg = {
  id: string;
};
export type ManagementOrdersControllerUpdateOrderApiResponse =
  /** status 200  */ {
    data: ManagementOrderDto;
  };
export type ManagementOrdersControllerUpdateOrderApiArg = {
  id: string;
  updateOrderDto: UpdateOrderDto;
};
export type ManagementOrdersControllerUpdateStatusApiResponse =
  /** status 200  */ {
    data: ManagementOrderDto;
  };
export type ManagementOrdersControllerUpdateStatusApiArg = {
  id: string;
  updateStatusDto: UpdateStatusDto;
};
export type ManagementOrdersControllerGetOptimalDeliveryZonesApiResponse =
  /** status 200  */ {
    data: ManagementOptimalDeliveryZoneInfoDto;
  };
export type ManagementOrdersControllerGetOptimalDeliveryZonesApiArg = {
  getOptimalDeliveryZoneDto: GetOptimalDeliveryZoneDto;
};
export type ManagementOrdersControllerGetOrderUpdateBonusInfoApiResponse =
  /** status 200  */ {
    data: OrderBonusInfoDto;
  };
export type ManagementOrdersControllerGetOrderUpdateBonusInfoApiArg = {
  id: string;
  getBonusInfoForOrderUpdateDto: GetBonusInfoForOrderUpdateDto;
};
export type ManagementStaffMembersControllerCreateApiResponse =
  /** status 201  */ {
    data: StaffMemberDto;
  };
export type ManagementStaffMembersControllerCreateApiArg = {
  createStaffMemberDto: CreateStaffMemberDto;
};
export type ManagementStaffMembersControllerFindAllApiResponse =
  /** status 200  */ {
    data?: StaffMemberDto[];
    total?: number;
  };
export type ManagementStaffMembersControllerFindAllApiArg = void;
export type ManagementStaffMembersControllerGetMeApiResponse =
  /** status 200  */ {
    data: StaffMemberDto;
  };
export type ManagementStaffMembersControllerGetMeApiArg = void;
export type ManagementStaffMembersControllerUpdateApiResponse =
  /** status 200  */ {
    data: ManagementChainDto;
  };
export type ManagementStaffMembersControllerUpdateApiArg = {
  id: string;
  updateStaffMemberDto: UpdateStaffMemberDto;
};
export type ManagementLegalControllerGetDocumentsApiResponse =
  /** status 200  */ {
    data: ManagementLegalDocumentsDto;
  };
export type ManagementLegalControllerGetDocumentsApiArg = void;
export type ManagementLegalControllerAcceptDocumentsApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementLegalControllerAcceptDocumentsApiArg = void;
export type ManagementLegalControllerAcceptInstructionApiResponse =
  /** status 200  */ {
    data: ManagementChainDto;
  };
export type ManagementLegalControllerAcceptInstructionApiArg = void;
export type ManagementStatsControllerGetStatsByIdApiResponse =
  /** status 200  */ {
    data: ClientStatsDto;
  };
export type ManagementStatsControllerGetStatsByIdApiArg = {
  id: string;
};
export type ManagementStatsControllerGetStatsApiResponse = /** status 200  */ {
  data?: ClientStatsDto[];
  total?: number;
  nextCursor?: string | null;
};
export type ManagementStatsControllerGetStatsApiArg = {
  getClientStatsDto: GetClientStatsDto;
};
export type ManagementRevenueStatsControllerStatsApiResponse =
  /** status 200  */ {
    data: RevenueStatsDto;
  };
export type ManagementRevenueStatsControllerStatsApiArg = {
  getRevenueStatsDto: GetRevenueStatsDto;
};
export type ManagementOrdersExportControllerExportOrdersApiResponse = unknown;
export type ManagementOrdersExportControllerExportOrdersApiArg = void;
export type ManagementOrdersExportControllerExportOrderItemsApiResponse =
  unknown;
export type ManagementOrdersExportControllerExportOrderItemsApiArg = void;
export type ManagementEventsStatsControllerStatsApiResponse =
  /** status 200  */ {
    data: EventsStatsResponseDto;
  };
export type ManagementEventsStatsControllerStatsApiArg = {
  eventsStatsRequestDto: EventsStatsRequestDto;
};
export type ManagementSubscriptionControllerGetSubscriptionApiResponse =
  /** status 200  */ {
    data: ManagementChainSubscriptionDto;
  };
export type ManagementSubscriptionControllerGetSubscriptionApiArg = void;
export type ManagementSubscriptionControllerGetMetadataApiResponse =
  /** status 200  */ {
    data?: ManagementChainSubscriptionMetadataDto[];
    total?: number;
  };
export type ManagementSubscriptionControllerGetMetadataApiArg = void;
export type ManagementSubscriptionControllerSubscribeApiResponse =
  /** status 200  */ {
    data: ManagementChainSubscriptionDto;
  };
export type ManagementSubscriptionControllerSubscribeApiArg = {
  subscribePremiumDto: SubscribePremiumDto;
};
export type ManagementSubscriptionControllerUpdateApiResponse =
  /** status 200  */ {
    data: ManagementChainSubscriptionDto;
  };
export type ManagementSubscriptionControllerUpdateApiArg = {
  id: string;
  updatePremiumChainSubscriptionDto: UpdatePremiumChainSubscriptionDto;
};
export type ManagementSubscriptionPromocodeControllerGetPromocodeApiResponse =
  /** status 200  */ {
    data?: ChainSubscriptionPromocodeDto;
  };
export type ManagementSubscriptionPromocodeControllerGetPromocodeApiArg = {
  code: string;
};
export type ManagementSubscriptionHistoryControllerGetHistoryApiResponse =
  /** status 200  */ {
    data?: ChainSubscriptionHistoryDto[];
    total?: number;
    nextCursor?: string | null;
  };
export type ManagementSubscriptionHistoryControllerGetHistoryApiArg = {
  limit?: number;
  cursor?: string;
};
export type ManagementPromocodesControllerGetAllApiResponse =
  /** status 200  */ {
    data?: PromocodeDto[];
    total?: number;
  };
export type ManagementPromocodesControllerGetAllApiArg = void;
export type ManagementPromocodesControllerCreateApiResponse =
  /** status 201  */ {
    data: PromocodeDto;
  };
export type ManagementPromocodesControllerCreateApiArg = {
  createPromocodeDto: CreatePromocodeDto;
};
export type ManagementPromocodesControllerGetOneByIdApiResponse =
  /** status 200  */ {
    data: PromocodeDto;
  };
export type ManagementPromocodesControllerGetOneByIdApiArg = {
  id: string;
};
export type ManagementPromocodesControllerUpdateApiResponse =
  /** status 200  */ {
    data: PromocodeDto;
  };
export type ManagementPromocodesControllerUpdateApiArg = {
  id: string;
  updatePromocodeDto: UpdatePromocodeDto;
};
export type ManagementPromocodesControllerDeleteApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementPromocodesControllerDeleteApiArg = {
  id: string;
};
export type ManagementPromocodesControllerCalculateDiscountApiResponse =
  /** status 200  */ {
    data: PromocodeDiscountInfoDto;
  };
export type ManagementPromocodesControllerCalculateDiscountApiArg = {
  calculatePromocodeDiscountDto: CalculatePromocodeDiscountDto;
};
export type ManagementProfileControllerGetProfileApiResponse =
  /** status 200  */ {
    data: ManagementProfileDto;
  };
export type ManagementProfileControllerGetProfileApiArg = void;
export type ManagementProfileControllerUpdateProfileApiResponse =
  /** status 200  */ {
    data: ManagementProfileDto;
  };
export type ManagementProfileControllerUpdateProfileApiArg = {
  updateManagementProfileDto: UpdateManagementProfileDto;
};
export type ManagementMailingControllerGetDraftMailingsApiResponse =
  /** status 200  */ {
    data?: MailingDto[];
    total?: number;
    nextCursor?: string | null;
  };
export type ManagementMailingControllerGetDraftMailingsApiArg = {
  limit?: number;
  cursor?: string;
};
export type ManagementMailingControllerGetScheduledMailingsApiResponse =
  /** status 200  */ {
    data?: MailingDto[];
    total?: number;
    nextCursor?: string | null;
  };
export type ManagementMailingControllerGetScheduledMailingsApiArg = {
  limit?: number;
  cursor?: string;
};
export type ManagementMailingControllerGetSentMailingsApiResponse =
  /** status 200  */ {
    data?: MailingDto[];
    total?: number;
    nextCursor?: string | null;
  };
export type ManagementMailingControllerGetSentMailingsApiArg = {
  limit?: number;
  cursor?: string;
};
export type ManagementMailingControllerCountMailingsApiResponse =
  /** status 200  */ {
    data: MailingCountDto;
  };
export type ManagementMailingControllerCountMailingsApiArg = void;
export type ManagementMailingControllerGetMailingByIdApiResponse =
  /** status 200  */ {
    data: MailingDto;
  };
export type ManagementMailingControllerGetMailingByIdApiArg = {
  id: string;
};
export type ManagementMailingControllerUpdateMailingByIdApiResponse =
  /** status 200  */ {
    data: MailingDto;
  };
export type ManagementMailingControllerUpdateMailingByIdApiArg = {
  id: string;
  updateMailingDto: UpdateMailingDto;
};
export type ManagementMailingControllerDeleteMailingByIdApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type ManagementMailingControllerDeleteMailingByIdApiArg = {
  id: string;
};
export type ManagementMailingControllerGetExtendedMailingByIdApiResponse =
  /** status 200  */ {
    data: ExtendedMailingDto;
  };
export type ManagementMailingControllerGetExtendedMailingByIdApiArg = {
  id: string;
};
export type ManagementMailingControllerCreateMailingApiResponse =
  /** status 201  */ {
    data: MailingDto;
  };
export type ManagementMailingControllerCreateMailingApiArg = {
  createMailingDto: CreateMailingDto;
};
export type ManagementMailingControllerStartMailingApiResponse =
  /** status 200  */ {
    data: MailingDto;
  };
export type ManagementMailingControllerStartMailingApiArg = {
  id: string;
};
export type ManagementMailingControllerUploadMailingPhotoApiResponse =
  /** status 200  */ {
    data: UploadedMailingPhotoDto;
  };
export type ManagementMailingControllerUploadMailingPhotoApiArg = {
  uploadMailingPhotoDto: UploadMailingPhotoDto;
};
export type ManagementReservationControllerGetActiveApiResponse =
  /** status 200  */ {
    data?: ReservationDto[];
    total?: number;
    nextCursor?: string | null;
  };
export type ManagementReservationControllerGetActiveApiArg = {
  limit?: number;
  cursor?: string;
};
export type ManagementReservationControllerGetArchivedApiResponse =
  /** status 200  */ {
    data?: ReservationDto[];
    total?: number;
    nextCursor?: string | null;
  };
export type ManagementReservationControllerGetArchivedApiArg = {
  limit?: number;
  cursor?: string;
};
export type ManagementReservationControllerCountApiResponse =
  /** status 200  */ {
    data: ReservationsCountDto;
  };
export type ManagementReservationControllerCountApiArg = void;
export type ManagementReservationControllerGetTablesByIdsApiResponse =
  /** status 200  */ {
    data?: ReservationTableDto[];
    total?: number;
  };
export type ManagementReservationControllerGetTablesByIdsApiArg = {
  locationId: string;
  getReservationTablesByIds: GetReservationTablesByIds;
};
export type ManagementAccountLinkControllerGetActiveVeritificationCodeApiResponse =
  /** status 201  */ {
    data: ManagementAccountLinkVerificationCodeDto;
  };
export type ManagementAccountLinkControllerGetActiveVeritificationCodeApiArg =
  void;
export type ManagementAccountLinkControllerCreateVerificationCodeApiResponse =
  /** status 201  */ {
    data: ManagementAccountLinkVerificationCodeDto;
  };
export type ManagementAccountLinkControllerCreateVerificationCodeApiArg = void;
export type ManagementAccountLinkControllerLinkTelegramApiResponse =
  /** status 200  */ {
    data: ManagementUserDto;
  };
export type ManagementAccountLinkControllerLinkTelegramApiArg = {
  managementLinkAccontDto: ManagementLinkAccontDto;
};
export type ManagementAccountLinkControllerLinkMaxApiResponse =
  /** status 200  */ {
    data: ManagementUserDto;
  };
export type ManagementAccountLinkControllerLinkMaxApiArg = {
  managementLinkAccontDto: ManagementLinkAccontDto;
};
export type SharedHealthControllerCheckApiResponse = /** status 200  */ {
  data?: boolean;
};
export type SharedHealthControllerCheckApiArg = void;
export type SharedWebhooksControllerHandleIikoWebhookApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type SharedWebhooksControllerHandleIikoWebhookApiArg = {
  body: string[];
};
export type SharedWebhooksControllerHandleRestoplaceWebhookApiResponse =
  /** status 200  */ {
    data?: boolean;
  };
export type SharedWebhooksControllerHandleRestoplaceWebhookApiArg = {
  restoplaceWebhookReserveEventDto: RestoplaceWebhookReserveEventDto;
};
export type OAuthRedirectControllerClientCallbackApiResponse = unknown;
export type OAuthRedirectControllerClientCallbackApiArg = {
  state: string;
  code?: string;
  deviceId?: string;
  error?: string;
  errorDescription?: string;
};
export type OAuthRedirectControllerManagementCallbackApiResponse = unknown;
export type OAuthRedirectControllerManagementCallbackApiArg = {
  state: string;
  code?: string;
  deviceId?: string;
  error?: string;
  errorDescription?: string;
};
export type DevLegalControllerUploadDocumentsApiResponse = /** status 200  */ {
  data?: boolean;
};
export type DevLegalControllerUploadDocumentsApiArg = void;
export type DevEventsControllerRunRollupApiResponse = /** status 200  */ {
  data?: boolean;
};
export type DevEventsControllerRunRollupApiArg = void;
export type UserTelegramInfoDto = {
  id: string;
  firstName: string;
  lastName: string | null;
  username: string | null;
  photoUrl: string | null;
};
export type UserMaxInfoDto = {
  id: string;
  firstName: string;
  lastName: string | null;
  username: string | null;
  photoUrl: string | null;
};
export type ClientInnerUserInfoDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  languageCode: UserLanguageCode;
  firstName: string | null;
  lastName: string | null;
  telegramUsername: string | null;
  wasLinked: boolean;
  telegramInfo: UserTelegramInfoDto | null;
  maxInfo: UserMaxInfoDto | null;
  acceptedClientDocuments: boolean;
  isSubscribedToMailings: boolean;
  bonusBalance: number;
  hasPreviouslyAcceptedClientDocuments: boolean;
};
export type TokenPairDto = {
  accessToken: string;
  refreshToken: string;
  tokenType: TokenType;
  expiresInSeconds: number;
};
export type ClientProfileAuthIdentityDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  provider: GlobalUserAuthProvider;
  providerSubject: string;
  login: string;
  providerUsername: string | null;
  providerEmail: string | null;
  providerPhone: string | null;
  providerFirstName: string | null;
  providerLastName: string | null;
  providerPhotoUrl: string | null;
};
export type ClientProfileDeliveryAddressPointDto = {
  lat: number;
  lng: number;
};
export type ClientProfileDeliveryAddressDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  address: string;
  street: string | null;
  city: string | null;
  house: string | null;
  point: ClientProfileDeliveryAddressPointDto;
  areManualCoordinates: boolean;
  entranceway: string | null;
  floor: string | null;
  apartment: string | null;
  intercom: string | null;
};
export type ClientProfileDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string | null;
  phone: string | null;
  email: string | null;
  verifiedEmail: string | null;
  languageCode: UserLanguageCode;
  authIdentities: ClientProfileAuthIdentityDto[];
  deliveryAddress: ClientProfileDeliveryAddressDto | null;
  innerUserInfo: ClientInnerUserInfoDto;
};
export type AuthenticatedClientTelegramUserDataDto = {
  allowsWriteToPm: boolean | null;
  firstName: string;
  isBot: boolean | null;
  isPremium: boolean | null;
  lastName: string | null;
  languageCode: string | null;
  photoUrl: string | null;
  username: string | null;
  innerUserInfo: ClientInnerUserInfoDto;
  auth: TokenPairDto;
  profile: ClientProfileDto | null;
};
export type ClientTelegramLoginDto = {
  channel?: Channel;
  utmCampaignId?: string | null;
};
export type ClientUserDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  languageCode: UserLanguageCode;
  firstName: string | null;
  lastName: string | null;
  telegramUsername: string | null;
  wasLinked: boolean;
  telegramInfo: UserTelegramInfoDto | null;
  maxInfo: UserMaxInfoDto | null;
  acceptedClientDocuments: boolean;
  isSubscribedToMailings: boolean;
  bonusBalance: number;
};
export type AuthenticatedClientMaxUserDataDto = {
  firstName: string;
  lastName: string | null;
  languageCode: string | null;
  photoUrl: string | null;
  username: string | null;
  innerUserInfo: ClientInnerUserInfoDto;
  auth: TokenPairDto;
  profile: ClientProfileDto | null;
};
export type ClientMaxLoginDto = {
  channel?: Channel;
  utmCampaignId?: string | null;
};
export type RefreshTokenDto = {
  refreshToken: string;
};
export type ClientOAuthStartResponseDto = {
  authorizationUrl: string;
  state: string;
  expiresInSeconds: number;
};
export type ClientOAuthStartDto = {
  languageCode?: UserLanguageCode;
};
export type ClientOAuthCallbackResponseDto = {
  firstName: string | null;
  lastName: string | null;
  username: string | null;
  photoUrl: string | null;
  innerUserInfo: ClientInnerUserInfoDto;
  auth: TokenPairDto;
  profile: ClientProfileDto | null;
};
export type ClientOAuthCallbackDto = {
  state: string;
  code?: string;
  deviceId?: string;
  channel?: Channel;
  utmCampaignId?: string | null;
};
export type MagicAuthRequestResponseDto = {
  codeId: string;
  expiresAt: string;
  retryAt: string;
};
export type MagicAuthRequestDto = {
  email: string;
  languageCode?: UserLanguageCode;
};
export type ClientMagicAuthResponseDto = {
  innerUserInfo: ClientInnerUserInfoDto;
  auth: TokenPairDto;
  profile: ClientProfileDto;
};
export type ClientMagicAuthVerifyDto = {
  codeId: string;
  code: string;
  channel?: Channel;
  utmCampaignId?: string | null;
};
export type ClientUpdateUserDto = {
  languageCode?: UserLanguageCode;
  isSubscribedToMailings?: boolean;
};
export type AdvertisingBannerShowDatesDto = {
  start: string;
  end: string;
};
export type AdvertisingBannerPreviewPhotoDto = {
  objectName: string;
  compressedObjectName: string;
  compressedObjectNameWebp500x500q70: string;
  displayName: string;
  bucketName: string;
};
export type AdvertisingBannerDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  status: AdvertisingBannerStatusEnum;
  useShowDates: boolean;
  sortOrder: number;
  showDates: AdvertisingBannerShowDatesDto | null;
  previewPhoto: AdvertisingBannerPreviewPhotoDto;
};
export type ChainLogoDto = {
  originalObjectName: string;
  compressedObjectName: string;
  bucketName: string;
  displayName: string;
};
export type ChainBrandLogoDto = {
  originalObjectName: string;
  bucketName: string;
  displayName: string;
};
export type ChainBrandPhotoDto = {
  originalObjectName: string;
  bucketName: string;
  displayName: string;
};
export type ChainBannerPhotoDesktopDto = {
  originalObjectName: string;
  bucketName: string;
  displayName: string;
};
export type ChainBannerPhotoAdaptiveDto = {
  originalObjectName: string;
  bucketName: string;
  displayName: string;
};
export type ChainAboutUsPhotoDesktopDto = {
  originalObjectName: string;
  bucketName: string;
  displayName: string;
};
export type ChainAboutUsPhotoAdaptiveDto = {
  originalObjectName: string;
  bucketName: string;
  displayName: string;
};
export type ChainThemeDto = {
  style: ChainThemeStyle;
  accentColor: string;
  firstColor: string;
  secondColor: string;
  thirdColor: string;
  analogColor: string;
  name: ChainThemeEnum;
};
export type ChainBonusSystemOptionsDto = {
  redemptionPercent: number;
  accrualPercent: number;
  bonusesPerCurrencyUnit: number;
};
export type ClientChainSettingsDto = {
  cutleryEnabled: boolean;
  currency: ChainCurrencyEnum;
  commentsEnabled: boolean;
  leaveOrderAtDoorOptionEnabled: boolean;
  eatAtPlaceOptionEnabled: boolean;
  recommendationsEnabled: boolean;
  noCallIsNeededOptionEnabled: boolean;
  showDescription: boolean;
  showBrandLogo: boolean;
  isOrderForAnotherPersonEnabled: boolean;
  isBonusSystemEnabled: boolean;
  handleStocks: boolean;
  theme: ChainThemeDto;
  bonusSystem: ChainBonusSystemOptionsDto | null;
  itemPhotoType: ItemPhotoTypeEnum;
};
export type ClientChainDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  description: string | null;
  botUsername: string;
  telegramBotUsername: string | null;
  maxBotUsername: string | null;
  hasTelegram: boolean;
  hasMax: boolean;
  contactPhone: string | null;
  contactEmail: string | null;
  websiteUrl: string | null;
  appUrl: string;
  domain: string | null;
  webUrl: string | null;
  acceptedOwnerDocuments: boolean;
  telegramUsername: string | null;
  maxUsername: string | null;
  logo: ChainLogoDto | null;
  brandLogo: ChainBrandLogoDto | null;
  brandPhoto: ChainBrandPhotoDto | null;
  bannerPhotoDesktop: ChainBannerPhotoDesktopDto | null;
  bannerPhotoAdaptive: ChainBannerPhotoAdaptiveDto | null;
  aboutUsPhotoDesktop: ChainAboutUsPhotoDesktopDto | null;
  aboutUsPhotoAdaptive: ChainAboutUsPhotoAdaptiveDto | null;
  hasActiveSubscription: boolean;
  hasLegalInfo: boolean;
  settings: ClientChainSettingsDto;
};
export type FrontendEventDto = {
  clientEventId: string;
  type: Type;
  platform: Platform;
  channel?: Channel;
  utmCampaignId?: string | null;
  occurredAt: string;
};
export type RecordEventsRequestDto = {
  events: FrontendEventDto[];
};
export type TimeSegmentDto = {
  hours: number;
  minutes: number;
};
export type DailyTimeslotDto = {
  start: TimeSegmentDto;
  end: TimeSegmentDto;
  date: string;
};
export type LocationScheduleDto = {
  asapAvailable: boolean;
  dailyTimeslots: DailyTimeslotDto[];
};
export type LocationPointDto = {
  lat: number;
  lng: number;
};
export type DeliveryZonePricingConditionDto = {
  min: number;
  max: number;
  deliveryPrice: number;
};
export type LocationDeliveryZoneDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  polygonPoints: LocationPointDto[];
  name: string;
  status: LocationDeliveryZoneStatusEnum;
  color: string;
  pricingConditions: DeliveryZonePricingConditionDto[];
};
export type ScheduleTimeslotDto = {
  work: boolean;
  start: TimeSegmentDto | null;
  end: TimeSegmentDto | null;
  endsNextDay: boolean;
};
export type WeeklyScheduleDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  monday: ScheduleTimeslotDto;
  tuesday: ScheduleTimeslotDto;
  wednesday: ScheduleTimeslotDto;
  thursday: ScheduleTimeslotDto;
  friday: ScheduleTimeslotDto;
  saturday: ScheduleTimeslotDto;
  sunday: ScheduleTimeslotDto;
};
export type ClientOnlinePaymentDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  provider: OnlinePaymentProviderEnum;
  sendReceipts: boolean;
  sendReceiptsByEmail: boolean;
};
export type LocationNationwideDeliveryOptionsDto = {
  active: boolean;
  price: number | null;
};
export type ClientLocationDeliveryServiceConfigDto = {
  isActive: boolean;
  orderOnTime: boolean | null;
  averageCookingTimeMinutes: number | null;
  paymentTypes: PaymentTypeEnum[];
  orderPeriod: LocationOrderPeriodEnum;
  onlinePayment: ClientOnlinePaymentDto | null;
  nationwide: LocationNationwideDeliveryOptionsDto;
};
export type ClientLocationTakeoutServiceConfigDto = {
  isActive: boolean;
  orderOnTime: boolean | null;
  averageCookingTimeMinutes: number | null;
  paymentTypes: PaymentTypeEnum[];
  orderPeriod: LocationOrderPeriodEnum;
  onlinePayment: ClientOnlinePaymentDto | null;
  reservationEnabled: boolean;
};
export type ClientLocationOrderPointServiceConfigDto = {
  isActive: boolean;
  orderOnTime: boolean | null;
  averageCookingTimeMinutes: number | null;
  paymentTypes: PaymentTypeEnum[];
  orderPeriod: LocationOrderPeriodEnum;
  onlinePayment: ClientOnlinePaymentDto | null;
  isCDEKActive: boolean;
  deliveryPrice: number;
};
export type ClientLocationDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  /** Name of the location */
  name: string;
  /** Address of the location */
  address: string;
  coordinates: LocationPointDto;
  areManualCoordinates: boolean;
  timezoneOffsetSeconds: number;
  /** Status of the location */
  status: LocationStatusEnum;
  /** Delivery zones */
  deliveryZones: LocationDeliveryZoneDto[];
  deliveryWorkSchedule: WeeklyScheduleDto | null;
  takeoutWorkSchedule: WeeklyScheduleDto | null;
  /** Delivery configuration */
  delivery: ClientLocationDeliveryServiceConfigDto | null;
  /** Takeout configuration */
  takeout: ClientLocationTakeoutServiceConfigDto | null;
  /** Order point configuration */
  orderPoint: ClientLocationOrderPointServiceConfigDto | null;
};
export type ClientOptimalDeliveryZoneDto = {
  deliveryZone: LocationDeliveryZoneDto;
  deliveryPrice: number;
  commentsEnabled: boolean;
  availablePaymentTypes: PaymentTypeEnum[];
  orderOnTimeEnabled: boolean;
  averageCookingTime: number;
  location: ClientLocationDto;
};
export type ClientNationwideInfoDto = {
  deliveryPrice: number;
  location: ClientLocationDto;
};
export type ClientOptimalDeliveryZoneInfoDto = {
  mergedSchedule: LocationScheduleDto;
  deliveryZone: ClientOptimalDeliveryZoneDto | null;
  nationwideInfo: ClientNationwideInfoDto | null;
};
export type PointInputDto = {
  lat: number;
  lng: number;
};
export type CreateOrderItemDto = {
  menuItemId: string;
  variantId?: string;
  /** Quantity of the item, must be at least 1 and maximum 99 */
  quantity: number;
};
export type OrderTimeSlotsAdjustmentInfoDto = {
  orderId?: string;
  locationId?: string;
  orderedItems: CreateOrderItemDto[];
};
export type GetOptimalDeliveryZoneDto = {
  point: PointInputDto;
  orderPrice: number;
  date?: string;
  timeSlotsAdjustmentInfo?: OrderTimeSlotsAdjustmentInfoDto;
};
export type GetLocationScheduleTimeSlotsAdjustmentInfoDto = {
  orderId?: string;
  orderedItems: CreateOrderItemDto[];
};
export type GetLocationScheduleDto = {
  serviceType: ServiceTypeEnum;
  timeSlotsAdjustmentInfo?: GetLocationScheduleTimeSlotsAdjustmentInfoDto;
};
export type FindClosestLocationDto = {
  latitude: number;
  longitude: number;
  isCDEKActive?: boolean;
};
export type OrderPointDimesionsDto = {
  widthCm: number;
  heightCm: number;
  depthCm: number;
};
export type OrderPointAddressDto = {
  countryCode: CountryCode;
  region: string;
  city: string;
  short: string;
  full: string;
};
export type OrderPointLocationDto = {
  longitude: number;
  latitude: number;
  address: OrderPointAddressDto;
};
export type OrderPointScheduleDayTimeDto = {
  hours: number;
  minutes: number;
};
export type OrderPointScheduleDayDto = {
  start: OrderPointScheduleDayTimeDto;
  end: OrderPointScheduleDayTimeDto;
};
export type OrderPointScheduleDto = {
  monday?: OrderPointScheduleDayDto;
  tuesday?: OrderPointScheduleDayDto;
  wednesday?: OrderPointScheduleDayDto;
  thursday?: OrderPointScheduleDayDto;
  friday?: OrderPointScheduleDayDto;
  saturday?: OrderPointScheduleDayDto;
  sunday?: OrderPointScheduleDayDto;
};
export type OrderPointDto = {
  id: string;
  type: OrderPointType;
  pvzType: OrderPointPVZType;
  scheduleString: string;
  weightMinKg: number | null;
  weightMaxKg: number | null;
  dimensions: OrderPointDimesionsDto[];
  location: OrderPointLocationDto;
  schedule: OrderPointScheduleDto;
};
export type OrderPointAreaDto = {
  lowerCorner: PointInputDto;
  upperCorner: PointInputDto;
};
export type FindOrderPointsDto = {
  area: OrderPointAreaDto;
};
export type OrderPointDeliveryPriceDto = {
  price: number;
  minCalendarDays: number;
  maxCalendarDays: number;
};
export type ClientCalculateOrderPointDeliveryPriceDto = {
  orderedItems: CreateOrderItemDto[];
  locationId: string;
};
export type MenuCategoryDisplayTimeDto = {
  hours: number;
  minutes: number;
};
export type MenuCategoryDisplayIntervalDto = {
  /** Start time in UTC+0 */
  start: MenuCategoryDisplayTimeDto;
  /** End time in UTC+0 */
  end: MenuCategoryDisplayTimeDto;
  timezoneOffsetMinutes: number;
};
export type MenuCategoryVariationDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  sortOrder: number;
};
export type MenuCategoryVariationGroupDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  variations: MenuCategoryVariationDto[];
  sortOrder: number;
};
export type ClientMenuCategoryDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  description: string | null;
  displayInterval: MenuCategoryDisplayIntervalDto | null;
  externalSource: MenuExternalSourceEnum | null;
  variationGroups: MenuCategoryVariationGroupDto[];
  isWithinDisplayInterval: boolean | null;
};
export type MenuItemWeightDto = {
  value: number;
  units: WeightUnits;
};
export type MenuItemDimensionsDto = {
  widthCm: number;
  heightCm: number;
  lengthCm: number;
};
export type ExternalPhotoSizesDto = {
  big?: string;
  c516x688?: string;
  c246x328?: string;
  square?: string;
  tm?: string;
};
export type ExternalPhotoDto = {
  url: string;
  sizes: ExternalPhotoSizesDto;
};
export type MenuItemExternalInfoDto = {
  source: MenuExternalSourceEnum | null;
  imageUrls: string[];
  croppedImageUrls: string[];
  imagePhotos: ExternalPhotoDto[];
  vendorCode: string | null;
  brand: string | null;
  averageRating: number | null;
  feedbackCount: number | null;
  itemUrl: string | null;
};
export type MinioMenuPhotoDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  bucketName: string;
  objectName: string;
  compressedObjectName: string;
  compressedObjectNameWebp500x500q90: string;
  compressedObjectNameWebp500x500q70: string;
  compressedObjectNameWebp300x300q70: string;
};
export type MenuItemVariationDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  sortOrder: number;
  isActive: boolean;
};
export type MenuItemVariationGroupDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  variations: MenuItemVariationDto[];
  sortOrder: number;
  isActive: boolean;
};
export type MenuItemPropertyDto = {
  categoryPropId: string;
  name: string;
  value: string | number | string[] | number[];
  unit?: string;
};
export type MenuItemVariantExternalInfoDto = {
  source: MenuExternalSourceEnum | null;
  imageUrls: string[];
  imagePhotos: ExternalPhotoDto[];
};
export type ClientMenuItemVariantDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  variationIds: string[];
  oldPrice: number | null;
  isActive: boolean;
  stockQuantity: number;
  weight: MenuItemWeightDto | null;
  dimensions: MenuItemDimensionsDto | null;
  externalInfo: MenuItemVariantExternalInfoDto;
  photos: MinioMenuPhotoDto[];
  price: number;
};
export type ClientMenuItemDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  description: string | null;
  price: number | null;
  oldPrice: number | null;
  isVariable: boolean;
  isAvailable: boolean;
  stockQuantity: number;
  weight: MenuItemWeightDto | null;
  dimensions: MenuItemDimensionsDto | null;
  externalInfo: MenuItemExternalInfoDto;
  photos: MinioMenuPhotoDto[];
  previewPhotoUrl: string | null;
  variationGroups: MenuItemVariationGroupDto[];
  properties: MenuItemPropertyDto[];
  categoryId: string;
  variants: ClientMenuItemVariantDto[];
  isWithinDisplayInterval: boolean | null;
};
export type ArchivedMenuItemVariantData = {
  groupId: string;
  groupName: string;
  variationId: string;
  variationName: string;
};
export type ArchivedMinioPhotoDto = {
  id: string;
  createdAt: string;
  bucketName: string;
  objectName: string;
  compressedObjectName: string | null;
  compressedObjectNameWebp500x500q90: string | null;
  compressedObjectNameWebp500x500q70: string | null;
  compressedObjectNameWebp300x300q70: string | null;
};
export type ArchivedMenuItemVariantDto = {
  id: string;
  price: number;
  oldPrice: number | null;
  isActive: boolean;
  weight: MenuItemWeightDto | null;
  dimensions: MenuItemDimensionsDto | null;
  externalInfo: MenuItemVariantExternalInfoDto;
  data: ArchivedMenuItemVariantData[];
  photos: ArchivedMinioPhotoDto[] | null;
};
export type ArchivedMenuItemCategoryDto = {
  id: string;
  name: string;
  displayInterval: MenuCategoryDisplayIntervalDto | null;
};
export type ArchivedMenuItemDto = {
  id: string;
  price: number | null;
  oldPrice: number | null;
  discountPrice: number | null;
  quantity: number;
  name: string;
  weight: MenuItemWeightDto | null;
  dimensions: MenuItemDimensionsDto | null;
  description: string | null;
  externalInfo: MenuItemExternalInfoDto;
  variant?: ArchivedMenuItemVariantDto | null;
  category: ArchivedMenuItemCategoryDto;
  photos: ArchivedMinioPhotoDto[];
};
export type OrderClientAuthIdentityDto = {
  provider: GlobalUserAuthProvider;
  login: string;
};
export type ArchivedLocationDto = {
  id: string;
  address: string;
  name: string;
  areManualCoordinates: boolean;
  point: LocationPointDto;
  timezoneOffsetSeconds: number;
};
export type OrderDeliveryAddressDto = {
  address: string | null;
  street: string | null;
  house: string | null;
  city: string | null;
  entranceway: string | null;
  floor: string | null;
  apartment: string | null;
  intercom: string | null;
};
export type ArchivedOrderPointDto = {
  id: string;
  type: OrderPointType;
  pvzType: OrderPointPVZType;
  scheduleString: string;
  location: OrderPointLocationDto;
  schedule: OrderPointScheduleDto;
};
export type PromocodeValidityPeriodDto = {
  begin: string;
  end: string;
};
export type ArchivedPromocodeDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  isActivated: boolean;
  isActive: boolean;
  name: string;
  type: PromocodeType;
  code: string;
  discount: number;
  validityPeriod: PromocodeValidityPeriodDto | null;
  currentUses: number;
  telegramCurrentUses: number;
  maxCurrentUses: number;
  webCurrentUses: number;
  telegramNumRedirects: string;
  maxNumRedirects: string;
  webNumRedirects: string;
  maxUses: number | null;
  maxUsesPerUser: number | null;
  minOrdersSum: number | null;
  qrCodeImageUrl: string | null;
  telegramQRCodeImageUrl: string | null;
  maxQRCodeImageUrl: string | null;
  webQRCodeImageUrl: string | null;
  url: string | null;
  telegramUrl: string | null;
  maxUrl: string | null;
  webUrl: string | null;
};
export type ClientOrderDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  webApp: WebAppEnum;
  locationId: string;
  deliveryZoneId: string | null;
  orderedItems: ArchivedMenuItemDto[];
  totalPrice: number;
  deliveryPrice: number;
  totalDiscount: number | null;
  totalBonusDiscount: number;
  baseBonusDiscount: number;
  bonuses: number;
  spentBonuses: number;
  status: OrderStatus;
  customerContact: string;
  emailForReceipts: string | null;
  customerName: string;
  anotherCustomerContact: string | null;
  anotherCustomerName: string | null;
  isForAnotherPerson: boolean;
  customerDeliveryCoordinates: LocationPointDto | null;
  areDeliveryCoordinatesManual: boolean;
  serviceType: ServiceTypeEnum;
  paymentType: PaymentTypeEnum;
  deliveryType: DeliveryTypeEnum | null;
  orderNumber: string;
  customerTelegramUsername: string | null;
  clientAuthIdentities: OrderClientAuthIdentityDto[];
  clientVerifiedEmail: string | null;
  commentary: string | null;
  date: string | null;
  confirmationUrl: string | null;
  receiptUrl: string | null;
  onlinePaymentStatus: OrderOnlinePaymentStatusEnum;
  location: ArchivedLocationDto;
  cutleryQuantity?: number | null;
  currency: ChainCurrencyEnum;
  leaveAtDoor: boolean;
  eatAtPlace: boolean;
  noCallIsNeeded: boolean;
  address: OrderDeliveryAddressDto;
  orderPoint: ArchivedOrderPointDto | null;
  promocode: ArchivedPromocodeDto | null;
};
export type OrderCustomerInfoDto = {
  /** Phone number for customer contact */
  phone: string;
  /** Customer's name */
  name: string;
};
export type CreateTakeoutOrderDto = {
  orderedItems: CreateOrderItemDto[];
  webApp?: WebAppEnum;
  promocodeId?: string;
  cutleryQuantity?: number;
  leaveAtDoor?: boolean;
  eatAtPlace?: boolean;
  noCallIsNeeded?: boolean;
  paymentType: PaymentTypeEnum;
  commentary?: string;
  date?: string;
  signDocuments?: boolean;
  subscribeToMailings?: boolean;
  isForAnotherPerson?: boolean;
  emailForReceipts?: string;
  customerInfo?: OrderCustomerInfoDto;
  anotherCustomerInfo?: OrderCustomerInfoDto;
  spendBonuses?: boolean;
  channel?: Channel;
  utmCampaignId?: string | null;
  /** Unique identifier of the location */
  locationId: string;
};
export type DeliveryOrderInfoDto = {
  address: string;
  street?: string;
  city?: string;
  house?: string;
  point: PointInputDto;
  areManualCoordinates?: boolean;
  entranceway?: string;
  floor?: string;
  apartment?: string;
  intercom?: string;
};
export type CreateDeliveryOrderCitywideDto = {
  orderedItems: CreateOrderItemDto[];
  webApp?: WebAppEnum;
  promocodeId?: string;
  cutleryQuantity?: number;
  leaveAtDoor?: boolean;
  noCallIsNeeded?: boolean;
  paymentType: PaymentTypeEnum;
  commentary?: string;
  date?: string;
  signDocuments?: boolean;
  subscribeToMailings?: boolean;
  isForAnotherPerson?: boolean;
  emailForReceipts?: string;
  customerInfo?: OrderCustomerInfoDto;
  anotherCustomerInfo?: OrderCustomerInfoDto;
  spendBonuses?: boolean;
  channel?: Channel;
  utmCampaignId?: string | null;
  /** Unique identifier of the delivery zone */
  deliveryZoneId: string;
  deliveryInfo: DeliveryOrderInfoDto;
};
export type CreateDeliveryOrderNationwideDto = {
  orderedItems: CreateOrderItemDto[];
  webApp?: WebAppEnum;
  promocodeId?: string;
  cutleryQuantity?: number;
  noCallIsNeeded?: boolean;
  paymentType: PaymentTypeEnum;
  commentary?: string;
  signDocuments?: boolean;
  subscribeToMailings?: boolean;
  isForAnotherPerson?: boolean;
  emailForReceipts?: string;
  customerInfo?: OrderCustomerInfoDto;
  anotherCustomerInfo?: OrderCustomerInfoDto;
  spendBonuses?: boolean;
  channel?: Channel;
  utmCampaignId?: string | null;
  locationId: string;
  deliveryInfo: DeliveryOrderInfoDto;
};
export type OrderPointInfoDto = {
  id: string;
  type: OrderPointType;
};
export type CreateOrderFromOrderPoint = {
  orderedItems: CreateOrderItemDto[];
  webApp?: WebAppEnum;
  promocodeId?: string;
  cutleryQuantity?: number;
  noCallIsNeeded?: boolean;
  paymentType: PaymentTypeEnum;
  commentary?: string;
  signDocuments?: boolean;
  subscribeToMailings?: boolean;
  isForAnotherPerson?: boolean;
  emailForReceipts?: string;
  customerInfo?: OrderCustomerInfoDto;
  anotherCustomerInfo?: OrderCustomerInfoDto;
  spendBonuses?: boolean;
  channel?: Channel;
  utmCampaignId?: string | null;
  locationId: string;
  orderPointInfo: OrderPointInfoDto;
};
export type OrderBonusInfoDto = {
  /** The number of received bonuses */
  accruedBonuses: number;
  /** The number of spent bonuses */
  spentBonuses: number;
  /** The amount of money applied as a discount */
  bonusDiscount: number;
};
export type GetBonusInfoForOrderCreation = {
  orderedItems: CreateOrderItemDto[];
  promocodeId?: string;
  spendBonuses?: boolean;
};
export type LegalDocumentVersionDto = {
  major: number;
  minor: number;
};
export type ChainGeneratedLegalDocumentDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  version: LegalDocumentVersionDto;
  url: string;
  type: ChainGeneratedLegalDocumentEnum;
};
export type ChainGeneratedLegalDocumentsDto = {
  privacyPolicy: ChainGeneratedLegalDocumentDto | null;
  consentToPersonalDataProcessing: ChainGeneratedLegalDocumentDto | null;
  termsOfUse: ChainGeneratedLegalDocumentDto | null;
};
export type ReservationLocationDto = {
  id: string;
  name: string;
  timezoneOffsetMinutes: number;
};
export type ReservationPaymentInfoDto = {
  link: string;
  price: number;
  waitTo: string;
  status: ReservationPaymentStatusEnum;
};
export type ReservationDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  phoneNumber: string;
  number: number;
  status: ReservationStatusEnum;
  numVisitors: number | null;
  commentary: string | null;
  from: string;
  to: string;
  location: ReservationLocationDto;
  tableIds: string[];
  payment: ReservationPaymentInfoDto | null;
};
export type SetReservationTimeSlotDto = {
  start: string;
  end: string;
};
export type CreateReservationDto = {
  locationId: string;
  phoneNumber: string;
  timeSlot: SetReservationTimeSlotDto;
  webApp: WebAppEnum;
  tableIds?: string[];
  numVisitors?: number;
  commentary?: string;
};
export type ReservationTimeSlotTableDto = {
  id: string;
  /** How many guests can order this table */
  guestCounts: number[];
};
export type ReservationTimeSlotDto = {
  from: TimeSegmentDto;
  to: TimeSegmentDto;
  date: string;
  tables: ReservationTimeSlotTableDto[];
};
export type ReservationImageDto = {
  id: string;
  image: string;
  imagePreview: string;
};
export type ReservationTableDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  floorId: string;
  number: number;
  minSeats: number;
  maxSeats: number;
  text: string;
  images: ReservationImageDto[];
};
export type ReservationTablesPageInfoDto = {
  page: number;
  totalPages: number;
  tables: ReservationTableDto[];
};
export type GetReservationTablesByIds = {
  tableIds: string[];
};
export type ReservationDepositDto = {
  deposit: number;
  depositTotal: number;
  depositTip: number;
  depositTax: number;
  depositText: string;
};
export type CalculateReservationDepositDto = {
  timeSlot: SetReservationTimeSlotDto;
  tableIds: string[];
  numVisitors?: number;
};
export type ClientPromocodeDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  isActivated: boolean;
  isActive: boolean;
  name: string;
  type: PromocodeType;
  code: string;
  discount: number;
  validityPeriod: PromocodeValidityPeriodDto | null;
  currentUses: number;
  telegramCurrentUses: number;
  maxCurrentUses: number;
  webCurrentUses: number;
  telegramNumRedirects: string;
  maxNumRedirects: string;
  webNumRedirects: string;
  maxUses: number | null;
  maxUsesPerUser: number | null;
  minOrdersSum: number | null;
  qrCodeImageUrl: string | null;
  telegramQRCodeImageUrl: string | null;
  maxQRCodeImageUrl: string | null;
  webQRCodeImageUrl: string | null;
  url: string;
  telegramUrl: string | null;
  maxUrl: string | null;
  webUrl: string | null;
  currentClientUses: number;
};
export type FindPromocodeDto = {
  code: string;
};
export type PromocodeItemDiscountDto = {
  menuItemId: string;
  variantId: string | null;
  price: number;
  discountPrice: number;
  quantity: number;
};
export type PromocodeDiscountInfoDto = {
  items: PromocodeItemDiscountDto[];
  totalDiscount: number;
};
export type CalculatePromocodeDiscountDto = {
  orderedItems: CreateOrderItemDto[];
  type: PromocodeType;
  discount: number;
};
export type UpdateClientProfileDto = {
  languageCode?: UserLanguageCode;
};
export type ClientEmailVerificationRequestDto = {
  email: string;
  webApp: EmailVerificationWebApp;
};
export type ClientEmailVerificationResultDto = {
  verified: boolean;
};
export type ClientEmailVerificationVerifyDto = {
  codeId: string;
  code: string;
};
export type ReservationByUrlIntegrationDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  url: string;
};
export type CdekIntegrationDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  comment: string | null;
};
export type ClientWildberriesSellerInfoDto = {
  name: string | null;
  trademark: string | null;
  valuation: number | null;
  feedbackCount: number | null;
  registrationDate: string | null;
  totalOrders: string | null;
  lastSyncedAt: string | null;
};
export type ClientAccountLinkVerificationCodeDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  expiresAt: string;
  code: string;
};
export type ClientLinkAccontDto = {
  code: string;
};
export type ClientStartAppResponseDto = {
  handled: boolean;
  type: Type2 | null;
};
export type ClientStartAppRequestDto = {
  startApp: string;
  webApp: WebApp;
};
export type ManagementUserInnerInfoDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  languageCode: UserLanguageCode;
  firstName: string | null;
  lastName: string | null;
  telegramUsername: string | null;
  wasLinked: boolean;
  telegramInfo: UserTelegramInfoDto | null;
  maxInfo: UserMaxInfoDto | null;
  acceptedManagerDocuments: boolean;
  hasChains: boolean;
};
export type ManagementProfileAuthIdentityDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  provider: GlobalUserAuthProvider;
  providerSubject: string;
  login: string;
  providerUsername: string | null;
  providerEmail: string | null;
  providerPhone: string | null;
  providerFirstName: string | null;
  providerLastName: string | null;
  providerPhotoUrl: string | null;
};
export type ManagementProfileDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string | null;
  phone: string | null;
  email: string | null;
  verifiedEmail: string | null;
  languageCode: UserLanguageCode;
  canCreateChains: boolean;
  authIdentities: ManagementProfileAuthIdentityDto[];
  innerUserInfo: ManagementUserInnerInfoDto;
};
export type AuthenticatedTelegramUserDataDto = {
  allowsWriteToPm: boolean | null;
  firstName: string;
  isBot: boolean | null;
  isPremium: boolean | null;
  lastName: string | null;
  languageCode: string | null;
  photoUrl: string | null;
  username: string | null;
  innerUserInfo: ManagementUserInnerInfoDto;
  auth: TokenPairDto;
  profile: ManagementProfileDto;
};
export type TelegramInitDataDto = {
  /** Telegram InitData (raw string) */
  initData: string;
};
export type TelegramBotVerificationDto = {
  id: number;
  username: string;
  firstName: string;
};
export type VerifyTelegramBotTokenDto = {
  /** Telegram bot token */
  token: string;
};
export type ManagementUserDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  languageCode: UserLanguageCode;
  firstName: string | null;
  lastName: string | null;
  telegramUsername: string | null;
  wasLinked: boolean;
  telegramInfo: UserTelegramInfoDto | null;
  maxInfo: UserMaxInfoDto | null;
  acceptedManagerDocuments: boolean;
};
export type AuthenticatedMaxUserDataDto = {
  firstName: string;
  lastName: string | null;
  username: string | null;
  languageCode: string;
  photoUrl: string | null;
  innerUserInfo: ManagementUserInnerInfoDto;
  auth: TokenPairDto;
  profile: ManagementProfileDto;
};
export type ManagementOAuthStartResponseDto = {
  authorizationUrl: string;
  state: string;
  expiresInSeconds: number;
};
export type ManagementOAuthStartDto = {
  languageCode?: UserLanguageCode;
};
export type ManagementOAuthCallbackResponseDto = {
  firstName: string | null;
  lastName: string | null;
  username: string | null;
  photoUrl: string | null;
  innerUserInfo: ManagementUserInnerInfoDto;
  auth: TokenPairDto;
  profile: ManagementProfileDto;
};
export type ManagementOAuthCallbackDto = {
  state: string;
  code?: string;
  deviceId?: string;
};
export type ManagementMagicAuthResponseDto = {
  innerUserInfo: ManagementUserInnerInfoDto;
  auth: TokenPairDto;
  profile: ManagementProfileDto;
};
export type MagicAuthVerifyDto = {
  codeId: string;
  code: string;
};
export type ManagementUpdateUserDto = {
  languageCode?: UserLanguageCode;
  isSubscribedToMailings?: boolean;
};
export type ShowDatesDto = {
  start: string;
  end: string;
};
export type CreatePreviewPhoto = {
  objectName: string;
  compressedObjectName: string;
  compressedObjectNameWebp500x500q70: string;
  displayName: string;
};
export type CreateAdvertisingBannerDto = {
  id?: string;
  name: string;
  status: AdvertisingBannerStatusEnum;
  useShowDates: boolean;
  showDates?: ShowDatesDto;
  previewPhoto: CreatePreviewPhoto;
};
export type MinioBufferInfoDto = {
  bucketName: string;
  objectName: string;
  url: string;
  sizeBytes: number;
  mimetype: string;
};
export type AdvertisingBannerUploadPreviewPhotoInfoDto = {
  bannerId: string;
  originalPhoto: MinioBufferInfoDto;
  compressedPhoto: MinioBufferInfoDto;
  compressedWebp500x500q70: MinioBufferInfoDto;
};
export type UploadAdvertisingBannerPreviewPhotoDto = {
  id?: string;
  image: Blob;
};
export type UpdateAdvertisingBannerDto = {
  name?: string;
  status?: AdvertisingBannerStatusEnum;
  useShowDates?: boolean;
  showDates?: ShowDatesDto;
  previewPhoto?: CreatePreviewPhoto;
};
export type ReorderAdvertisingBannersDto = {
  ids: string[];
};
export type UtmCampaignDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  appUrl: string;
  numRedirects: number;
  totalRedirects: number;
  webApp: WebAppEnum;
  campaign: string | null;
  source: string | null;
  medium: string | null;
};
export type CreateUtmCampaignDto = {
  name: string;
  webApp?: WebAppEnum;
  campaign?: string;
  source?: string;
  medium?: string;
};
export type UpdateUtmCampaignDto = {
  name?: string;
};
export type UtmPerCampaignStatDto = {
  id: string;
  name: string;
  campaign: string | null;
  source: string | null;
  medium: string | null;
  totalRedirects: number;
  uniqueRedirects: number;
};
export type UtmAggregatedRowDto = {
  value: string;
  totalRedirects: number;
  uniqueRedirects: number;
};
export type UtmAggregatedStatsDto = {
  byCampaign: UtmAggregatedRowDto[];
  bySource: UtmAggregatedRowDto[];
  byMedium: UtmAggregatedRowDto[];
};
export type UtmLinkStatsDto = {
  linkType: LinkTypeEnum;
  webApp: WebAppEnum;
  perCampaign: UtmPerCampaignStatDto[];
  aggregated: UtmAggregatedStatsDto;
};
export type PromocodePerCodeStatDto = {
  id: string;
  code: string;
  name: string;
  numRedirects: number;
  currentUses: number;
};
export type PromocodeLinkStatsDto = {
  linkType: LinkTypeEnum;
  webApp: WebAppEnum;
  perPromocode: PromocodePerCodeStatDto[];
};
export type LinkStatsRequestDto = {
  linkType: LinkTypeEnum;
  webApp: WebAppEnum;
};
export type ManagementChainCurrentStaffMemberInfoDto = {
  role: StaffRoleEnum;
};
export type ManagementChainSettingsDto = {
  cutleryEnabled: boolean;
  currency: ChainCurrencyEnum;
  commentsEnabled: boolean;
  leaveOrderAtDoorOptionEnabled: boolean;
  eatAtPlaceOptionEnabled: boolean;
  recommendationsEnabled: boolean;
  noCallIsNeededOptionEnabled: boolean;
  showDescription: boolean;
  showBrandLogo: boolean;
  isOrderForAnotherPersonEnabled: boolean;
  isBonusSystemEnabled: boolean;
  handleStocks: boolean;
  theme: ChainThemeDto;
  bonusSystem: ChainBonusSystemOptionsDto | null;
  itemPhotoType: ItemPhotoTypeEnum;
};
export type ManagementChainOnlinePaymentSettingsDto = {
  vatCode: OnlinePaymentVatCode;
  paymentSubject: OnlinePaymentSubject;
};
export type ChainLegalInfoRussiaDto = {
  phoneNumber: string;
  name: string;
  inn: string;
  ogrn: string;
  legalAddress: string;
  email: string;
};
export type ChainLegalInfoMontenegroDto = {
  phoneNumber: string;
  name: string;
  registrationNumber: string;
  legalAddress: string;
  email: string;
};
export type ChainLegalInfoDto = {
  type: ChainLegalInfoEnum;
  info: ChainLegalInfoRussiaDto | ChainLegalInfoMontenegroDto;
};
export type ChainSubscriptionLimitsDto = {
  maxOrdersSum: number;
  currentOrdersSum: number;
  maxCancellationsWithReturn: number;
  currentCancellationsWithReturn: number;
};
export type ChainSubscriptionPaymentDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  url: string;
  price: number;
  status: ChainSubscriptionPaymentStatusEnum;
  isAuto: boolean;
};
export type ManagementChainSubscriptionDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  renewDate: string;
  isActive: boolean;
  isWaitingForPayment: boolean;
  isAutoRenewalActive: boolean;
  subscriptionDate: string;
  expirationDate: string | null;
  gracePeriodDays: number;
  duration: ChainSubscriptionDurationEnum;
  level: ChainSubcriptionLevelEnum;
  nextDuration: ChainSubscriptionDurationEnum;
  nextLevel: ChainSubcriptionLevelEnum;
  lastPrice: number;
  nextPrice: number;
  limits: ChainSubscriptionLimitsDto | null;
  lastPayment: ChainSubscriptionPaymentDto | null;
};
export type ManagementChainDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  description: string | null;
  botUsername: string;
  telegramBotUsername: string | null;
  maxBotUsername: string | null;
  hasTelegram: boolean;
  hasMax: boolean;
  contactPhone: string | null;
  contactEmail: string | null;
  websiteUrl: string | null;
  appUrl: string;
  domain: string | null;
  webUrl: string | null;
  acceptedOwnerDocuments: boolean;
  telegramUsername: string | null;
  maxUsername: string | null;
  logo: ChainLogoDto | null;
  brandLogo: ChainBrandLogoDto | null;
  brandPhoto: ChainBrandPhotoDto | null;
  bannerPhotoDesktop: ChainBannerPhotoDesktopDto | null;
  bannerPhotoAdaptive: ChainBannerPhotoAdaptiveDto | null;
  aboutUsPhotoDesktop: ChainAboutUsPhotoDesktopDto | null;
  aboutUsPhotoAdaptive: ChainAboutUsPhotoAdaptiveDto | null;
  status: ChainStatusEnum;
  unsignedOwnerDocumentsExpirationDate: string | null;
  currentStaffMemberInfo: ManagementChainCurrentStaffMemberInfoDto;
  settings: ManagementChainSettingsDto;
  onlinePaymentSettings: ManagementChainOnlinePaymentSettingsDto | null;
  legalInfo: ChainLegalInfoDto | null;
  subscription: ManagementChainSubscriptionDto | null;
};
export type ManagementChainStatsDto = {
  numActiveOrders: number;
  numRecommendations: number;
};
export type ExtendedChainDto = {
  chain: ManagementChainDto;
  stats: ManagementChainStatsDto;
};
export type CreateChainDto = {
  /** Chain name */
  name?: string;
  /** Bot token for Telegram or Max chains */
  botToken?: string;
  /** Browser chain full domain (e.g. gly.ru or shop.botly.one) */
  domain?: string;
  /** Is the user creating the chain the owner */
  isOwner?: boolean;
  webApp?: WebAppEnum;
};
export type CreateChainPhotoDto = {
  objectName: string;
  compressedObjectName: string;
  displayName: string;
};
export type CreateChainBrandLogoDto = {
  objectName: string;
  displayName: string;
};
export type CreateChainBrandPhotoDto = {
  objectName: string;
  displayName: string;
};
export type CreateChainBannerPhotoDesktopDto = {
  objectName: string;
  displayName: string;
};
export type CreateChainBannerPhotoAdaptiveDto = {
  objectName: string;
  displayName: string;
};
export type CreateChainAboutUsPhotoDesktopDto = {
  objectName: string;
  displayName: string;
};
export type CreateChainAboutUsPhotoAdaptiveDto = {
  objectName: string;
  displayName: string;
};
export type ChainGeneralOnlinePaymentSettingsDto = {
  vatCode: OnlinePaymentVatCode;
  paymentSubject: OnlinePaymentSubject;
};
export type UpdateChainDto = {
  logo?: CreateChainPhotoDto | null;
  brandLogo?: CreateChainBrandLogoDto | null;
  brandPhoto?: CreateChainBrandPhotoDto | null;
  bannerPhotoDesktop?: CreateChainBannerPhotoDesktopDto | null;
  bannerPhotoAdaptive?: CreateChainBannerPhotoAdaptiveDto | null;
  aboutUsPhotoDesktop?: CreateChainAboutUsPhotoDesktopDto | null;
  aboutUsPhotoAdaptive?: CreateChainAboutUsPhotoAdaptiveDto | null;
  description?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  websiteUrl?: string | null;
  showDescription?: boolean;
  onlinePaymentSettings?: ChainGeneralOnlinePaymentSettingsDto;
  showBrandLogo?: boolean;
  /** MAX Bot token */
  maxBotToken?: string;
  /** Telegram Bot token */
  telegramBotToken?: string;
  telegramUsername?: string | null;
  maxUsername?: string | null;
  /** Browser chain full domain (e.g. gly.ru or shop.botly.one) */
  domain?: string;
};
export type ChainUploadedBrandLogoImageDto = {
  original: MinioBufferInfoDto;
};
export type ChainUploadedBrandPhotoImageDto = {
  original: MinioBufferInfoDto;
};
export type ChainUploadedBannerPhotoImageDto = {
  desktop: MinioBufferInfoDto | null;
  adaptive: MinioBufferInfoDto | null;
};
export type UpdateChainThemeDto = {
  style?: ChainThemeStyle;
  accentColor?: string;
  firstColor?: string;
  secondColor?: string;
  thirdColor?: string;
  analogColor?: string;
  name?: ChainThemeEnum;
};
export type UpdateChainInformationDto = {
  cutleryEnabled?: boolean;
  currency?: ChainCurrencyEnum;
  commentsEnabled?: boolean;
  leaveOrderAtDoorOptionEnabled?: boolean;
  eatAtPlaceOptionEnabled?: boolean;
  recommendationsEnabled?: boolean;
  noCallIsNeededOptionEnabled?: boolean;
  isOrderForAnotherPersonEnabled?: boolean;
  isBonusSystemEnabled?: boolean;
  handleStocks?: boolean;
  bonusSystem?: boolean;
  theme?: UpdateChainThemeDto;
  itemPhotoType?: ItemPhotoTypeEnum;
};
export type SetChainLegalInfoRussiaDto = {
  type: ChainLegalInfoEnum;
  phoneNumber: string;
  name: string;
  inn: string;
  ogrn: string;
  legalAddress: string;
  email: string;
};
export type SetChainLegalInfoMontenegroDto = {
  type: ChainLegalInfoEnum;
  phoneNumber: string;
  name: string;
  registrationNumber: string;
  legalAddress: string;
  email: string;
};
export type SetChainLegalInfoDto = {
  info: SetChainLegalInfoRussiaDto | SetChainLegalInfoMontenegroDto;
};
export type ChainSavedPaymentMethodDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  type: ChainPaymentMethodType;
  title: string | null;
};
export type ChainPaymentMethodUpdateDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  type: ChainPaymentMethodType;
  status: ChainPaymentMethodUpdateStatusEnum;
  confirmationUrl: string;
};
export type WildberriesSellerInfoSyncedDto = {
  name: string | null;
  trademark: string | null;
  valuation: number | null;
  feedbackCount: number | null;
  lastSyncedAt: string | null;
};
export type WildberriesSellerAnalyticsDto = {
  integrationId: string;
  apiKey: string;
  registrationDate: string | null;
  totalOrders: string | null;
  sellerInfo: WildberriesSellerInfoSyncedDto | null;
};
export type CreateWildberriesSellerAnalyticsDto = {
  apiKey: string;
  registrationDate?: string | null;
  totalOrders?: string | null;
};
export type UpdateWildberriesSellerAnalyticsDto = {
  apiKey?: string;
  totalOrders?: string | null;
};
export type IikoPaymentDto = {
  paymentType: PaymentTypeEnum;
  code: string;
};
export type IikoServiceDto = {
  serviceType: ServiceTypeEnum;
  name: string;
};
export type IikoIntegrationMetadataDto = {
  apiKey: string;
  organizationId: string;
  terminalId: string;
  shouldSyncMenu: boolean;
  syncMenuName: string | null;
  syncInterval: IikoMenuSyncInterval | null;
  payments: IikoPaymentDto[];
  services: IikoServiceDto[];
};
export type CdekIntegrationMetadataDto = {
  clientId: string;
  clientSecret: string;
  comment: string;
  calculateDeliveryPriceViaApi: boolean;
};
export type ReservationByUrlIntegrationMetadataDto = {
  name: string;
  url: string;
};
export type RestoplaceIntegrationMetadataDto = {
  apiKey: string;
  name: string;
};
export type WildberriesIntegrationMetadataDto = {
  apiKey: string;
  itemsImportedAt: string | null;
};
export type WildberriesSellerAnalyticsIntegrationMetadataDto = {
  apiKey: string;
};
export type IntegrationDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  type: IntegrationTypeEnum;
  metadata:
    | IikoIntegrationMetadataDto
    | CdekIntegrationMetadataDto
    | ReservationByUrlIntegrationMetadataDto
    | RestoplaceIntegrationMetadataDto
    | WildberriesIntegrationMetadataDto
    | WildberriesSellerAnalyticsIntegrationMetadataDto;
};
export type StartMenuIikoSync = {
  apiKey: string;
  organizationId: string;
  syncMenuName?: string;
};
export type IikoMenuSyncInfoDto = {
  syncedAt: string | null;
};
export type IikoIntegrationServiceMappingInputDto = {
  type: ServiceTypeEnum;
  name: string;
};
export type IikoIntegrationPaymentMappingInputDto = {
  type: PaymentTypeEnum;
  code: string;
};
export type IntegrateIikoDto = {
  apiKey: string;
  organizationId: string;
  terminalGroupId: string;
  serviceMappings: IikoIntegrationServiceMappingInputDto[];
  paymentMappings: IikoIntegrationPaymentMappingInputDto[];
  shouldSyncMenu?: boolean;
  syncMenuName?: string;
  syncInterval?: IikoMenuSyncInterval;
};
export type UpdateIikoIntegrationDto = {
  serviceMappings?: IikoIntegrationServiceMappingInputDto[];
  paymentMappings?: IikoIntegrationPaymentMappingInputDto[];
  shouldSyncMenu?: boolean;
  syncMenuName?: string;
  syncInterval?: IikoMenuSyncInterval;
};
export type IntegrateCdekDto = {
  clientId: string;
  clientSecret: string;
  comment?: string | null;
  calculateDeliveryPriceViaApi?: boolean;
};
export type UpdateCdekIntegrationDto = {
  comment?: string | null;
  calculateDeliveryPriceViaApi?: boolean;
};
export type IntegrateReservationByUrlDto = {
  url: string;
  name: string;
};
export type UpdateReservationByUrlIntegrationDto = {
  url?: string;
  name?: string;
};
export type IntegrateRestoplaceDto = {
  apiKey: string;
  name: string;
};
export type UpdateRestoplaceIntegrationDto = {
  apiKey?: string;
  name?: string;
};
export type UpsertWildberriesIntegrationDto = {
  apiKey: string;
};
export type WbImportableItemSizeDto = {
  chrtId: number;
  sizeName: string;
  price?: string | null;
  oldPrice?: string | null;
};
export type WbImportableItemCharacteristicDto = {
  id?: number;
  name?: string;
  value?: string | number | (string | number)[];
};
export type WbImportableItemDto = {
  nmId: number;
  imtId?: number;
  name: string;
  subjectName?: string | null;
  description?: string | null;
  price?: string | null;
  oldPrice?: string | null;
  photos: string[];
  vendorCode?: string | null;
  brand?: string | null;
  isVariable: boolean;
  lengthCm?: number | null;
  widthCm?: number | null;
  heightCm?: number | null;
  weightKg?: number | null;
  sizes: WbImportableItemSizeDto[];
  characteristics: WbImportableItemCharacteristicDto[];
};
export type WbImportFailureDto = {
  nmId: number;
  reason: string;
};
export type WbImportSummaryDto = {
  created: number;
  updated: number;
  failed: number;
  failures: WbImportFailureDto[];
  wbItemsImportedAt: string;
};
export type OnlinePaymentReceiptInfoDto = {
  taxSystemCode: OnlinePaymentTaxSystemCode;
  paymentMode: OnlinePaymentMode;
  vatCode: OnlinePaymentVatCode;
  paymentSubject: OnlinePaymentSubject;
};
export type ManagementOnlinePaymentDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  provider: OnlinePaymentProviderEnum;
  sendReceipts: boolean;
  sendReceiptsByEmail: boolean;
  shopId: string;
  secretKey: string;
  name: string;
  receiptInfo: OnlinePaymentReceiptInfoDto | null;
};
export type ManagementLocationDeliveryServiceConfigDto = {
  isActive: boolean;
  orderOnTime: boolean | null;
  averageCookingTimeMinutes: number | null;
  paymentTypes: PaymentTypeEnum[];
  orderPeriod: LocationOrderPeriodEnum;
  onlinePayment: ManagementOnlinePaymentDto | null;
  nationwide: LocationNationwideDeliveryOptionsDto;
};
export type ManagementLocationTakeoutServiceConfigDto = {
  isActive: boolean;
  orderOnTime: boolean | null;
  averageCookingTimeMinutes: number | null;
  paymentTypes: PaymentTypeEnum[];
  orderPeriod: LocationOrderPeriodEnum;
  onlinePayment: ManagementOnlinePaymentDto | null;
  reservationEnabled: boolean;
  restoplaceIntegrationId: string | null;
};
export type ManagementLocationOrderPointServiceConfigDto = {
  isActive: boolean;
  orderOnTime: boolean | null;
  averageCookingTimeMinutes: number | null;
  paymentTypes: PaymentTypeEnum[];
  orderPeriod: LocationOrderPeriodEnum;
  onlinePayment: ManagementOnlinePaymentDto | null;
  isCDEKActive: boolean;
  deliveryPrice: number;
  additionalDeliveryDays: number | null;
};
export type ManagementLocationDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  /** Name of the location */
  name: string;
  /** Address of the location */
  address: string;
  coordinates: LocationPointDto;
  areManualCoordinates: boolean;
  timezoneOffsetSeconds: number;
  /** Status of the location */
  status: LocationStatusEnum;
  /** Delivery zones */
  deliveryZones: LocationDeliveryZoneDto[];
  deliveryWorkSchedule: WeeklyScheduleDto | null;
  takeoutWorkSchedule: WeeklyScheduleDto | null;
  /** Delivery configuration */
  delivery: ManagementLocationDeliveryServiceConfigDto | null;
  /** Takeout configuration */
  takeout: ManagementLocationTakeoutServiceConfigDto | null;
  /** Order point configuration */
  orderPoint: ManagementLocationOrderPointServiceConfigDto | null;
};
export type CoordinatesDto = {
  /** Latitude of the location */
  latitude: number;
  /** Longitude of the location */
  longitude: number;
};
export type CreateLocationDto = {
  /** Name of the location */
  name: string;
  /** Address of the location */
  address: string;
  /** Coordinates of the location */
  coordinates: CoordinatesDto;
  areManualCoordinates?: boolean;
  type?: LocationType;
};
export type TimeInputDto = {
  hours: number;
  minutes: number;
};
export type UpdateDateOfTheWeekDto = {
  work: boolean;
  start?: TimeInputDto;
  end?: TimeInputDto;
  endsNextDay?: boolean;
};
export type UpdateLocationScheduleDto = {
  monday?: UpdateDateOfTheWeekDto;
  tuesday?: UpdateDateOfTheWeekDto;
  wednesday?: UpdateDateOfTheWeekDto;
  thursday?: UpdateDateOfTheWeekDto;
  friday?: UpdateDateOfTheWeekDto;
  saturday?: UpdateDateOfTheWeekDto;
  sunday?: UpdateDateOfTheWeekDto;
};
export type UpdateLocationNationwideDeliveryOptionsDto = {
  active: boolean;
  price?: number;
};
export type UpdateLocationDeliveryServiceConfigDto = {
  paymentTypes?: PaymentTypeEnum[];
  isActive?: boolean;
  orderOnTime?: boolean;
  averageCookingTimeMinutes?: number;
  schedule?: UpdateLocationScheduleDto;
  orderPeriod?: LocationOrderPeriodEnum;
  onlinePaymentId?: string | null;
  nationwide?: UpdateLocationNationwideDeliveryOptionsDto;
};
export type UpdateLocationTakeoutServiceConfigDto = {
  paymentTypes?: PaymentTypeEnum[];
  isActive?: boolean;
  orderOnTime?: boolean;
  averageCookingTimeMinutes?: number;
  schedule?: UpdateLocationScheduleDto;
  orderPeriod?: LocationOrderPeriodEnum;
  onlinePaymentId?: string | null;
  reservationEnabled?: boolean;
  restoplaceIntegrationId?: string | null;
};
export type UpdateLocationOrderPointServiceConfigDto = {
  paymentTypes?: PaymentTypeEnum[];
  isActive?: boolean;
  onlinePaymentId?: string | null;
  deliveryPrice?: number;
  isCDEKActive?: boolean;
  additionalDeliveryDays?: number;
};
export type DeliveryZonePricingConditionInputDto = {
  min: number;
  max: number;
  deliveryPrice: number;
};
export type UpdateDeliveryZoneDto = {
  id?: string;
  polygonPoints: PointInputDto[];
  name: string;
  status: LocationDeliveryZoneStatusEnum;
  color: string;
  pricingConditions?: DeliveryZonePricingConditionInputDto[];
};
export type UpdateLocationDto = {
  /** Name of the location */
  name?: string;
  /** Address of the location */
  address?: string;
  /** Coordinates of the location */
  coordinates?: CoordinatesDto;
  areManualCoordinates?: boolean;
  type?: LocationType;
  /** Delivery configuration */
  delivery?: UpdateLocationDeliveryServiceConfigDto;
  /** Takeout configuration */
  takeout?: UpdateLocationTakeoutServiceConfigDto;
  /** Order point configuration */
  orderPoint?: UpdateLocationOrderPointServiceConfigDto;
  status?: LocationStatusEnum;
  deliveryZones?: UpdateDeliveryZoneDto[];
};
export type ManagementCalculateOrderPointDeliveryPriceDto = {
  orderedItems: CreateOrderItemDto[];
  locationId: string;
  orderId?: string;
};
export type MenuCategoryPropertyMetadataDto = {
  type: MenuPropertyType;
  isMultiple: boolean;
  values?: string[];
};
export type MenuCategoryPropertyDto = {
  id: string;
  name: string;
  unit?: string;
  metadata: MenuCategoryPropertyMetadataDto;
};
export type MenuReceiptInfoDto = {
  vatCode?: OnlinePaymentVatCode;
  paymentSubject?: OnlinePaymentSubject;
};
export type MenuCategoryDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  description: string | null;
  displayInterval: MenuCategoryDisplayIntervalDto | null;
  externalSource: MenuExternalSourceEnum | null;
  variationGroups: MenuCategoryVariationGroupDto[];
  sortOrder: number;
  status: MenuCategoryStatus;
  properties: MenuCategoryPropertyDto[];
  receiptInfo: MenuReceiptInfoDto | null;
};
export type CategoryPropertiesDto = {
  name: string;
  type?: MenuPropertyType;
  values?: string[];
  unit?: string;
  isMultiple?: boolean;
};
export type CreateMenuVariationDto = {
  name: string;
};
export type CreateMenuVariationGroupDto = {
  name: string;
  variations: CreateMenuVariationDto[];
};
export type SetMenuCategoryDisplayTimeDto = {
  hours: number;
  minutes: number;
};
export type SetMenuCategoryDisplayIntervalDto = {
  start: SetMenuCategoryDisplayTimeDto;
  end: SetMenuCategoryDisplayTimeDto;
  timezoneOffsetMinutes?: number;
};
export type CreateMenuCategoryDto = {
  name: string;
  description?: string;
  properties?: CategoryPropertiesDto[];
  sortOrder?: number;
  variationGroups?: CreateMenuVariationGroupDto[];
  receiptInfo?: MenuReceiptInfoDto;
  displayInterval?: SetMenuCategoryDisplayIntervalDto | null;
};
export type ExtendedMenuCategoryDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  description: string | null;
  displayInterval: MenuCategoryDisplayIntervalDto | null;
  externalSource: MenuExternalSourceEnum | null;
  variationGroups: MenuCategoryVariationGroupDto[];
  sortOrder: number;
  status: MenuCategoryStatus;
  properties: MenuCategoryPropertyDto[];
  receiptInfo: MenuReceiptInfoDto | null;
  itemsCount: number;
};
export type UpdateMenuVariationDto = {
  name?: string;
  id?: string;
};
export type UpdateMenuVariationGroupDto = {
  name?: string;
  id?: string;
  variations?: UpdateMenuVariationDto[];
};
export type UpdateMenuCategoryPropertiesDto = {
  name: string;
  type?: MenuPropertyType;
  values?: string[];
  unit?: string;
  isMultiple?: boolean;
  id?: string;
};
export type UpdateMenuCategoryDto = {
  name?: string;
  description?: string;
  receiptInfo?: MenuReceiptInfoDto;
  displayInterval?: SetMenuCategoryDisplayIntervalDto | null;
  status?: MenuCategoryStatus;
  variationGroups?: UpdateMenuVariationGroupDto[];
  properties?: UpdateMenuCategoryPropertiesDto[];
};
export type CategoryOrderItemDto = {
  id: string;
  sortOrder: number;
};
export type ReorderCategoriesDto = {
  categories: CategoryOrderItemDto[];
};
export type MenuItemVariantDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  variationIds: string[];
  oldPrice: number | null;
  isActive: boolean;
  stockQuantity: number;
  weight: MenuItemWeightDto | null;
  dimensions: MenuItemDimensionsDto | null;
  externalInfo: MenuItemVariantExternalInfoDto;
  photos: MinioMenuPhotoDto[];
  price: number | null;
  manualIsActive: boolean;
  reservedStockQuantity: number;
};
export type MenuItemDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  description: string | null;
  price: number | null;
  oldPrice: number | null;
  isVariable: boolean;
  isAvailable: boolean;
  stockQuantity: number;
  weight: MenuItemWeightDto | null;
  dimensions: MenuItemDimensionsDto | null;
  externalInfo: MenuItemExternalInfoDto;
  photos: MinioMenuPhotoDto[];
  previewPhotoUrl: string | null;
  variationGroups: MenuItemVariationGroupDto[];
  properties: MenuItemPropertyDto[];
  sortOrder: number;
  status: MenuItemStatusEnum;
  isAddedToRecommendations: boolean;
  manualIsAvailable: boolean;
  reservedStockQuantity: number;
  recommendationSortOrder: number | null;
  variants: MenuItemVariantDto[];
  category: MenuCategoryDto;
  receiptInfo: MenuReceiptInfoDto | null;
};
export type MenuItemPropertiesDto = {
  id: string;
  stringValue?: string;
  numberValue?: number;
  stringArrayValue?: string[];
  numberArrayValue?: number[];
};
export type MenuItemWeightInputDto = {
  value: number;
  units: WeightUnits;
};
export type MenuItemDimensionsInputDto = {
  widthCm: number;
  heightCm: number;
  lengthCm: number;
};
export type CreateMenuPhotoDto = {
  /** Original image */
  objectName: string;
  /** Dynamically compressed image */
  compressedObjectName: string;
  /** Compressed image 500x500 90% quality in WebP format */
  compressedObjectNameWebp500x500q90: string;
  /** Compressed image 500x500 70% quality in WebP format */
  compressedObjectNameWebp500x500q70: string;
  /** Compressed image 300x300 70% quality in WebP format */
  compressedObjectNameWebp300x300q70: string;
};
export type SetActiveVariationGroupDto = {
  id: string;
  activeVariationIds: string[];
};
export type SetMenuItemVariantDto = {
  id?: string;
  variationIds: string[];
  price?: number;
  oldPrice?: number | null;
  isActive: boolean;
  weight?: MenuItemWeightInputDto | null;
  dimensions?: MenuItemDimensionsInputDto | null;
  photos?: CreateMenuPhotoDto[];
};
export type CreateMenuItemDto = {
  menuItemId?: string;
  name: string;
  description?: string;
  price?: number | null;
  oldPrice?: number | null;
  isVariable?: boolean;
  categoryId: string;
  properties?: MenuItemPropertiesDto[];
  sortOrder?: number;
  isAvailable?: boolean;
  weight?: MenuItemWeightInputDto | null;
  dimensions?: MenuItemDimensionsInputDto | null;
  photos?: CreateMenuPhotoDto[];
  activeVariationGroups?: SetActiveVariationGroupDto[];
  variants?: SetMenuItemVariantDto[];
  receiptInfo?: MenuReceiptInfoDto;
};
export type UpdateMenuItemVariationDto = {
  id?: string;
  variationIds: string[];
  price?: number;
  oldPrice?: number | null;
  isActive: boolean;
  weight?: MenuItemWeightInputDto | null;
  dimensions?: MenuItemDimensionsInputDto | null;
  photos?: CreateMenuPhotoDto[];
  externalImageUrls?: string[];
};
export type UpdateMenuItemDto = {
  name?: string;
  description?: string;
  price?: number | null;
  oldPrice?: number | null;
  isVariable?: boolean;
  categoryId?: string;
  properties?: MenuItemPropertiesDto[];
  isAvailable?: boolean;
  weight?: MenuItemWeightInputDto | null;
  dimensions?: MenuItemDimensionsInputDto | null;
  photos?: CreateMenuPhotoDto[];
  activeVariationGroups?: SetActiveVariationGroupDto[];
  receiptInfo?: MenuReceiptInfoDto;
  status?: MenuItemStatusEnum;
  externalImageUrls?: string[];
  variants?: UpdateMenuItemVariationDto[];
};
export type UpdateItemStockEntryDto = {
  menuItemId: string;
  stockQuantity: number;
};
export type UpdateVariantStockEntryDto = {
  variantId: string;
  stockQuantity: number;
};
export type UpdateStockDto = {
  items?: UpdateItemStockEntryDto[];
  variants?: UpdateVariantStockEntryDto[];
};
export type NewMenuItemSortOrderDto = {
  id: string;
  sortOrder: number;
};
export type ReorderMenuItemsDto = {
  newSortOrders: NewMenuItemSortOrderDto[];
};
export type MenuItemRecommendationsDto = {
  recommendationsEnabled: boolean;
  items: MenuItemDto[];
};
export type UploadedMenuPhotoInfoDto = {
  bucketName: string;
  objectName: string;
  url: string;
  sizeBytes: number;
  mimetype: string;
};
export type UploadedMenuPhotoDto = {
  original: UploadedMenuPhotoInfoDto;
  compressed: UploadedMenuPhotoInfoDto;
  compressedWebp500x500q90: UploadedMenuPhotoInfoDto;
  compressedWebp500x500q70: UploadedMenuPhotoInfoDto;
  compressedWebp300x300q70: UploadedMenuPhotoInfoDto;
};
export type UploadMenuPhotosDto = {
  /** JSON array of photo metadata */
  photos: string;
  images: Blob[];
};
export type SetMenuItemRecommendationsDto = {
  menuItemIds: string[];
};
export type ReorderMenuItemRecommendationDto = {
  menuItemId: string;
  sortOrder: number;
};
export type ReorderMenuItemRecommendationsDto = {
  newSortOrders: ReorderMenuItemRecommendationDto[];
};
export type SetOnlinePaymentReceiptInfoDto = {
  taxSystemCode: OnlinePaymentTaxSystemCode;
  paymentMode: OnlinePaymentMode;
  vatCode: OnlinePaymentVatCode;
  paymentSubject: OnlinePaymentSubject;
};
export type CreateOnlinePaymentDto = {
  shopId: string;
  secretKey: string;
  name: string;
  provider?: OnlinePaymentProviderEnum;
  sendReceipts?: boolean;
  sendReceiptsByEmail?: boolean;
  receiptInfo?: SetOnlinePaymentReceiptInfoDto | null;
};
export type UpdateOnlinePaymentDto = {
  shopId?: string;
  secretKey?: string;
  name?: string;
  provider?: OnlinePaymentProviderEnum;
  sendReceipts?: boolean;
  sendReceiptsByEmail?: boolean;
  receiptInfo?: SetOnlinePaymentReceiptInfoDto | null;
};
export type ManagementOrderDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  webApp: WebAppEnum;
  locationId: string;
  deliveryZoneId: string | null;
  orderedItems: ArchivedMenuItemDto[];
  totalPrice: number;
  deliveryPrice: number;
  totalDiscount: number | null;
  totalBonusDiscount: number;
  baseBonusDiscount: number;
  bonuses: number;
  spentBonuses: number;
  status: OrderStatus;
  customerContact: string;
  emailForReceipts: string | null;
  customerName: string;
  anotherCustomerContact: string | null;
  anotherCustomerName: string | null;
  isForAnotherPerson: boolean;
  customerDeliveryCoordinates: LocationPointDto | null;
  areDeliveryCoordinatesManual: boolean;
  serviceType: ServiceTypeEnum;
  paymentType: PaymentTypeEnum;
  deliveryType: DeliveryTypeEnum | null;
  orderNumber: string;
  customerTelegramUsername: string | null;
  clientAuthIdentities: OrderClientAuthIdentityDto[];
  clientVerifiedEmail: string | null;
  commentary: string | null;
  date: string | null;
  confirmationUrl: string | null;
  receiptUrl: string | null;
  onlinePaymentStatus: OrderOnlinePaymentStatusEnum;
  location: ArchivedLocationDto;
  cutleryQuantity?: number | null;
  currency: ChainCurrencyEnum;
  leaveAtDoor: boolean;
  eatAtPlace: boolean;
  noCallIsNeeded: boolean;
  address: OrderDeliveryAddressDto;
  orderPoint: ArchivedOrderPointDto | null;
  promocode: ArchivedPromocodeDto | null;
  iikoSyncStatus: OrderIikoSyncStatusEnum | null;
  managementCommentary: string | null;
  isCreatedWithStocks: boolean;
};
export type DelayedOrderCountDto = {
  /** The number of new delayed orders */
  new: number;
  /** The number of accepted delayed orders */
  accepted: number;
};
export type OrdersCountDto = {
  /** Total orders count */
  total: number;
  /** Not delayed active orders (not cancelled or finished) */
  active: number;
  /** The counters of delayed orders */
  delayed: DelayedOrderCountDto;
};
export type UpdateOrderDeliveryInfoDto = {
  /** Unique identifier of the delivery zone */
  deliveryZoneId?: string;
  point: PointInputDto;
  areManualCoordinates?: boolean;
};
export type UpdateOrderDeliveryAddressInfoDto = {
  address?: string;
  street?: string;
  city?: string;
  house?: string;
  entranceway?: string;
  floor?: string;
  apartment?: string;
  intercom?: string;
};
export type UpdateOrderDto = {
  orderedItems?: CreateOrderItemDto[];
  webApp?: WebAppEnum;
  leaveAtDoor?: boolean;
  eatAtPlace?: boolean;
  noCallIsNeeded?: boolean;
  paymentType?: PaymentTypeEnum;
  subscribeToMailings?: boolean;
  channel?: Channel;
  utmCampaignId?: string | null;
  serviceType?: ServiceTypeEnum;
  deliveryType?: DeliveryTypeEnum;
  /** Unique identifier of the location */
  locationId?: string;
  deliveryInfo?: UpdateOrderDeliveryInfoDto;
  deliveryAddressInfo?: UpdateOrderDeliveryAddressInfoDto;
  date?: string | null;
  commentary?: string;
  managementCommentary?: string;
  orderPointInfo?: OrderPointInfoDto;
};
export type UpdateStatusDto = {
  status: OrderStatus;
};
export type ManagementOptimalDeliveryZoneDto = {
  deliveryZone: LocationDeliveryZoneDto;
  deliveryPrice: number;
  commentsEnabled: boolean;
  availablePaymentTypes: PaymentTypeEnum[];
  orderOnTimeEnabled: boolean;
  averageCookingTime: number;
  location: ManagementLocationDto;
};
export type ManagementNationwideInfoDto = {
  deliveryPrice: number;
  location: ManagementLocationDto;
};
export type ManagementOptimalDeliveryZoneInfoDto = {
  mergedSchedule: LocationScheduleDto;
  deliveryZone: ManagementOptimalDeliveryZoneDto | null;
  nationwideInfo: ManagementNationwideInfoDto | null;
};
export type GetBonusInfoForOrderUpdateDto = {
  orderedItems: CreateOrderItemDto[];
};
export type StaffMemberDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  /** Provider login of the staff member */
  username: string;
  /** Telegram username of the staff member */
  telegramUsername: string;
  usernameProvider: StaffMemberUsernameProvider;
  /** Role of the staff member */
  role: StaffRoleEnum;
  name: string;
  phoneNumber: string | null;
  photoUrl: string | null;
  telegramPhotoUrl: string | null;
  maxPhotoUrl: string | null;
  status: StaffMemberStatusEnum;
  jobPosition: string | null;
};
export type CreateStaffMemberDto = {
  telegramUsername?: string;
  /** Provider login or verified email of the staff member */
  username?: string;
  usernameProvider?: StaffMemberUsernameProvider;
  role: StaffRoleEnum;
  name: string;
  phoneNumber?: string | null;
  jobPosition?: string | null;
};
export type UpdateStaffMemberDto = {
  role?: StaffRoleEnum;
  name?: string;
  phoneNumber?: string | null;
  jobPosition?: string | null;
  photoUrl?: string;
  status?: StaffMemberStatusEnum;
};
export type LegalDocumentDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  type: LegalDocumentEnum;
  url: string;
  version: LegalDocumentVersionDto;
};
export type ManagementLegalDocumentsDto = {
  privacyPolicyForManagers: LegalDocumentDto | null;
  termsOfUseForManagers: LegalDocumentDto | null;
  consentToPersonalDataProcessingForManagers: LegalDocumentDto | null;
  instructionForCustomerDataProcessingForOwners: LegalDocumentDto | null;
  templatePrivacyPolicyForCustomersRussia: LegalDocumentDto | null;
  templateConsentToPersonalDataProcessingForCustomersRussia: LegalDocumentDto | null;
  templateTermsOfUseForCustomersRussia: LegalDocumentDto | null;
  templatePrivacyPolicyForCustomersMontenegro: LegalDocumentDto | null;
  templateConsentToPersonalDataProcessingForCustomersMontenegro: LegalDocumentDto | null;
  templateTermsOfUseForCustomersMontenegro: LegalDocumentDto | null;
};
export type ClientStatsDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  clientId: string;
  telegramId: string;
  telegramUsername: string | null;
  telegramPhotoUrl: string | null;
  maxUsername: string | null;
  maxPhotoUrl: string | null;
  totalOrdersSum: number;
  totalOrdersCount: number;
  lastOrderDate: string;
  registrationDate: string;
  phoneNumber: string;
  verifiedEmail: string | null;
  name: string;
  spentBonuses: number;
  bonusBalance: number;
  authIdentities: ClientProfileAuthIdentityDto[];
};
export type GetClientStatsDto = {
  searchBy?: string;
  limit?: number;
  cursor?: string;
};
export type RevenueStatsPeriodDto = {
  type: RevenueStatsPeriodEnum;
  from: string;
  to: string;
};
export type RevenueStatsTotalsDto = {
  revenue: number;
  ordersCount: number;
  averageBill: number;
  uniqueCustomers: number;
};
export type RevenueStatsSeriesEntryDto = {
  date: string;
  revenue: number;
  ordersCount: number;
};
export type RevenueStatsTopItemVariantDto = {
  id: string;
  name: string;
  revenue: number;
  ordersCount: number;
  isArchived: boolean;
};
export type RevenueStatsTopItemDto = {
  id: string;
  name: string;
  photoUrl: string | null;
  revenue: number;
  ordersCount: number;
  isArchived: boolean;
  variants: RevenueStatsTopItemVariantDto[] | null;
};
export type RevenueStatsDto = {
  period: RevenueStatsPeriodDto;
  currency: ChainCurrencyEnum;
  totals: RevenueStatsTotalsDto;
  series: RevenueStatsSeriesEntryDto[];
  topItemsByRevenue: RevenueStatsTopItemDto[];
  topItemsByOrdersCount: RevenueStatsTopItemDto[];
};
export type GetRevenueStatsDto = {
  period: RevenueStatsPeriodEnum;
  /** Caller's local-time UTC offset in minutes; all day boundaries are computed in this offset. */
  tzOffsetMinutes: number;
};
export type PeriodDto = {
  from: string;
  to: string;
};
export type EventCountsDto = {
  catalogOpened: number;
  cartItemAdded: number;
  cartOpened: number;
  orderCreated: number;
  orderPaid: number;
  userAuthorized: number;
};
export type DetailedEventCountDto = {
  type: EventTypeEnum;
  platform: WebAppEnum;
  channel: EventChannelEnum;
  source: string | null;
  count: number;
};
export type ConversionDto = {
  orderPaidPerCatalogOpened: number;
};
export type AuthenticatedUsersByProviderDto = {
  telegram: number;
  max: number;
  google: number;
  yandex: number;
  vk: number;
};
export type EventsStatsResponseDto = {
  period: PeriodDto;
  events: EventCountsDto;
  detailed: DetailedEventCountDto[];
  conversion: ConversionDto;
  guestSessionsCount: number;
  authenticatedUsersCount: number;
  authenticatedUsersByProvider: AuthenticatedUsersByProviderDto;
};
export type EventsStatsRequestDto = {
  period: EventsStatsPeriodEnum;
};
export type ManagementChainSubscriptionMetadataDto = {
  id: string;
  level: ChainSubscriptionLevelEnum;
  duration: ChainSubscriptionDurationEnum;
  price: number;
  nextPaymentPrice: number;
  nextPaymentDate: string;
};
export type SubscribePremiumDto = {
  duration: ChainSubscriptionDurationEnum;
  promocode?: string;
};
export type UpdatePremiumChainSubscriptionDto = {
  isAutoRenewalActive?: boolean;
};
export type ChainSubscriptionPromocodeDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  code: string;
  subscriptionDuration: ChainSubscriptionDurationEnum;
  type: ChainSubscriptionPromocodeEnum;
  expirationDate: string;
  discount: number;
  maxCharges: number;
  currentCharges: number;
  isActive: boolean;
  isUsed: boolean;
  oldSubscriptionPrice: number;
  newSubscriptionPrice: number;
  endDate: string;
};
export type ChainSubscriptionHistoryDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  subscriptionDuration: ChainSubscriptionDurationEnum;
  newSubscriptionRenewDate: string | null;
  promocode: string | null;
  subscriptionDurationLength: number;
  paymentCreatedAt: string;
  paymentPrice: number;
  paymentStatus: ChainSubscriptionPaymentStatusEnum;
  isPaymentAuto: boolean;
  paymentReceiptStatus: ChainSubscriptionReceiptStatusEnum | null;
  paymentReceiptUrl: string | null;
};
export type PromocodeDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  isActivated: boolean;
  isActive: boolean;
  name: string;
  type: PromocodeType;
  code: string;
  discount: number;
  validityPeriod: PromocodeValidityPeriodDto | null;
  currentUses: number;
  telegramCurrentUses: number;
  maxCurrentUses: number;
  webCurrentUses: number;
  telegramNumRedirects: string;
  maxNumRedirects: string;
  webNumRedirects: string;
  maxUses: number | null;
  maxUsesPerUser: number | null;
  minOrdersSum: number | null;
  qrCodeImageUrl: string | null;
  telegramQRCodeImageUrl: string | null;
  maxQRCodeImageUrl: string | null;
  webQRCodeImageUrl: string | null;
  url: string;
  telegramUrl: string | null;
  maxUrl: string | null;
  webUrl: string | null;
};
export type CreatePromocodeValidityPeriodDto = {
  begin: string;
  end: string;
};
export type CreatePromocodeDto = {
  isActivated: boolean;
  name: string;
  type: PromocodeType;
  code: string;
  discount?: number | null;
  validityPeriod?: CreatePromocodeValidityPeriodDto | null;
  maxUses?: number | null;
  maxUsesPerUser?: number | null;
  minOrderSum?: number | null;
};
export type UpdatePromocodeDto = {
  isActivated?: boolean;
  name?: string;
  validityPeriod?: CreatePromocodeValidityPeriodDto | null;
  maxUses?: number | null;
  maxUsesPerUser?: number | null;
  minOrderSum?: number | null;
};
export type UpdateManagementProfileDto = {
  languageCode?: UserLanguageCode;
};
export type MailingPhotoDto = {
  objectName: string;
  displayName: string;
  bucketName: string;
};
export type MailingProgressDto = {
  usersReached: number;
  usersFailed: number;
};
export type MailingStatsDto = {
  totalUsers: number;
  sendingTimeSeconds: number;
};
export type MailingDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  text: string;
  mailingDate: string | null;
  status: MailingStatusEnum;
  sentAt: string | null;
  photo: MailingPhotoDto | null;
  progress: MailingProgressDto | null;
  stats: MailingStatsDto | null;
};
export type MailingCountDto = {
  total: number;
  draft: number;
  scheduled: number;
  sent: number;
};
export type SetMailingPhotoDto = {
  objectName: string;
  displayName: string;
};
export type UpdateMailingDto = {
  name?: string;
  text?: string;
  mailingDate?: string | null;
  photo?: SetMailingPhotoDto | null;
};
export type ExtendedMailingDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  text: string;
  mailingDate: string | null;
  status: MailingStatusEnum;
  sentAt: string | null;
  photo: MailingPhotoDto | null;
  progress: MailingProgressDto | null;
  stats: MailingStatsDto;
};
export type CreateMailingDto = {
  id?: string;
  name: string;
  text: string;
  mailingDate?: string | null;
  photo?: SetMailingPhotoDto | null;
};
export type UploadedMailingPhotoDto = {
  mailingId: string;
  compressedPhoto: MinioBufferInfoDto;
};
export type UploadMailingPhotoDto = {
  id?: string;
  image: Blob;
};
export type ReservationsCountDto = {
  active: number;
  archived: number;
  total: number;
};
export type ManagementAccountLinkVerificationCodeDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  expiresAt: string;
  code: string;
};
export type ManagementLinkAccontDto = {
  code: string;
};
export type RestoplaceWebhookReserveEventDto = {
  event: RestoplaceWebhookReserveEventEnum;
  id: number;
  userid: number;
  created: string;
  last_updated?: string;
  reserve_id: number;
  time_from: string;
  time_to: string;
  name: string;
  count: number;
  phone: string;
  email: string;
  tg_username?: string;
  text: string;
  status: RestoplaceReserveStatusEnum;
  success: number;
  is_fast: number;
  source: string;
  depositPriceDesired: number;
  depositPrice: number;
  depositPaid: RestoplaceDepositPaidEnum;
  depositOnline: number;
  item_ids: string[];
  item_type: string;
  floor_id: number;
  floor_name: string;
};
export enum UserLanguageCode {
  Ru = "ru",
  En = "en",
  Ar = "ar",
}
export enum TokenType {
  Bearer = "Bearer",
}
export enum GlobalUserAuthProvider {
  Telegram = "telegram",
  Max = "max",
  Google = "google",
  Yandex = "yandex",
  Vk = "vk",
}
export enum Channel {
  Organic = "organic",
  Utm = "utm",
  Promo = "promo",
  Multi = "multi",
}
export enum AdvertisingBannerStatusEnum {
  Active = "active",
  Archived = "archived",
}
export enum ChainCurrencyEnum {
  Rub = "RUB",
  Usd = "USD",
  Eur = "EUR",
  Aed = "AED",
  Azn = "AZN",
  Amd = "AMD",
  Byn = "BYN",
  Kzt = "KZT",
  Kgs = "KGS",
  Mdl = "MDL",
  Tjs = "TJS",
  Tmt = "TMT",
  Uzs = "UZS",
  Gbp = "GBP",
  Cny = "CNY",
  Try = "TRY",
  Chf = "CHF",
  Jpy = "JPY",
}
export enum ChainThemeStyle {
  Base = "base",
  Minimalism = "minimalism",
}
export enum ChainThemeEnum {
  Light = "light",
  Dark = "dark",
}
export enum ItemPhotoTypeEnum {
  Square = "square",
  Portrait = "portrait",
}
export enum Type {
  CatalogOpened = "catalog_opened",
  CartItemAdded = "cart_item_added",
  CartOpened = "cart_opened",
}
export enum Platform {
  Telegram = "telegram",
  Max = "max",
  Web = "web",
}
export enum LocationDeliveryZoneStatusEnum {
  Active = "active",
  Inactive = "inactive",
}
export enum PaymentTypeEnum {
  ByCard = "by_card",
  ByCash = "by_cash",
  Online = "online",
}
export enum LocationStatusEnum {
  Active = "active",
  Inactive = "inactive",
}
export enum LocationOrderPeriodEnum {
  Day = "day",
  Week = "week",
  Month = "month",
  Year = "year",
}
export enum OnlinePaymentProviderEnum {
  Yookassa = "yookassa",
  Tbank = "tbank",
}
export enum ServiceTypeEnum {
  Delivery = "delivery",
  Takeout = "takeout",
  OrderPoint = "order_point",
}
export enum OrderPointType {
  Cdek = "cdek",
}
export enum OrderPointPVZType {
  Pvz = "pvz",
  Postamat = "postamat",
}
export enum CountryCode {
  Af = "AF",
  Ax = "AX",
  Al = "AL",
  Dz = "DZ",
  As = "AS",
  Ad = "AD",
  Ao = "AO",
  Ai = "AI",
  Aq = "AQ",
  Ag = "AG",
  Ar = "AR",
  Am = "AM",
  Aw = "AW",
  Au = "AU",
  At = "AT",
  Az = "AZ",
  Bs = "BS",
  Bh = "BH",
  Bd = "BD",
  Bb = "BB",
  By = "BY",
  Be = "BE",
  Bz = "BZ",
  Bj = "BJ",
  Bm = "BM",
  Bt = "BT",
  Bo = "BO",
  Bq = "BQ",
  Ba = "BA",
  Bw = "BW",
  Bv = "BV",
  Br = "BR",
  Io = "IO",
  Bn = "BN",
  Bg = "BG",
  Bf = "BF",
  Bi = "BI",
  Cv = "CV",
  Kh = "KH",
  Cm = "CM",
  Ca = "CA",
  Ky = "KY",
  Cf = "CF",
  Td = "TD",
  Cl = "CL",
  Cn = "CN",
  Cx = "CX",
  Cc = "CC",
  Co = "CO",
  Km = "KM",
  Cg = "CG",
  Cd = "CD",
  Ck = "CK",
  Cr = "CR",
  Ci = "CI",
  Hr = "HR",
  Cu = "CU",
  Cw = "CW",
  Cy = "CY",
  Cz = "CZ",
  Dk = "DK",
  Dj = "DJ",
  Dm = "DM",
  Do = "DO",
  Ec = "EC",
  Eg = "EG",
  Sv = "SV",
  Gq = "GQ",
  Er = "ER",
  Ee = "EE",
  Sz = "SZ",
  Et = "ET",
  Fk = "FK",
  Fo = "FO",
  Fj = "FJ",
  Fi = "FI",
  Fr = "FR",
  Gf = "GF",
  Pf = "PF",
  Tf = "TF",
  Ga = "GA",
  Gm = "GM",
  Ge = "GE",
  De = "DE",
  Gh = "GH",
  Gi = "GI",
  Gr = "GR",
  Gl = "GL",
  Gd = "GD",
  Gp = "GP",
  Gu = "GU",
  Gt = "GT",
  Gg = "GG",
  Gn = "GN",
  Gw = "GW",
  Gy = "GY",
  Ht = "HT",
  Hm = "HM",
  Va = "VA",
  Hn = "HN",
  Hk = "HK",
  Hu = "HU",
  Is = "IS",
  In = "IN",
  Id = "ID",
  Ir = "IR",
  Iq = "IQ",
  Ie = "IE",
  Im = "IM",
  Il = "IL",
  It = "IT",
  Jm = "JM",
  Jp = "JP",
  Je = "JE",
  Jo = "JO",
  Kz = "KZ",
  Ke = "KE",
  Ki = "KI",
  Kp = "KP",
  Kr = "KR",
  Kw = "KW",
  Kg = "KG",
  La = "LA",
  Lv = "LV",
  Lb = "LB",
  Ls = "LS",
  Lr = "LR",
  Ly = "LY",
  Li = "LI",
  Lt = "LT",
  Lu = "LU",
  Mo = "MO",
  Mg = "MG",
  Mw = "MW",
  My = "MY",
  Mv = "MV",
  Ml = "ML",
  Mt = "MT",
  Mh = "MH",
  Mq = "MQ",
  Mr = "MR",
  Mu = "MU",
  Yt = "YT",
  Mx = "MX",
  Fm = "FM",
  Md = "MD",
  Mc = "MC",
  Mn = "MN",
  Me = "ME",
  Ms = "MS",
  Ma = "MA",
  Mz = "MZ",
  Mm = "MM",
  Na = "NA",
  Nr = "NR",
  Np = "NP",
  Nl = "NL",
  Nc = "NC",
  Nz = "NZ",
  Ni = "NI",
  Ne = "NE",
  Ng = "NG",
  Nu = "NU",
  Nf = "NF",
  Mk = "MK",
  Mp = "MP",
  No = "NO",
  Om = "OM",
  Pk = "PK",
  Pw = "PW",
  Ps = "PS",
  Pa = "PA",
  Pg = "PG",
  Py = "PY",
  Pe = "PE",
  Ph = "PH",
  Pn = "PN",
  Pl = "PL",
  Pt = "PT",
  Pr = "PR",
  Qa = "QA",
  Re = "RE",
  Ro = "RO",
  Ru = "RU",
  Rw = "RW",
  Bl = "BL",
  Sh = "SH",
  Kn = "KN",
  Lc = "LC",
  Mf = "MF",
  Pm = "PM",
  Vc = "VC",
  Ws = "WS",
  Sm = "SM",
  St = "ST",
  Sa = "SA",
  Sn = "SN",
  Rs = "RS",
  Sc = "SC",
  Sl = "SL",
  Sg = "SG",
  Sx = "SX",
  Sk = "SK",
  Si = "SI",
  Sb = "SB",
  So = "SO",
  Za = "ZA",
  Gs = "GS",
  Ss = "SS",
  Es = "ES",
  Lk = "LK",
  Sd = "SD",
  Sr = "SR",
  Sj = "SJ",
  Se = "SE",
  Ch = "CH",
  Sy = "SY",
  Tw = "TW",
  Tj = "TJ",
  Tz = "TZ",
  Th = "TH",
  Tl = "TL",
  Tg = "TG",
  Tk = "TK",
  To = "TO",
  Tt = "TT",
  Tn = "TN",
  Tr = "TR",
  Tm = "TM",
  Tc = "TC",
  Tv = "TV",
  Ug = "UG",
  Ua = "UA",
  Ae = "AE",
  Gb = "GB",
  Us = "US",
  Um = "UM",
  Uy = "UY",
  Uz = "UZ",
  Vu = "VU",
  Ve = "VE",
  Vn = "VN",
  Vg = "VG",
  Vi = "VI",
  Wf = "WF",
  Eh = "EH",
  Ye = "YE",
  Zm = "ZM",
  Zw = "ZW",
}
export enum MenuExternalSourceEnum {
  Iiko = "iiko",
  Wildberries = "wildberries",
}
export enum WeightUnits {
  Kilogram = "kilogram",
  Gram = "gram",
}
export enum WebAppEnum {
  Telegram = "telegram",
  Max = "max",
  Web = "web",
}
export enum OrderStatus {
  New = "new",
  Confirmed = "confirmed",
  Preparing = "preparing",
  ReadyToDeliver = "ready to deliver",
  ReadyToTakeout = "ready to takeout",
  Delivering = "delivering",
  Delivered = "delivered",
  Cancelled = "cancelled",
}
export enum DeliveryTypeEnum {
  Citywide = "citywide",
  Nationwide = "nationwide",
}
export enum OrderOnlinePaymentStatusEnum {
  None = "none",
  Waiting = "waiting",
  Succeeded = "succeeded",
  Canceled = "canceled",
}
export enum PromocodeType {
  OrderDiscountFixed = "order_discount_fixed",
  OrderDiscountPercent = "order_discount_percent",
  OrderFreeDelivery = "order_free_delivery",
}
export enum ChainGeneratedLegalDocumentEnum {
  PrivacyPolicyRu = "privacy_policy_ru",
  ConsentToPersonalDataProcessingRu = "consent_to_personal_data_processing_ru",
  TermsOfUseRu = "terms_of_use_ru",
  PrivacyPolicyMe = "privacy_policy_me",
  ConsentToPersonalDataProcessingMe = "consent_to_personal_data_processing_me",
  TermsOfUseMe = "terms_of_use_me",
}
export enum ReservationStatusEnum {
  New = "new",
  Approved = "approved",
  Processing = "processing",
  Canceled = "canceled",
  CancelledDeposit = "cancelled_deposit",
  Completed = "completed",
}
export enum ReservationPaymentStatusEnum {
  Waiting = "waiting",
  Failed = "failed",
  Success = "success",
}
export enum EmailVerificationWebApp {
  Telegram = "telegram",
  Web = "web",
}
export enum Type2 {
  Utm = "utm",
  Promo = "promo",
}
export enum WebApp {
  Telegram = "telegram",
  Max = "max",
  Web = "web",
}
export enum LinkTypeEnum {
  Utm = "utm",
  Promocode = "promocode",
}
export enum ChainStatusEnum {
  Active = "active",
  Inactive = "inactive",
  Suspended = "suspended",
}
export enum StaffRoleEnum {
  Owner = "owner",
  Admin = "admin",
  Staff = "staff",
}
export enum OnlinePaymentVatCode {
  $1 = 1,
  $2 = 2,
  $3 = 3,
  $4 = 4,
  $5 = 5,
  $6 = 6,
  $7 = 7,
  $8 = 8,
  $9 = 9,
  $10 = 10,
}
export enum OnlinePaymentSubject {
  Commodity = "commodity",
  Excise = "excise",
  Service = "service",
  Payment = "payment",
  Another = "another",
}
export enum ChainLegalInfoEnum {
  Russia = "russia",
  Montenegro = "montenegro",
}
export enum ChainSubscriptionDurationEnum {
  Month = "month",
  Year = "year",
}
export enum ChainSubcriptionLevelEnum {
  Premium = "premium",
  Trial = "trial",
}
export enum ChainSubscriptionPaymentStatusEnum {
  Pending = "pending",
  Succeeded = "succeeded",
  Canceled = "canceled",
}
export enum ChainPaymentMethodType {
  SberLoan = "sber_loan",
  Alfabank = "alfabank",
  MobileBalance = "mobile_balance",
  BankCard = "bank_card",
  Installments = "installments",
  Cash = "cash",
  SberBnpl = "sber_bnpl",
  Sbp = "sbp",
  B2BSberbank = "b2b_sberbank",
  ElectronicCertificate = "electronic_certificate",
  YooMoney = "yoo_money",
  ApplePay = "apple_pay",
  GooglePay = "google_pay",
  Qiwi = "qiwi",
  Sberbank = "sberbank",
  Tbank = "tbank",
  Wechat = "wechat",
  Webmoney = "webmoney",
}
export enum ChainPaymentMethodUpdateStatusEnum {
  Pending = "pending",
  Successful = "successful",
  Failed = "failed",
}
export enum IntegrationTypeEnum {
  Iiko = "iiko",
  Cdek = "cdek",
  ReservationByUrl = "reservation_by_url",
  Restoplace = "restoplace",
  Wildberries = "wildberries",
  WildberriesSellerAnalytics = "wildberries_seller_analytics",
}
export enum IikoMenuSyncInterval {
  Manually = "manually",
  Daily = "daily",
  Weekly = "weekly",
  Monthly = "monthly",
}
export enum OnlinePaymentTaxSystemCode {
  $1 = 1,
  $2 = 2,
  $3 = 3,
  $4 = 4,
  $5 = 5,
  $6 = 6,
}
export enum OnlinePaymentMode {
  FullPayment = "full_payment",
  FullPrepayment = "full_prepayment",
}
export enum LocationType {
  Door = "door",
  Warehouse = "warehouse",
  Postamat = "postamat",
}
export enum MenuCategoryStatus {
  Active = "active",
  Hidden = "hidden",
}
export enum MenuPropertyType {
  String = "string",
  Number = "number",
  Enum = "enum",
}
export enum MenuItemStatusEnum {
  Active = "active",
  Inactive = "inactive",
}
export enum OrderIikoSyncStatusEnum {
  Success = "Success",
  InProgress = "InProgress",
  Error = "Error",
}
export enum DelayedOrdersSectionEnum {
  New = "new",
  Accepted = "accepted",
}
export enum StaffMemberUsernameProvider {
  Telegram = "telegram",
  Max = "max",
  Google = "google",
  Yandex = "yandex",
  Vk = "vk",
  Email = "email",
}
export enum StaffMemberStatusEnum {
  Active = "active",
  Inactive = "inactive",
}
export enum LegalDocumentEnum {
  PrivacyPolicyForManagers = "privacy_policy_for_managers",
  TermsOfUseForManagers = "terms_of_use_for_managers",
  ConsentToPersonalDataProcessingForManagers = "consent_to_personal_data_processing_for_managers",
  InstructionForCustomerDataProcessingForOwners = "instruction_for_customer_data_processing_for_owners",
  TemplatePrivacyPolicyCustomersRu = "template_privacy_policy_customers_ru",
  TemplateConsentToPersonalDataProcessingCustomersRu = "template_consent_to_personal_data_processing_customers_ru",
  TemplateTermsOfUseCustomersRu = "template_terms_of_use_customers_ru",
  TemplatePrivacyPolicyCustomersMe = "template_privacy_policy_customers_me",
  TemplateConsentToPersonalDataProcessingCustomersMe = "template_consent_to_personal_data_processing_customers_me",
  TemplateTermsOfUseCustomersMe = "template_terms_of_use_customers_me",
}
export enum RevenueStatsPeriodEnum {
  Day = "day",
  Week = "week",
  Month = "month",
  PreviousMonth = "previous_month",
  ThreeMonths = "three_months",
  SixMonths = "six_months",
}
export enum EventTypeEnum {
  CatalogOpened = "catalog_opened",
  CartItemAdded = "cart_item_added",
  CartOpened = "cart_opened",
  OrderCreated = "order_created",
  OrderPaid = "order_paid",
  UserAuthorized = "user_authorized",
}
export enum EventChannelEnum {
  Organic = "organic",
  Utm = "utm",
  Promo = "promo",
  Multi = "multi",
}
export enum EventsStatsPeriodEnum {
  Day = "day",
  Week = "week",
  Month = "month",
  PreviousMonth = "previous_month",
  ThreeMonths = "three_months",
  SixMonths = "six_months",
}
export enum ChainSubscriptionLevelEnum {
  Premium = "premium",
  Trial = "trial",
}
export enum ChainSubscriptionPromocodeEnum {
  Discount = "discount",
  Free = "free",
}
export enum ChainSubscriptionReceiptStatusEnum {
  Pending = "pending",
  Succeeded = "succeeded",
  Canceled = "canceled",
  Scheduled = "scheduled",
}
export enum MailingStatusEnum {
  Draft = "draft",
  Scheduled = "scheduled",
  Preparing = "preparing",
  InProgress = "in_progress",
  Sent = "sent",
  Failed = "failed",
}
export enum RestoplaceWebhookReserveEventEnum {
  ReserveCreated = "reserve.created",
  ReserveUpdated = "reserve.updated",
}
export enum RestoplaceReserveStatusEnum {
  $1 = 1,
  $2 = 2,
  $3 = 3,
  $4 = 4,
  $5 = 5,
  $6 = 6,
  $8 = 8,
}
export enum RestoplaceDepositPaidEnum {
  $0 = 0,
  $1 = 1,
  $2 = 2,
}
export const {
  useClientAuthDeprecatedControllerLoginMutation,
  useClientTelegramAuthControllerLoginMutation,
  useClientTelegramAuthControllerWhoamiQuery,
  useClientMaxAuthControllerLoginMutation,
  useClientMaxAuthControllerWhoamiQuery,
  useClientTokenAuthControllerRefreshMutation,
  useClientTokenAuthControllerLogoutMutation,
  useClientOAuthControllerStartMutation,
  useClientOAuthControllerCallbackMutation,
  useClientMagicAuthControllerRequestMutation,
  useClientMagicAuthControllerVerifyMutation,
  useClientUserControllerUpdateMutation,
  useClientAdvertisingBannerControllerGetActiveBannersQuery,
  useClientChainControllerGetChainInformationQuery,
  useClientEventsControllerRecordMutation,
  useClientDeliveryControllerGetOptimalDeliveryZoneMutation,
  useClientLocationControllerGetAllLocationsQuery,
  useClientLocationControllerGetLocationQuery,
  useClientLocationControllerGetScheduleMutation,
  useClientLocationControllerFindClosestLocationMutation,
  useClientOrderPointControllerFindOrderPointsMutation,
  useClientOrderPointControllerCalculateDeliveryPriceMutation,
  useClientMenuItemCategoriesControllerGetAllMenuCategoriesQuery,
  useClientMenuItemsControllerGetAllMenuItemsQuery,
  useClientMenuItemsControllerGetMenuItemByIdQuery,
  useClientMenuItemsControllerGetAllRecommendationsQuery,
  useClientOrderControllerGetOrdersQuery,
  useClientOrderControllerGetOrderByIdQuery,
  useClientOrderControllerCreateTakeoutOrderMutation,
  useClientOrderControllerCreateCitywideDeliveryMutation,
  useClientOrderControllerCreateNationwideDeliveryMutation,
  useClientOrderControllerCreateOrderFromOrderPointMutation,
  useClientOrderControllerGetBonusInfoForOrderCreationMutation,
  useClientLegalControllerGetGeneratedDocumentsQuery,
  useClientLegalControllerAcceptDocumentsMutation,
  useClientReservationControllerGetReservationsQuery,
  useClientReservationControllerCreateReservationMutation,
  useClientReservationControllerGetTimeSlotsQuery,
  useClientReservationControllerGetTablesQuery,
  useClientReservationControllerGetTablesByIdsMutation,
  useClientReservationControllerCalculateDepositMutation,
  useClientPromocodeControllerExistsQuery,
  useClientPromocodeControllerFindMutation,
  useClientPromocodeControllerCalculateDiscountMutation,
  useClientProfileControllerGetProfileQuery,
  useClientProfileControllerUpdateProfileMutation,
  useEmailVerificationControllerRequestMutation,
  useEmailVerificationControllerVerifyMutation,
  useClientReservationByUrlIntegrationControllerGetIntegrationQuery,
  useClientCdekIntegrationControllerGetIntegrationQuery,
  useClientWildberriesIntegrationControllerExistsQuery,
  useClientWildberriesSellerAnalyticsControllerGetSellerInfoQuery,
  useClientAccoutLinkControllerGetActiveVeritificationCodeQuery,
  useClientAccoutLinkControllerReceiveVerificationCodeMutation,
  useClientAccoutLinkControllerLinkTelegramMutation,
  useClientAccoutLinkControllerLinkMaxMutation,
  useClientStartAppControllerHandleMutation,
  useManagementTelegramAuthDeprecatedControllerValidateInitDataMutation,
  useManagementTelegramBotDeprecatedControllerVerifyBotTokenMutation,
  useManagementTelegramAuthControllerLoginMutation,
  useManagementTelegramAuthControllerWhoamiQuery,
  useManagementMaxAuthControllerLoginMutation,
  useManagementMaxAuthControllerWhoamiQuery,
  useManagementTokenAuthControllerRefreshMutation,
  useManagementTokenAuthControllerLogoutMutation,
  useManagementOAuthControllerStartMutation,
  useManagementOAuthControllerCallbackMutation,
  useManagementMagicAuthControllerRequestMutation,
  useManagementMagicAuthControllerVerifyMutation,
  useManagementUserControllerUpdateMutation,
  useManagementAdvertisingBannerControllerGetBannersQuery,
  useManagementAdvertisingBannerControllerCreateBannerMutation,
  useManagementAdvertisingBannerControllerUploadPreviewPhotoMutation,
  useManagementAdvertisingBannerControllerGetBannerQuery,
  useManagementAdvertisingBannerControllerUpdateBannerMutation,
  useManagementAdvertisingBannerControllerDeleteBannerMutation,
  useManagementAdvertisingBannerControllerReorderBannersMutation,
  useManagementUtmCampaignControllerGetCampaignsQuery,
  useManagementUtmCampaignControllerCreateCampaignMutation,
  useManagementUtmCampaignControllerUpdateCampaignMutation,
  useManagementUtmCampaignControllerSoftDeleteCampaignMutation,
  useManagementLinkStatsControllerGetStatsMutation,
  useManagementChainsControllerMyChainsQuery,
  useManagementChainsControllerCreateMutation,
  useManagementChainsControllerUpdateChainMutation,
  useManagementChainsControllerUploadBrandLogoMutation,
  useManagementChainsControllerUploadBrandPhotoMutation,
  useManagementChainsControllerUploadBannerPhotoMutation,
  useManagementChainsControllerGetChainInformationQuery,
  useManagementChainsControllerUpdateChainInformationMutation,
  useChainLegalControllerGetGeneratedDocumentsQuery,
  useChainLegalControllerGetLegalInfoQuery,
  useChainLegalControllerSetLegalInfoMutation,
  useChainLegalControllerDeleteLegalInfoMutation,
  useChainPaymentControllerGetSavedPaymentMethodQuery,
  useChainPaymentControllerUpdatePaymentMethodMutation,
  useChainPaymentControllerGetLastPaymentMethodUpdateQuery,
  useManagementWildberriesSellerAnalyticsControllerCreateMutation,
  useManagementWildberriesSellerAnalyticsControllerUpdateMutation,
  useManagementWildberriesSellerAnalyticsControllerGetQuery,
  useManagementIntegrationControllerGetAllQuery,
  useManagementIntegrationControllerGetByIdQuery,
  useManagementIntegrationControllerDeleteByIdMutation,
  useManagementMenuSyncControllerSynciikoMenuMutation,
  useManagementMenuSyncControllerGetIikoSyncInfoQuery,
  useManagementIikoIntegrationControllerIntegrateIikoMutation,
  useManagementIikoIntegrationControllerUpdateIikoIntegrationMutation,
  useManagementCdekIntegrationControllerIntegrateCdekMutation,
  useManagementCdekIntegrationControllerUpdateCdekIntegrationMutation,
  useManagementReservationByUrlIntegrationControllerIntegrateMutation,
  useManagementReservationByUrlIntegrationControllerUpdateIntegrationMutation,
  useManagementRestoplaceIntegrationControllerIntegrateRestoplaceMutation,
  useManagementRestoplaceIntegrationControllerUpdateRestoplaceIntegrationMutation,
  useManagementWildberriesIntegrationControllerCreateIntegrationMutation,
  useManagementWildberriesIntegrationControllerUpdateIntegrationMutation,
  useManagementWildberriesIntegrationControllerGetImportableItemsQuery,
  useManagementWildberriesIntegrationControllerImportAllItemsMutation,
  useManagementLocationsControllerCreateMutation,
  useManagementLocationsControllerFindAllQuery,
  useManagementLocationsControllerFindOneQuery,
  useManagementLocationsControllerUpdateMutation,
  useManagementLocationsControllerGetScheduleMutation,
  useManagementLocationsControllerFindClosestLocationMutation,
  useManagementOrderPointControllerFindOrderPointsMutation,
  useManagementOrderPointControllerCalculateDeliveryPriceMutation,
  useManagementMenuCategoriesControllerCreateMutation,
  useManagementMenuCategoriesControllerFindAllQuery,
  useManagementMenuCategoriesControllerFindOneQuery,
  useManagementMenuCategoriesControllerUpdateMutation,
  useManagementMenuCategoriesControllerReorderMutation,
  useManagementMenuItemsControllerCreateMutation,
  useManagementMenuItemsControllerFindAllQuery,
  useManagementMenuItemsControllerFindOneQuery,
  useManagementMenuItemsControllerUpdateMutation,
  useManagementMenuItemsControllerSetStockMutation,
  useManagementMenuItemsControllerReorderMutation,
  useManagementMenuItemsControllerGetAllRecommendationsQuery,
  useManagementMenuItemsControllerUploadPhotosMutation,
  useManagementMenuItemsControllerSetRecommendationsMutation,
  useManagementMenuItemsControllerReorderRecommendationsMutation,
  useManagementOnlinePaymentsControllerGetOnlinePaymentsQuery,
  useManagementOnlinePaymentsControllerCreateOnlinePaymentMutation,
  useManagementOnlinePaymentsControllerUpdateOnlinePaymentMutation,
  useManagementOnlinePaymentsControllerDeleteOnlinePaymentMutation,
  useManagementOrdersControllerFindAllQuery,
  useManagementOrdersControllerGetOpenOrdersQuery,
  useManagementOrdersControllerGetDelayedOrdersQuery,
  useManagementOrdersControllerGetArchivedOrdersQuery,
  useManagementOrdersControllerCountOrdersQuery,
  useManagementOrdersControllerFindOneQuery,
  useManagementOrdersControllerUpdateOrderMutation,
  useManagementOrdersControllerUpdateStatusMutation,
  useManagementOrdersControllerGetOptimalDeliveryZonesMutation,
  useManagementOrdersControllerGetOrderUpdateBonusInfoMutation,
  useManagementStaffMembersControllerCreateMutation,
  useManagementStaffMembersControllerFindAllQuery,
  useManagementStaffMembersControllerGetMeQuery,
  useManagementStaffMembersControllerUpdateMutation,
  useManagementLegalControllerGetDocumentsQuery,
  useManagementLegalControllerAcceptDocumentsMutation,
  useManagementLegalControllerAcceptInstructionMutation,
  useManagementStatsControllerGetStatsByIdQuery,
  useManagementStatsControllerGetStatsMutation,
  useManagementRevenueStatsControllerStatsMutation,
  useManagementOrdersExportControllerExportOrdersQuery,
  useManagementOrdersExportControllerExportOrderItemsQuery,
  useManagementEventsStatsControllerStatsMutation,
  useManagementSubscriptionControllerGetSubscriptionQuery,
  useManagementSubscriptionControllerGetMetadataQuery,
  useManagementSubscriptionControllerSubscribeMutation,
  useManagementSubscriptionControllerUpdateMutation,
  useManagementSubscriptionPromocodeControllerGetPromocodeQuery,
  useManagementSubscriptionHistoryControllerGetHistoryQuery,
  useManagementPromocodesControllerGetAllQuery,
  useManagementPromocodesControllerCreateMutation,
  useManagementPromocodesControllerGetOneByIdQuery,
  useManagementPromocodesControllerUpdateMutation,
  useManagementPromocodesControllerDeleteMutation,
  useManagementPromocodesControllerCalculateDiscountMutation,
  useManagementProfileControllerGetProfileQuery,
  useManagementProfileControllerUpdateProfileMutation,
  useManagementMailingControllerGetDraftMailingsQuery,
  useManagementMailingControllerGetScheduledMailingsQuery,
  useManagementMailingControllerGetSentMailingsQuery,
  useManagementMailingControllerCountMailingsQuery,
  useManagementMailingControllerGetMailingByIdQuery,
  useManagementMailingControllerUpdateMailingByIdMutation,
  useManagementMailingControllerDeleteMailingByIdMutation,
  useManagementMailingControllerGetExtendedMailingByIdQuery,
  useManagementMailingControllerCreateMailingMutation,
  useManagementMailingControllerStartMailingMutation,
  useManagementMailingControllerUploadMailingPhotoMutation,
  useManagementReservationControllerGetActiveQuery,
  useManagementReservationControllerGetArchivedQuery,
  useManagementReservationControllerCountQuery,
  useManagementReservationControllerGetTablesByIdsMutation,
  useManagementAccountLinkControllerGetActiveVeritificationCodeQuery,
  useManagementAccountLinkControllerCreateVerificationCodeMutation,
  useManagementAccountLinkControllerLinkTelegramMutation,
  useManagementAccountLinkControllerLinkMaxMutation,
  useSharedHealthControllerCheckQuery,
  useSharedWebhooksControllerHandleIikoWebhookMutation,
  useSharedWebhooksControllerHandleRestoplaceWebhookMutation,
  useOAuthRedirectControllerClientCallbackQuery,
  useOAuthRedirectControllerManagementCallbackQuery,
  useDevLegalControllerUploadDocumentsMutation,
  useDevEventsControllerRunRollupMutation,
} = injectedRtkApi;
